webpackJsonp([1],{

/***/ "/0Ya":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0S7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0UW5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('section',{staticClass:"header"},[_c('div',{staticClass:"header-wrapper flexbox-wrapper"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"flex-item flex-item03"},[_c('span',{staticClass:"flex-item-content"},[_c('h1',[_vm._v(_vm._s(_vm.contextTitle))])])]),_vm._v(" "),_c('div',{staticClass:"flex-item flex-item04 ol-photon-geocoder",attrs:{"id":"search-box"}})])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"columns"},[_vm._m(2),_vm._v(" "),_c('aside',{staticClass:"sidebar-first",attrs:{"id":"sidebar-left"}},[_c('div',{staticClass:"main-level-wrapper"},[_c('div',{staticClass:"col_1"},[_c('div',{staticClass:"main-level poissons-block",on:{"mouseover":function($event){_vm.show_poissons = true; _vm.show_cours_eau = false;_vm.show_restauration_ecologique = false},"mouseleave":function($event){_vm.locked_cadenas ? _vm.show_poissons = true : _vm.show_poissons = false}}},[_c('div',{staticClass:"main-level-title",class:_vm.show_poissons ? 'like-hover' : ''},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"main-level cours-eau-block",on:{"mouseover":function($event){_vm.show_cours_eau = true; _vm.show_poissons = false; _vm.show_restauration_ecologique = false},"mouseleave":function($event){_vm.locked_cadenas ? _vm.show_cours_eau = true : _vm.show_cours_eau = false}}},[_c('div',{staticClass:"main-level-title",class:_vm.show_cours_eau ? 'like-hover' : ''},[_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"main-level actions-block",on:{"mouseover":function($event){_vm.show_restauration_ecologique = true; _vm.show_cours_eau = false; _vm.show_poissons = false},"mouseleave":function($event){_vm.locked_cadenas ? _vm.show_restauration_ecologique = true : _vm.show_restauration_ecologique = false}}},[_c('div',{staticClass:"main-level-title",class:_vm.show_restauration_ecologique ? 'like-hover' : ''},[_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"actions-wrapper"},[_c('div',{staticClass:"picto-wrapper",on:{"click":_vm.reInitializeLayers}},[_c('img',{attrs:{"src":"static/img/picto-reinitialiser.png"}}),_c('span',{staticClass:"infobulle"},[_vm._v("Réinitialiser la carte")])]),_vm._v(" "),_c('div',{staticClass:"picto-wrapper",on:{"click":_vm.handleClickControlPrint}},[_c('img',{attrs:{"src":"static/img/picto-print.png"}}),_c('span',{staticClass:"infobulle"},[_vm._v("Copier la carte")])]),_vm._v(" "),_c('div',{staticClass:"picto-wrapper",on:{"click":_vm.copyUrlToClipboard}},[_c('img',{attrs:{"src":"static/img/picto-lien.png"}}),_c('span',{staticClass:"infobulle"},[_vm._v("Partager la carte")])]),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('div',{staticClass:"sub-level-1-wrapper col_2"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_poissons),expression:"show_poissons"}],staticClass:"sub-level-1 poissons-popup",on:{"mouseover":function($event){_vm.show_poissons = true},"mouseleave":function($event){_vm.locked_cadenas ? _vm.show_poissons = true : _vm.show_poissons = false}}},[_c('div',{staticClass:"sub-level-1-defilable"},[_c('h2',[_vm._v("Poissons")]),_vm._v(" "),_c('div',{staticClass:"cadenas-wrapper",class:_vm.locked_cadenas ? 'cadenas-locked' : 'cadenas-unlocked',on:{"click":function($event){_vm.locked_cadenas = !_vm.locked_cadenas}}},[_c('img',{attrs:{"src":"static/img/picto-cadenas.png"}}),_c('span',{staticClass:"infobulle unlocked"},[_vm._v("Verrouiller le menu")]),_c('span',{staticClass:"infobulle locked"},[_vm._v("Déverrouiller le menu")])]),_vm._v(" "),_c('div',{attrs:{"id":"wrapper-all-species"}},[_c('div',{attrs:{"id":"all-species"}},_vm._l((_vm.especes),function(espece){return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_especes),expression:"selected_especes"}],attrs:{"id":'temps_' + espece.code.toLowerCase(),"type":"checkbox"},domProps:{"value":'temps_' + espece.code.toLowerCase(),"checked":Array.isArray(_vm.selected_especes)?_vm._i(_vm.selected_especes,'temps_' + espece.code.toLowerCase())>-1:(_vm.selected_especes)},on:{"change":function($event){var $$a=_vm.selected_especes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='temps_' + espece.code.toLowerCase(),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected_especes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected_especes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected_especes=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Répartition géographique","for":'temps_' + espece.code.toLowerCase()}},[_vm._v(_vm._s(espece.nom_commun))])])}),0)]),_vm._v(" "),_c('hr',{staticClass:"blue"}),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_stations_echantillonnage),expression:"checkboxes_left_menu.checked_stations_echantillonnage"}],attrs:{"type":"checkbox","id":"checkbox-stations-echantillonnage"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_stations_echantillonnage)?_vm._i(_vm.checkboxes_left_menu.checked_stations_echantillonnage,null)>-1:(_vm.checkboxes_left_menu.checked_stations_echantillonnage)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_stations_echantillonnage,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_stations_echantillonnage", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_stations_echantillonnage", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_stations_echantillonnage", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"like-h2",attrs:{"title":"Portion de rivière échantillonnée à l'électricité","for":"checkbox-stations-echantillonnage"}},[_vm._v("Stations d'échantillonnage")])]),_vm._v(" "),_c('hr',{staticClass:"blue"}),_vm._v(" "),_c('h2',[_vm._v("Analyse piscicole")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_richesse_specifique),expression:"checkboxes_left_menu.checked_richesse_specifique"}],attrs:{"type":"checkbox","id":"checkbox-richesse-specifique"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_richesse_specifique)?_vm._i(_vm.checkboxes_left_menu.checked_richesse_specifique,null)>-1:(_vm.checkboxes_left_menu.checked_richesse_specifique)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_richesse_specifique,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_richesse_specifique", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_richesse_specifique", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_richesse_specifique", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Nombre d'espèces par station d'échantillonnage","for":"checkbox-richesse-specifique"}},[_vm._v("Richesse spécifique")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_etat_ipr),expression:"checkboxes_left_menu.checked_etat_ipr"}],attrs:{"type":"checkbox","id":"checkbox-etat-ipr"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_etat_ipr)?_vm._i(_vm.checkboxes_left_menu.checked_etat_ipr,null)>-1:(_vm.checkboxes_left_menu.checked_etat_ipr)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_etat_ipr,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_etat_ipr", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_etat_ipr", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_etat_ipr", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Indicateur de la qualité des rivières basé sur l'état du peuplement piscicole","for":"checkbox-etat-ipr"}},[_vm._v("Indice poisson rivière (IPR)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_assemblage_pisci_ref),expression:"checkboxes_left_menu.checked_assemblage_pisci_ref"}],attrs:{"type":"checkbox","id":"checkbox-assemblage-pisci-ref"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_assemblage_pisci_ref)?_vm._i(_vm.checkboxes_left_menu.checked_assemblage_pisci_ref,null)>-1:(_vm.checkboxes_left_menu.checked_assemblage_pisci_ref)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_assemblage_pisci_ref,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_assemblage_pisci_ref", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_assemblage_pisci_ref", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_assemblage_pisci_ref", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Espèces présentes si aucune pression humaine","for":"checkbox-assemblage-pisci-ref"}},[_vm._v("Les assemblages piscicoles de référence")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_cours_eau),expression:"show_cours_eau"}],staticClass:"sub-level-1 cours-eau-popup",on:{"mouseover":function($event){_vm.show_cours_eau = true},"mouseleave":function($event){_vm.locked_cadenas ? _vm.show_cours_eau = true : _vm.show_cours_eau = false}}},[_c('div',{staticClass:"sub-level-1-defilable"},[_c('h2',[_vm._v("Qualité de l'eau - Etat des lieux 2019, AESN")]),_vm._v(" "),_c('div',{staticClass:"cadenas-wrapper",class:_vm.locked_cadenas ? 'cadenas-locked' : 'cadenas-unlocked',on:{"click":function($event){_vm.locked_cadenas = !_vm.locked_cadenas}}},[_c('img',{attrs:{"src":"static/img/picto-cadenas.png"}}),_c('span',{staticClass:"infobulle unlocked"},[_vm._v("Verrouiller le menu")]),_c('span',{staticClass:"infobulle locked"},[_vm._v("Déverrouiller le menu")])]),_vm._v(" "),_c('div',{staticClass:"sidebar-selection"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_qualite_eau_etat_pc),expression:"checkboxes_left_menu.checked_qualite_eau_etat_pc"}],attrs:{"type":"checkbox","id":"checkbox-qualite-eau-etat-pc"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_qualite_eau_etat_pc)?_vm._i(_vm.checkboxes_left_menu.checked_qualite_eau_etat_pc,null)>-1:(_vm.checkboxes_left_menu.checked_qualite_eau_etat_pc)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_qualite_eau_etat_pc,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_eau_etat_pc", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_eau_etat_pc", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_eau_etat_pc", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Température, oxygène, phosphore, azote...","for":"checkbox-qualite-eau-etat-pc"}},[_vm._v("État physico-chimique")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_qualite_eau_etat_ps),expression:"checkboxes_left_menu.checked_qualite_eau_etat_ps"}],attrs:{"type":"checkbox","id":"checkbox-qualite-eau-etat-ps"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_qualite_eau_etat_ps)?_vm._i(_vm.checkboxes_left_menu.checked_qualite_eau_etat_ps,null)>-1:(_vm.checkboxes_left_menu.checked_qualite_eau_etat_ps)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_qualite_eau_etat_ps,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_eau_etat_ps", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_eau_etat_ps", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_eau_etat_ps", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Métaux lourds : cuivre, zinc, asenic...","for":"checkbox-qualite-eau-etat-ps"}},[_vm._v("Polluants persistants")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_qualite_eau_bio),expression:"checkboxes_left_menu.checked_qualite_eau_bio"}],attrs:{"type":"checkbox","id":"checkbox-qualite-eau-bio"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_qualite_eau_bio)?_vm._i(_vm.checkboxes_left_menu.checked_qualite_eau_bio,null)>-1:(_vm.checkboxes_left_menu.checked_qualite_eau_bio)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_qualite_eau_bio,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_eau_bio", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_eau_bio", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_eau_bio", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Synthèse des indices biologiques : IPR, IBD, IBGN...","for":"checkbox-qualite-eau-bio"}},[_vm._v("Qualité biologique")])]),_vm._v(" "),_c('h2',[_vm._v("Qualité des habitats (SYRAH, 2017)")]),_vm._v(" "),_c('div',{staticClass:"sidebar-selection"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_diversite_habitat),expression:"checkboxes_left_menu.checked_diversite_habitat"}],attrs:{"type":"checkbox","id":"checkbox-diversite-habitat"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_diversite_habitat)?_vm._i(_vm.checkboxes_left_menu.checked_diversite_habitat,null)>-1:(_vm.checkboxes_left_menu.checked_diversite_habitat)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_diversite_habitat,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_diversite_habitat", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_diversite_habitat", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_diversite_habitat", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Probabilité d'altération des habitats par les activités humaines","for":"checkbox-diversite-habitat"}},[_vm._v("Habitats aquatiques")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_presence_ripisylve),expression:"checkboxes_left_menu.checked_presence_ripisylve"}],attrs:{"type":"checkbox","id":"checkbox-presence-ripisylve"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_presence_ripisylve)?_vm._i(_vm.checkboxes_left_menu.checked_presence_ripisylve,null)>-1:(_vm.checkboxes_left_menu.checked_presence_ripisylve)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_presence_ripisylve,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_presence_ripisylve", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_presence_ripisylve", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_presence_ripisylve", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Taux de boisement des berges","for":"checkbox-presence-ripisylve"}},[_vm._v("Ripisylve")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_erosion_sol),expression:"checkboxes_left_menu.checked_erosion_sol"}],attrs:{"type":"checkbox","id":"checkbox-erosion-sol"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_erosion_sol)?_vm._i(_vm.checkboxes_left_menu.checked_erosion_sol,null)>-1:(_vm.checkboxes_left_menu.checked_erosion_sol)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_erosion_sol,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_erosion_sol", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_erosion_sol", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_erosion_sol", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Risque d'érosion des sols agricoles","for":"checkbox-erosion-sol"}},[_vm._v("Érosion des sols")])]),_vm._v(" "),_c('h2',[_vm._v("Continuité écologique (ROE, février 2024)")]),_vm._v(" "),_c('div',{staticClass:"sidebar-selection"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.checked_qualite_localisation_obst),expression:"checkboxes_left_menu.checked_qualite_localisation_obst"}],attrs:{"type":"checkbox","id":"checkbox-localisation-obst"},domProps:{"checked":Array.isArray(_vm.checkboxes_left_menu.checked_qualite_localisation_obst)?_vm._i(_vm.checkboxes_left_menu.checked_qualite_localisation_obst,null)>-1:(_vm.checkboxes_left_menu.checked_qualite_localisation_obst)},on:{"change":function($event){var $$a=_vm.checkboxes_left_menu.checked_qualite_localisation_obst,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_localisation_obst", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_localisation_obst", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkboxes_left_menu, "checked_qualite_localisation_obst", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"title":"Libre circulation piscicole et transit des sédiments","for":"checkbox-localisation-obst"}},[_vm._v("Obstacles")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_restauration_ecologique),expression:"show_restauration_ecologique"}],staticClass:"sub-level-1 actions-popup",on:{"mouseover":function($event){_vm.show_restauration_ecologique = true},"mouseleave":function($event){_vm.locked_cadenas ? _vm.show_restauration_ecologique = true : _vm.show_restauration_ecologique = false}}},[_c('div',{staticClass:"sub-level-1-defilable"},[_c('div',{staticClass:"cadenas-wrapper",class:_vm.locked_cadenas ? 'cadenas-locked' : 'cadenas-unlocked',on:{"click":function($event){_vm.locked_cadenas = !_vm.locked_cadenas}}},[_c('img',{attrs:{"src":"static/img/picto-cadenas.png"}}),_c('span',{staticClass:"infobulle unlocked"},[_vm._v("Verrouiller le menu")]),_c('span',{staticClass:"infobulle locked"},[_vm._v("Déverrouiller le menu")])]),_vm._v(" "),_vm._l((_vm.filters_travaux('type_op')),function(filter_travaux){return [_c('h2',[_vm._v(_vm._s(filter_travaux[0].lib_title))]),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","id":filter_travaux[0].filtering},domProps:{"checked":!_vm.travaux_filters.find(function (country) { return country.filtering == filter_travaux[0].filtering && !country.checked; })},on:{"click":function($event){return _vm.clickParent(filter_travaux, 'type_op')}}}),_vm._v(" "),_c('label',{attrs:{"for":filter_travaux[0].filtering}},[_vm._v(_vm._s(filter_travaux[0].lib_all))]),_vm._v(" "),_c('hr',{staticClass:"blue"}),_vm._v(" "),_vm._l((filter_travaux),function(option){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.checked),expression:"option.checked"}],attrs:{"type":"checkbox","id":option.lib},domProps:{"checked":Array.isArray(option.checked)?_vm._i(option.checked,null)>-1:(option.checked)},on:{"change":function($event){var $$a=option.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(option, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(option, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(option, "checked", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":option.lib}},[_vm._v(_vm._s(option.lib))])]})]}),_vm._v(" "),_c('hr',{staticClass:"blue"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked_rapport),expression:"checked_rapport"}],attrs:{"type":"checkbox","id":"checkbox-rapport","disabled":!_vm.checked_travaux_vector_layer},domProps:{"checked":Array.isArray(_vm.checked_rapport)?_vm._i(_vm.checked_rapport,null)>-1:(_vm.checked_rapport)},on:{"change":function($event){var $$a=_vm.checked_rapport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked_rapport=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked_rapport=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked_rapport=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"like-h2",attrs:{"title":"","for":"checkbox-rapport"}},[_vm._v("Rapport technique")]),_vm._v(" "),_c('hr',{staticClass:"blue"}),_vm._v(" "),_vm._l((_vm.filters_travaux('type_structure')),function(filter_travaux){return [_c('h2',[_vm._v(_vm._s(filter_travaux[0].lib_title))]),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","disabled":!(_vm.travaux_filters.filter(function (filter) { return filter.filtering == 'type_op'; }).some(function (filter) { return filter.checked; })),"id":filter_travaux[0].filtering},domProps:{"checked":!_vm.travaux_filters.find(function (country) { return country.filtering == filter_travaux[0].filtering && !country.checked; })},on:{"click":function($event){return _vm.clickParent(filter_travaux, 'type_structure')}}}),_vm._v(" "),_c('label',{attrs:{"for":filter_travaux[0].filtering}},[_vm._v(_vm._s(filter_travaux[0].lib_all))]),_vm._v(" "),_c('hr',{staticClass:"blue"}),_vm._v(" "),_vm._l((filter_travaux),function(option){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.checked),expression:"option.checked"}],attrs:{"type":"checkbox","disabled":!(_vm.travaux_filters.filter(function (filter) { return filter.filtering == 'type_op'; }).some(function (filter) { return filter.checked; })),"id":option.lib},domProps:{"checked":Array.isArray(option.checked)?_vm._i(option.checked,null)>-1:(option.checked)},on:{"change":function($event){var $$a=option.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(option, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(option, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(option, "checked", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":option.lib}},[_vm._v(_vm._s(option.lib))])]})]}),_vm._v(" "),_c('hr',{staticClass:"blue"}),_vm._v(" "),_c('h2',[_vm._v("Année de réalisation")]),_vm._v(" "),_c('div',{style:(!_vm.checked_travaux_vector_layer ? 'pointer-events: none;opacity: 0.4' : ''),attrs:{"id":"slider-container"}}),_vm._v(" "),_c('div',{attrs:{"id":"range-label"}},[_vm._v("0 - 10")])],2)])])]),_vm._v(" "),_c('div',{staticClass:"sub-level-2-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isGroup1()),expression:"isGroup1()"}],staticClass:"sub-level-2 poissons-popup"},[_c('div',{staticClass:"toggle-lateral",on:{"click":_vm.resetGroup1}},[_c('i',{staticClass:"fas fa-trash-alt"}),_c('span',{staticClass:"infobulle trash"},[_vm._v("Supprimer la couche")])]),_vm._v(" "),_c('div',{staticClass:"sub-level-2-inner"},[_c('div',{staticClass:"toggle-topdown",on:{"click":function($event){_vm.show_toggletopdown_poissons = !_vm.show_toggletopdown_poissons}}},[(_vm.show_toggletopdown_poissons)?_c('i',{staticClass:"fas fa-minus"}):_vm._e(),_vm._v(" "),(!_vm.show_toggletopdown_poissons)?_c('i',{staticClass:"fas fa-plus"}):_vm._e()]),_vm._v(" "),(!_vm.show_toggletopdown_poissons)?_c('div',{staticClass:"title-popup-closed"},[(_vm.selected_especes.length > 0)?_c('h2',[_vm._v(_vm._s(_vm.title_espece ? _vm.title_espece.split('—')[0].trim() : ''))]):(_vm.check_if_first_group)?_c('h2',[_vm._v("\n                  "+_vm._s(_vm.set_title_bar_first_group())+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_toggletopdown_poissons),expression:"show_toggletopdown_poissons"}],staticClass:"toggle-block"},[(_vm.display_comment_etat || _vm.display_comment_evolution)?_c('div',{staticClass:"sub-main-menu"},[_c('div',{staticClass:"title-popup"},[_c('h2',{attrs:{"id":"cc"}},[_vm._v(_vm._s(_vm.title_espece ? _vm.title_espece.split('—')[0].trim() : ''))]),_vm._v(" "),_c('div',[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.url_article_poisson && _vm.url_image_poisson),expression:"url_article_poisson && url_image_poisson"}],attrs:{"target":"_blank","href":_vm.url_article_poisson}},[_c('img',{staticStyle:{"display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":_vm.url_image_poisson}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.selected_especes.length > 0),expression:"this.selected_especes.length > 0"}],staticClass:"legende-wrapper"},[_c('div',[_c('img',{attrs:{"src":_vm.selected_especes.length > 0 ? _vm.get_legend_url(_vm.getIdLayer(_vm.selected_especes[0].split('_')[1])) : ''}})])])]):(_vm.check_if_first_group)?_c('div',{staticClass:"sub-main-menu"},[_c('h2',{attrs:{"id":"dd"}},[_vm._v("\n                  "+_vm._s(_vm.set_title_bar_first_group())+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"legende-wrapper"},[_c('div',[_c('img',{attrs:{"src":_vm.get_first_group_key() == 'checked_stations_echantillonnage' ? _vm.get_legend_url(_vm.get_first_group_key(), true) : _vm.get_legend_url(_vm.get_first_group_key())}})])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique || _vm.checkboxes_left_menu.checked_etat_ipr),expression:"checkboxes_left_menu.checked_richesse_specifique || checkboxes_left_menu.checked_etat_ipr"}],staticClass:"options-wrapper"},[_c('div',{staticClass:"btn-options",on:{"click":function($event){_vm.show_block_poissons = !_vm.show_block_poissons}}},[(!_vm.show_block_poissons)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-plus-options.png"}}),_vm._v(" Plus d'options")]):_vm._e(),_vm._v(" "),(_vm.show_block_poissons)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-moins-options.png"}}),_vm._v(" Moins d'options")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_block_poissons),expression:"show_block_poissons"}],staticClass:"options-content"},[_c('div',{staticClass:"sub-title"},[_vm._v("L'échelle temporelle")]),_vm._v(" "),_c('div',{staticClass:"sidebar-selection inline-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat_richesse_ipr__1","type":"radio","value":"temps_etat__all"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__all")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__all")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat_richesse_ipr__1"}},[_vm._v("Toutes dates")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat_richesse_ipr__2","type":"radio","value":"temps_etat__20202030"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__20202030")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__20202030")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat_richesse_ipr__2"}},[_vm._v("2021 – 2030")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat_richesse_ipr__3","type":"radio","value":"temps_etat__20102020"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__20102020")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__20102020")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat_richesse_ipr__3"}},[_vm._v("2011 – 2020")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat_richesse_ipr__4","type":"radio","value":"temps_etat__20002010"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__20002010")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__20002010")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat_richesse_ipr__4"}},[_vm._v("2001 – 2010")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat_richesse_ipr__5","type":"radio","value":"temps_etat__before2000"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__before2000")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__before2000")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat_richesse_ipr__5"}},[_vm._v("Avant 2001")]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique),expression:"checkboxes_left_menu.checked_richesse_specifique"},{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat_richesse_ipr__6","type":"radio","value":"temps__evolution"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps__evolution")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps__evolution")}}}),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique),expression:"checkboxes_left_menu.checked_richesse_specifique"}],attrs:{"for":"temps_etat_richesse_ipr__6"}},[_vm._v("Évolution")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_stations_echantillonnage),expression:"checkboxes_left_menu.checked_stations_echantillonnage"}],staticClass:"btn-options btn-stat",on:{"click":function($event){_vm.show_block_stat_echantillonnage = !_vm.show_block_stat_echantillonnage}}},[(!_vm.show_block_stat_echantillonnage)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-plus-options.png"}}),_vm._v("Statistiques")]):_vm._e(),_vm._v(" "),(_vm.show_block_stat_echantillonnage)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-moins-options.png"}}),_vm._v("Statistiques")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"defilable-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_block_stat_echantillonnage),expression:"show_block_stat_echantillonnage"}],staticClass:"statistiques-wrapper"},[_c('div',{staticClass:"species-subtitle",staticStyle:{"margin-top":"20px","text-align":"center"},attrs:{"id":"title-barchart"}},[_vm._v("Nombre d'échantillonnages en 2023")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"},attrs:{"id":"barchart"}}),_vm._v(" "),_c('div',{staticClass:"species-subtitle",staticStyle:{"margin-top":"20px","text-align":"center"},attrs:{"id":"title-piechart"}},[_vm._v("Répartition du nombre d'échantillonnage par opérateurs")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"},attrs:{"id":"piechart"}}),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique || _vm.checkboxes_left_menu.checked_etat_ipr),expression:"checkboxes_left_menu.checked_richesse_specifique || checkboxes_left_menu.checked_etat_ipr"}],staticClass:"btn-options btn-stat",on:{"click":function($event){_vm.show_block_stat = !_vm.show_block_stat}}},[(!_vm.show_block_stat)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-plus-options.png"}}),_vm._v("Statistiques")]):_vm._e(),_vm._v(" "),(_vm.show_block_stat)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-moins-options.png"}}),_vm._v("Statistiques")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.display_comment_etat || _vm.display_comment_evolution)),expression:"(display_comment_etat || display_comment_evolution)"}],staticClass:"btn-options",on:{"click":function($event){_vm.show_block_interpretation = !_vm.show_block_interpretation}}},[(!_vm.show_block_interpretation)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-plus-options.png"}}),_vm._v(" Interprétation")]):_vm._e(),_vm._v(" "),(_vm.show_block_interpretation)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-moins-options.png"}}),_vm._v(" Interprétation")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"repartition-geographique-wrapper defilable-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.display_comment_etat || _vm.display_comment_evolution) && _vm.show_block_interpretation),expression:"(display_comment_etat || display_comment_evolution) && show_block_interpretation"}]},[_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.display_comment_etat),expression:"display_comment_etat"}]},[_vm._v("Répartition géographique")]),_vm._v(" "),_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.display_comment_evolution),expression:"display_comment_evolution"}]},[_vm._v("Tendance")]),_vm._v(" "),_vm._l((_vm.legend_poisson),function(legend){return _c('div',{staticClass:"legende-wrapper"},[_c('h4',[_vm._v(_vm._s(legend.layerLabel))]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":legend.layerUrl}})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display_comment_etat),expression:"display_comment_etat"}],staticClass:"description-wrapper",domProps:{"innerHTML":_vm._s(_vm.especesEtatComments)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display_comment_evolution),expression:"display_comment_evolution"}],staticClass:"description-wrapper",domProps:{"innerHTML":_vm._s(_vm.commentEvolutionEspeces)}}),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(_vm.idInfo),expression:"idInfo"}]}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.idInfo),expression:"idInfo"}],staticStyle:{"margin-left":"10px","margin-right":"10px"},attrs:{"id":"refresh-text"},domProps:{"innerHTML":_vm._s(_vm.textTextArea)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_user_logged_in),expression:"is_user_logged_in"}]},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.idInfo),expression:"idInfo"}],attrs:{"target":"_blank","href":'./gestion/?type=info&id=' + _vm.idInfo}},[_vm._v("\n                    "+_vm._s(this.linkText))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.idInfo),expression:"idInfo"}],staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.refreshText(_vm.selected_especes[0] + '_' + _vm.checkboxes_left_menu.especes_temps.replace('temps_', ''), _vm.idInfo.split('__')[2])}}})])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_block_stat),expression:"show_block_stat"}],staticClass:"statistiques-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique),expression:"checkboxes_left_menu.checked_richesse_specifique"}],staticClass:"sub-main-menu"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique && _vm.pieContextePiscicoleCyprinicole.data.length > 0),expression:"checkboxes_left_menu.checked_richesse_specifique && pieContextePiscicoleCyprinicole.data.length > 0"}],staticClass:"species-subtitle",staticStyle:{"margin-top":"20px","text-align":"center"}},[_vm._v("Fréquence d'occurrence des espèces au sein des contextes cyprinicoles\n                  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique && _vm.pieContextePiscicoleCyprinicole.data.length > 0),expression:"checkboxes_left_menu.checked_richesse_specifique && pieContextePiscicoleCyprinicole.data.length > 0"}],staticStyle:{"text-align":"center"},attrs:{"id":"piechart-contexte-piscicole-salmonicole"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique && _vm.pieContextePiscicoleIntermediaire.data.length > 0),expression:"checkboxes_left_menu.checked_richesse_specifique && pieContextePiscicoleIntermediaire.data.length > 0"}],staticClass:"species-subtitle",staticStyle:{"margin-top":"20px","text-align":"center"}},[_vm._v("Fréquence d'occurrence des espèces au sein des contextes intermédiaires\n                  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique && _vm.pieContextePiscicoleIntermediaire.data.length > 0),expression:"checkboxes_left_menu.checked_richesse_specifique && pieContextePiscicoleIntermediaire.data.length > 0"}],staticStyle:{"text-align":"center"},attrs:{"id":"piechart-contexte-piscicole-intermediaire"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique && _vm.pieContextePiscicoleSalmonicole.data.length > 0),expression:"checkboxes_left_menu.checked_richesse_specifique && pieContextePiscicoleSalmonicole.data.length > 0"}],staticClass:"species-subtitle",staticStyle:{"margin-top":"20px","text-align":"center"}},[_vm._v("Fréquence d'occurrence des espèces au sein des contextes salmonicoles\n                  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique && _vm.pieContextePiscicoleSalmonicole.data.length > 0),expression:"checkboxes_left_menu.checked_richesse_specifique && pieContextePiscicoleSalmonicole.data.length > 0"}],staticStyle:{"text-align":"center"},attrs:{"id":"piechart-contexte-piscicole-cyprinicole"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_richesse_specifique == true && _vm.checkboxes_left_menu.especes_temps.endsWith('__evolution')),expression:"checkboxes_left_menu.checked_richesse_specifique == true && checkboxes_left_menu.especes_temps.endsWith('__evolution')"}],staticStyle:{"margin-left":"10px","margin-right":"10px"},domProps:{"innerHTML":_vm._s(_vm.commentRichesseSpecifiqueEvolution)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_etat_ipr),expression:"checkboxes_left_menu.checked_etat_ipr"}]},[_c('div',{staticClass:"sub-main-menu"}),_vm._v(" "),_c('div',{staticClass:"species-subtitle",staticStyle:{"margin-top":"20px","text-align":"center"}},[_vm._v("Résultats des IPR")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"},attrs:{"id":"barchart-ipr"}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected_especes.length > 0),expression:"selected_especes.length > 0"}],staticClass:"options-wrapper"},[_c('div',{staticClass:"btn-options",on:{"click":function($event){_vm.show_block_poissons = !_vm.show_block_poissons}}},[(!_vm.show_block_poissons)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-plus-options.png"}}),_vm._v(" Plus d'options")]):_vm._e(),_vm._v(" "),(_vm.show_block_poissons)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-moins-options.png"}}),_vm._v(" Moins d'options")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_block_poissons),expression:"show_block_poissons"}],staticClass:"options-content"},[_c('div',{staticClass:"sub-title"},[_vm._v("L'échelle temporelle")]),_vm._v(" "),_c('div',{staticClass:"sidebar-selection inline-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat__1","type":"radio","value":"temps_etat__all"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__all")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__all")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat__1"}},[_vm._v("Toutes dates")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat__2","type":"radio","value":"temps_etat__20202030"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__20202030")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__20202030")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat__2"}},[_vm._v("2021 – 2030")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat__3","type":"radio","value":"temps_etat__20102020"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__20102020")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__20102020")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat__3"}},[_vm._v("2011 – 2020")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat__4","type":"radio","value":"temps_etat__20002010"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__20002010")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__20002010")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat__4"}},[_vm._v("2001 – 2010")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat__5","type":"radio","value":"temps_etat__before2000"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps_etat__before2000")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps_etat__before2000")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat__5"}},[_vm._v("Avant 2001")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_temps),expression:"checkboxes_left_menu.especes_temps"}],attrs:{"id":"temps_etat__6","type":"radio","value":"temps__evolution"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_temps,"temps__evolution")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_temps", "temps__evolution")}}}),_vm._v(" "),_c('label',{attrs:{"for":"temps_etat__6"}},[_vm._v("Évolution")])]),_vm._v(" "),_c('div',{staticClass:"sub-title"},[_vm._v("Le type de protocole")]),_vm._v(" "),_c('div',{staticClass:"sidebar-selection"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_protocole),expression:"checkboxes_left_menu.especes_protocole"}],attrs:{"id":"protocole__1","type":"radio","value":"protocole_full"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_protocole,"protocole_full")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_protocole", "protocole_full")}}}),_vm._v(" "),_c('label',{attrs:{"title":"Échantillonnages normalisés par pêche électrique","for":"protocole__1"}},[_vm._v("Tous protocoles")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_protocole),expression:"checkboxes_left_menu.especes_protocole"}],attrs:{"id":"protocole__2","type":"radio","value":"protocole_complet"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_protocole,"protocole_complet")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_protocole", "protocole_complet")}}}),_vm._v(" "),_c('label',{attrs:{"title":"Échantillonnage complet d'un tronçon à l'électricité","for":"protocole__2"}},[_vm._v("Inventaire complet")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxes_left_menu.especes_protocole),expression:"checkboxes_left_menu.especes_protocole"}],attrs:{"id":"protocole__3","type":"radio","value":"protocole_ponctuel"},domProps:{"checked":_vm._q(_vm.checkboxes_left_menu.especes_protocole,"protocole_ponctuel")},on:{"change":function($event){return _vm.$set(_vm.checkboxes_left_menu, "especes_protocole", "protocole_ponctuel")}}}),_vm._v(" "),_c('label',{attrs:{"title":"Échantillonnage partiel d'un tronçon à l'électricité","for":"protocole__3"}},[_vm._v("Échantillonnage par point")])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.check_if_rivieres_group()),expression:"check_if_rivieres_group()"}],staticClass:"sub-level-2 stations-popup"},[_c('div',{staticClass:"toggle-lateral",on:{"click":_vm.resetGroupRivieres}},[_c('i',{staticClass:"fas fa-trash-alt"}),_c('span',{staticClass:"infobulle trash"},[_vm._v("Supprimer la couche")])]),_vm._v(" "),_c('div',{staticClass:"sub-level-2-inner"},[_c('div',{staticClass:"toggle-topdown",on:{"click":function($event){_vm.show_toggletopdown_rivieres = !_vm.show_toggletopdown_rivieres}}},[(_vm.show_toggletopdown_rivieres)?_c('i',{staticClass:"fas fa-minus"}):_vm._e(),_vm._v(" "),(!_vm.show_toggletopdown_rivieres)?_c('i',{staticClass:"fas fa-plus"}):_vm._e()]),_vm._v(" "),(!_vm.show_toggletopdown_rivieres)?_c('div',{staticClass:"title-popup-closed"},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.check_if_rivieres_group),expression:"check_if_rivieres_group"}]},[_vm._v("\n                  "+_vm._s(_vm.set_title_bar_rivieres_group())+"\n              ")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_toggletopdown_rivieres),expression:"show_toggletopdown_rivieres"}],staticClass:"toggle-block"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.check_if_rivieres_group),expression:"check_if_rivieres_group"}],staticClass:"sub-main-menu"},[_c('h2',{attrs:{"id":"ee"}},[_vm._v("\n                  "+_vm._s(_vm.set_title_bar_rivieres_group())+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"legende-wrapper"},[_c('div',[_c('h3',{attrs:{"if":"checkboxes_left_menu.checked_diversite_habitat || checkboxes_left_menu.checked_presence_ripisylve"}},[_vm._v(" "+_vm._s(_vm.setLegendTitleForSpecificLayers(['checked_diversite_habitat', 'checked_presence_ripisylve'])))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.get_legend_url(_vm.get_rivieres_group_key())}})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkboxes_left_menu.checked_qualite_localisation_obst),expression:"checkboxes_left_menu.checked_qualite_localisation_obst"}],staticClass:"sub-level-2 obstacles-popup"},[_c('div',{staticClass:"toggle-lateral",on:{"click":function($event){_vm.checkboxes_left_menu.checked_qualite_localisation_obst = !_vm.checkboxes_left_menu.checked_qualite_localisation_obst}}},[_c('i',{staticClass:"fas fa-trash-alt"}),_c('span',{staticClass:"infobulle trash"},[_vm._v("Supprimer la couche")])]),_vm._v(" "),_c('div',{staticClass:"sub-level-2-inner"},[_c('div',{staticClass:"toggle-topdown",on:{"click":function($event){_vm.show_toggletopdown_obstacles = !_vm.show_toggletopdown_obstacles}}},[(_vm.show_toggletopdown_obstacles)?_c('i',{staticClass:"fas fa-minus"}):_vm._e(),_vm._v(" "),(!_vm.show_toggletopdown_obstacles)?_c('i',{staticClass:"fas fa-plus"}):_vm._e()]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_toggletopdown_obstacles),expression:"show_toggletopdown_obstacles"}],staticClass:"toggle-block"},[_c('div',{staticClass:"defilable-wrapper"},[_c('div',{staticClass:"description-wrapper"},[_c('h3',{attrs:{"if":"checkboxes_left_menu.checked_qualite_localisation_obst"}},[_vm._v(" "+_vm._s(_vm.setLegendTitleForSpecificLayers(['checked_qualite_localisation_obst'])))]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":_vm.get_legend_url('checked_qualite_localisation_obst')}})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}],staticClass:"sub-level-2 actions-popup"},[_c('div',{staticClass:"toggle-lateral",on:{"click":function($event){_vm.checked_travaux_vector_layer = !_vm.checked_travaux_vector_layer;_vm.travaux_filters.forEach(function (el) {el.checked = false;});_vm.activateOnceTypeStructure = true;_vm.minSelectedDate = _vm.minDate;_vm.maxSelectedDate = _vm.maxDate;_vm.slider.range(_vm.minSelectedDate, _vm.maxSelectedDate);_vm.checked_rapport = false;}}},[_c('i',{staticClass:"fas fa-trash-alt"}),_c('span',{staticClass:"infobulle trash"},[_vm._v("Supprimer la couche")])]),_vm._v(" "),_c('div',{staticClass:"sub-level-2-inner"},[_c('div',{staticClass:"toggle-topdown",on:{"click":function($event){_vm.show_toggletopdown_actions = !_vm.show_toggletopdown_actions}}},[(_vm.show_toggletopdown_actions)?_c('i',{staticClass:"fas fa-minus"}):_vm._e(),_vm._v(" "),(!_vm.show_toggletopdown_actions)?_c('i',{staticClass:"fas fa-plus"}):_vm._e()]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_toggletopdown_actions),expression:"show_toggletopdown_actions"}],staticClass:"toggle-block"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}],staticClass:"description-wrapper"},[_vm._m(10),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_user_logged_in),expression:"is_user_logged_in"}],staticClass:"fa fa-edit",style:(_vm.draw_travaux ? 'color: red;' : ''),attrs:{"aria-hidden":"true","alt":"Positionner une nouvelle action sur la carte","title":"Positionner une nouvelle action sur la carte"},on:{"click":function($event){return _vm.activateDrawingTravaux()}}},[_vm._v("Créer une action")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}],staticClass:"btn-options btn-stat",on:{"click":function($event){_vm.show_block_stat_restauration = !_vm.show_block_stat_restauration}}},[(!_vm.show_block_stat_restauration)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-plus-options.png"}}),_vm._v("Statistiques")]):_vm._e(),_vm._v(" "),(_vm.show_block_stat_restauration)?_c('span',[_c('img',{attrs:{"src":"static/img/picto-moins-options.png"}}),_vm._v("Statistiques")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"defilable-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_block_stat_restauration),expression:"show_block_stat_restauration"}],staticClass:"statistiques-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}],staticClass:"sub-main-menu"},[_c('h4',[_vm._v("Travaux de restauration écologique")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}],staticClass:"species-subtitle",staticStyle:{"margin-top":"20px","text-align":"center"},attrs:{"id":"title-travaux-barchart"}},[_vm._v("Type de travaux réalisés en 2023")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}],staticStyle:{"text-align":"center"},attrs:{"id":"barchart-travaux"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}],staticClass:"species-subtitle",staticStyle:{"margin-top":"20px","text-align":"center"},attrs:{"id":"title-travaux-piechart"}},[_c('b',[_vm._v("Type d'actions de restauration toutes années")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}],staticStyle:{"text-align":"center"},attrs:{"id":"piechart-travaux"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}]},[_c('div',{attrs:{"id":"travaux-legend"}})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"map-controls"},[_c('div',{staticClass:"layers-wrapper"},[_c('div',{staticClass:"ol-layers ol-unselectable ol-control",on:{"click":function($event){_vm.show_couches = !_vm.show_couches}}},[_c('button',{staticClass:"ol-layer-icon icon-layer",attrs:{"type":"button","title":"Fonds de carte"}},[_vm._v("")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_couches),expression:"show_couches"}],ref:"fondplan",staticClass:"map-layers-popup",on:{"mouseleave":function($event){_vm.show_couches = false}}},[_c('div',{attrs:{"id":"ign-layers"}},[_c('h4',[_vm._v("Fonds de carte")]),_vm._v(" "),_c('div',{staticClass:"grid-legend-container"},[_vm._l((_vm.layers_background_list.filter(function (layer) { return layer.basemap; })),function(l){return [_c('div',[_c('img',{style:(_vm.basemap == l.identifier ? 'opacity:1;border-width:2px' : 'opacity:0.3;'),attrs:{"alt":l.title_alt || l.title,"title":l.title_alt || l.title,"src":'static/img/' + l.picto},on:{"click":function($event){return _vm.selectBaseMap(l.identifier)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(l.title))])])]})],2),_vm._v(" "),_c('h4',[_vm._v("Détails de carte")]),_vm._v(" "),_vm._l((_vm.layers_background_list.slice().filter(function (el) { return !el.basemap; }).reverse()),function(item){return _c('li',{staticClass:"details-carte"},[_c('input',{staticClass:"checkbox",attrs:{"id":item.identifier.replace('.','-').toLowerCase(),"type":"checkbox","data-identifier":item.identifier},domProps:{"checked":item.visible},on:{"click":_vm.checkboxToggle}}),_vm._v(" "),_c('label',{attrs:{"for":item.identifier.replace('.','-').toLowerCase()}},[_vm._v(_vm._s(item.title))])])})],2)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.right_panel),expression:"right_panel"}],staticClass:"sub-level-4",attrs:{"id":"popup-content"}},[_c('div',{staticClass:"toggle-lateral-sl4",on:{"click":function($event){_vm.right_panel = false}}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "),_c('div',{staticClass:"defilable-sl4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.popup_element)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.popup_travaux)}}),_vm._v(" "),_c('div',{attrs:{"id":"querycontentcontainer"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked_travaux_vector_layer),expression:"checked_travaux_vector_layer"}],attrs:{"id":"pdfcontent"}},[_c('br',{directives:[{name:"show",rawName:"v-show",value:(_vm.idPdf),expression:"idPdf"}]}),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(_vm.idPdf),expression:"idPdf"}]}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.textPdfArea)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_user_logged_in),expression:"is_user_logged_in"}]},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.idPdf),expression:"idPdf"}],attrs:{"target":"_blank","href":'./gestion/?type=action&id=' + _vm.idPdf}},[_vm._v("\n                   "+_vm._s(_vm.linkPdfText)+"\n                  ")]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.idPdf),expression:"idPdf"}],staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.refreshPdf('checked_localisation_typologie', _vm.idPdf.split('__')[2])}}})])]),_vm._v(" "),_c('div',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.external_url),expression:"external_url"}],on:{"click":_vm.openExternalUrl}},[_vm._v("Voir la fiche technique")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display_evolution_chart),expression:"display_evolution_chart"}],staticStyle:{"margin-top":"20px","text-align":"center"},attrs:{"id":"title-barchart-evolution-species"}},[_c('div',{staticClass:"sub-title"},[_vm._v("Évolution des densités")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display_evolution_chart),expression:"display_evolution_chart"}],staticStyle:{"text-align":"center"},attrs:{"id":"barchart-evolution-species"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display_evolution_chart),expression:"display_evolution_chart"}],staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/legende-tendance-evolution.svg","onerror":"this.onerror=null; this.src='static/img/legende-tendance-evolution.png'"}})])]),_vm._v(" "),_c('div',{staticClass:"defilable-sl4"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-item flex-item01"},[_c('span',{staticClass:"flex-item-content"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":"static/img/logo-opsn.png"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-item flex-item02"},[_c('span',{staticClass:"flex-item-content"},[_c('a',{attrs:{"href":"/"}},[_vm._v("RETOUR AU SITE")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('div',{attrs:{"id":"map"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-level-title-content"},[_c('img',{attrs:{"src":"static/img/picto-poisson.png"}}),_c('br'),_vm._v("Poissons")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-level-title-content"},[_c('img',{attrs:{"src":"static/img/picto-riviere.png"}}),_c('br'),_vm._v("Rivières")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-level-title-content"},[_c('img',{attrs:{"src":"static/img/picto-action.png"}}),_c('br'),_vm._v("Actions de restauration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picto-wrapper"},[_c('a',{attrs:{"href":"/carte/telechargement-des-donnees/"}},[_c('img',{attrs:{"src":"static/img/picto-telechargement.png"}})]),_c('span',{staticClass:"infobulle"},[_vm._v("Télécharger les données")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"echantillonnages-legend"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-popup-closed"},[_c('h2',[_vm._v("Obstacles")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-popup-closed"},[_c('h2',[_vm._v("Actions de restauration")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"width":"240px","src":"static/img/legende_travaux.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CAXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


/**
 * @callback ResolverFn
 * @param {string} varName - variable name before being parsed.
 *        For example: {a.b.c} ->  'a.b.c', {  x  } -> 'x'
 * @param {Object} view - the view object that was passed to .render() function
 * @returns {string|number|boolean|Object|undefined} the value to be
 *        interpolated. If the function returns undefined, the value resolution
 *        algorithm will go ahead with the default behaviour (resolving the
 *        variable name from the provided object).
 */

var VAR_MATCH_REGEX = /\{\{\s*(.*?)\s*\}\}/g;

function _valueToString(value) {
  switch (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) {
    case 'string':
    case 'number':
    case 'boolean':
      return value;
    case 'object':
      try {
        // null is an object but is falsy. Swallow it.
        return value === null ? '' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
      } catch (jsonError) {
        return '{...}';
      }
    default:
      // Anything else will be replaced with an empty string
      // For example: undefined, Symbol, etc.
      return '';
  }
}

/**
 * Recursively goes through an object trying to resolve a path.
 *
 * @param {Object} scope - The object to traverse (in each recursive call we dig into this object)
 * @param {string[]} path - An array of property names to traverse one-by-one
 * @param {number} [pathIndex=0] - The current index in the path array
 */
function _recursivePathResolver(scope, path) {
  var pathIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if ((typeof scope === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(scope)) !== 'object' || scope === null || scope === undefined) {
    return '';
  }

  var varName = path[pathIndex];
  var value = scope[varName];

  if (pathIndex === path.length - 1) {
    // It's a leaf, return whatever it is
    return value;
  }

  return _recursivePathResolver(value, path, ++pathIndex);
}

function defaultResolver(varName, view) {
  return _recursivePathResolver(view, varName.split('.'));
}

/**
 * Replaces every {{variable}} inside the template with values provided by view.
 *
 * @param {string} template - The template containing one or more {{variableNames}} every variable
 *        names that is used in the template. If it's omitted, it'll be assumed an empty object.
 * @param {Object} [view={}] - An object containing values for every variable names that is used in
 *        the template. If it's omitted, it'll be set to an empty object essentially removing all
 *        {{varName}}s in the template.
 * @param {ResolverFn} [resolver] - An optional function that will be
 *        called for every {{varName}} to generate a value. If the resolver throws an error
 *        we'll proceed with the default value resolution algorithm (find the value from the view
 *        object).
 * @returns {string} - Template where its variable names replaced with
 *        corresponding values. If a value is not found or is invalid, it will
 *        be assumed empty string ''. If the value is an object itself, it'll
 *        be stringified by JSON.
 *        In case of a JSON stringify error the result will look like "{...}".
 */
function render(template) {
  var view = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var resolver = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultResolver;

  // don't touch the template if it is not a string
  if (typeof template !== 'string') {
    return template;
  }

  return template.replace(VAR_MATCH_REGEX, function (match, varName) {
    try {
      // defaultResolver never throws
      return _valueToString(resolver(varName, view));
    } catch (e) {
      // if your resolver throws, we proceed with the default resolver
      return _valueToString(defaultResolver(varName, view));
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (render);

/***/ }),

/***/ "IYLo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "If3l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_015b8340_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("OzWz");
function injectStyle (ssrContext) {
  __webpack_require__("0S7p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_015b8340_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalize_css__ = __webpack_require__("uMhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_async_computed__ = __webpack_require__("JJ92");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_async_computed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_clipboard2___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
// Vue.config.devtools = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.errorHandler = function (err, vm, info) {
  console.log('[Global Error Handler]: Error in ' + info + ': ' + err);
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "OzWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S3P2":
/***/ (function(module, exports) {

module.exports = {"aa":{"language":"Afar","location":null,"id":4096,"tag":"aa","version":"Release 10"},"aa-dj":{"language":"Afar","location":"Djibouti","id":4096,"tag":"aa-DJ","version":"Release 10"},"aa-er":{"language":"Afar","location":"Eritrea","id":4096,"tag":"aa-ER","version":"Release 10"},"aa-et":{"language":"Afar","location":"Ethiopia","id":4096,"tag":"aa-ET","version":"Release 10"},"af":{"language":"Afrikaans","location":null,"id":54,"tag":"af","version":"Release 7"},"af-na":{"language":"Afrikaans","location":"Namibia","id":4096,"tag":"af-NA","version":"Release 10"},"af-za":{"language":"Afrikaans","location":"South Africa","id":1078,"tag":"af-ZA","version":"Release B"},"agq":{"language":"Aghem","location":null,"id":4096,"tag":"agq","version":"Release 10"},"agq-cm":{"language":"Aghem","location":"Cameroon","id":4096,"tag":"agq-CM","version":"Release 10"},"ak":{"language":"Akan","location":null,"id":4096,"tag":"ak","version":"Release 10"},"ak-gh":{"language":"Akan","location":"Ghana","id":4096,"tag":"ak-GH","version":"Release 10"},"sq":{"language":"Albanian","location":null,"id":28,"tag":"sq","version":"Release 7"},"sq-al":{"language":"Albanian","location":"Albania","id":1052,"tag":"sq-AL","version":"Release B"},"sq-mk":{"language":"Albanian","location":"North Macedonia","id":4096,"tag":"sq-MK","version":"Release 10"},"gsw":{"language":"Alsatian","location":null,"id":132,"tag":"gsw","version":"Release 7"},"gsw-fr":{"language":"Alsatian","location":"France","id":1156,"tag":"gsw-FR","version":"Release V"},"gsw-li":{"language":"Alsatian","location":"Liechtenstein","id":4096,"tag":"gsw-LI","version":"Release 10"},"gsw-ch":{"language":"Alsatian","location":"Switzerland","id":4096,"tag":"gsw-CH","version":"Release 10"},"am":{"language":"Amharic","location":null,"id":94,"tag":"am","version":"Release 7"},"am-et":{"language":"Amharic","location":"Ethiopia","id":1118,"tag":"am-ET","version":"Release V"},"ar":{"language":"Arabic","location":null,"id":1,"tag":"ar","version":"Release 7"},"ar-dz":{"language":"Arabic","location":"Algeria","id":5121,"tag":"ar-DZ","version":"Release B"},"ar-bh":{"language":"Arabic","location":"Bahrain","id":15361,"tag":"ar-BH","version":"Release B"},"ar-td":{"language":"Arabic","location":"Chad","id":4096,"tag":"ar-TD","version":"Release 10"},"ar-km":{"language":"Arabic","location":"Comoros","id":4096,"tag":"ar-KM","version":"Release 10"},"ar-dj":{"language":"Arabic","location":"Djibouti","id":4096,"tag":"ar-DJ","version":"Release 10"},"ar-eg":{"language":"Arabic","location":"Egypt","id":3073,"tag":"ar-EG","version":"Release B"},"ar-er":{"language":"Arabic","location":"Eritrea","id":4096,"tag":"ar-ER","version":"Release 10"},"ar-iq":{"language":"Arabic","location":"Iraq","id":2049,"tag":"ar-IQ","version":"Release B"},"ar-il":{"language":"Arabic","location":"Israel","id":4096,"tag":"ar-IL","version":"Release 10"},"ar-jo":{"language":"Arabic","location":"Jordan","id":11265,"tag":"ar-JO","version":"Release B"},"ar-kw":{"language":"Arabic","location":"Kuwait","id":13313,"tag":"ar-KW","version":"Release B"},"ar-lb":{"language":"Arabic","location":"Lebanon","id":12289,"tag":"ar-LB","version":"Release B"},"ar-ly":{"language":"Arabic","location":"Libya","id":4097,"tag":"ar-LY","version":"Release B"},"ar-mr":{"language":"Arabic","location":"Mauritania","id":4096,"tag":"ar-MR","version":"Release 10"},"ar-ma":{"language":"Arabic","location":"Morocco","id":6145,"tag":"ar-MA","version":"Release B"},"ar-om":{"language":"Arabic","location":"Oman","id":8193,"tag":"ar-OM","version":"Release B"},"ar-ps":{"language":"Arabic","location":"Palestinian Authority","id":4096,"tag":"ar-PS","version":"Release 10"},"ar-qa":{"language":"Arabic","location":"Qatar","id":16385,"tag":"ar-QA","version":"Release B"},"ar-sa":{"language":"Arabic","location":"Saudi Arabia","id":1025,"tag":"ar-SA","version":"Release B"},"ar-so":{"language":"Arabic","location":"Somalia","id":4096,"tag":"ar-SO","version":"Release 10"},"ar-ss":{"language":"Arabic","location":"South Sudan","id":4096,"tag":"ar-SS","version":"Release 10"},"ar-sd":{"language":"Arabic","location":"Sudan","id":4096,"tag":"ar-SD","version":"Release 10"},"ar-sy":{"language":"Arabic","location":"Syria","id":10241,"tag":"ar-SY","version":"Release B"},"ar-tn":{"language":"Arabic","location":"Tunisia","id":7169,"tag":"ar-TN","version":"Release B"},"ar-ae":{"language":"Arabic","location":"U.A.E.","id":14337,"tag":"ar-AE","version":"Release B"},"ar-001":{"language":"Arabic","location":"World","id":4096,"tag":"ar-001","version":"Release 10"},"ar-ye":{"language":"Arabic","location":"Yemen","id":9217,"tag":"ar-YE","version":"Release B"},"hy":{"language":"Armenian","location":null,"id":43,"tag":"hy","version":"Release 7"},"hy-am":{"language":"Armenian","location":"Armenia","id":1067,"tag":"hy-AM","version":"Release C"},"as":{"language":"Assamese","location":null,"id":77,"tag":"as","version":"Release 7"},"as-in":{"language":"Assamese","location":"India","id":1101,"tag":"as-IN","version":"Release V"},"ast":{"language":"Asturian","location":null,"id":4096,"tag":"ast","version":"Release 10"},"ast-es":{"language":"Asturian","location":"Spain","id":4096,"tag":"ast-ES","version":"Release 10"},"asa":{"language":"Asu","location":null,"id":4096,"tag":"asa","version":"Release 10"},"asa-tz":{"language":"Asu","location":"Tanzania","id":4096,"tag":"asa-TZ","version":"Release 10"},"az-cyrl":{"language":"Azerbaijani (Cyrillic)","location":null,"id":29740,"tag":"az-Cyrl","version":"Windows 7"},"az-cyrl-az":{"language":"Azerbaijani (Cyrillic)","location":"Azerbaijan","id":2092,"tag":"az-Cyrl-AZ","version":"Release C"},"az":{"language":"Azerbaijani (Latin)","location":null,"id":44,"tag":"az","version":"Release 7"},"az-latn":{"language":"Azerbaijani (Latin)","location":null,"id":30764,"tag":"az-Latn","version":"Windows 7"},"az-latn-az":{"language":"Azerbaijani (Latin)","location":"Azerbaijan","id":1068,"tag":"az-Latn-AZ","version":"Release C"},"ksf":{"language":"Bafia","location":null,"id":4096,"tag":"ksf","version":"Release 10"},"ksf-cm":{"language":"Bafia","location":"Cameroon","id":4096,"tag":"ksf-CM","version":"Release 10"},"bm":{"language":"Bamanankan","location":null,"id":4096,"tag":"bm","version":"Release 10"},"bm-latn-ml":{"language":"Bamanankan (Latin)","location":"Mali","id":4096,"tag":"bm-Latn-ML","version":"Release 10"},"bn":{"language":"Bangla","location":null,"id":69,"tag":"bn","version":"Release 7"},"bn-bd":{"language":"Bangla","location":"Bangladesh","id":2117,"tag":"bn-BD","version":"Release V"},"bn-in":{"language":"Bangla","location":"India","id":1093,"tag":"bn-IN","version":"Release E1"},"bas":{"language":"Basaa","location":null,"id":4096,"tag":"bas","version":"Release 10"},"bas-cm":{"language":"Basaa","location":"Cameroon","id":4096,"tag":"bas-CM","version":"Release 10"},"ba":{"language":"Bashkir","location":null,"id":109,"tag":"ba","version":"Release 7"},"ba-ru":{"language":"Bashkir","location":"Russia","id":1133,"tag":"ba-RU","version":"Release V"},"eu":{"language":"Basque","location":null,"id":45,"tag":"eu","version":"Release 7"},"eu-es":{"language":"Basque","location":"Spain","id":1069,"tag":"eu-ES","version":"Release B"},"be":{"language":"Belarusian","location":null,"id":35,"tag":"be","version":"Release 7"},"be-by":{"language":"Belarusian","location":"Belarus","id":1059,"tag":"be-BY","version":"Release B"},"bem":{"language":"Bemba","location":null,"id":4096,"tag":"bem","version":"Release 10"},"bem-zm":{"language":"Bemba","location":"Zambia","id":4096,"tag":"bem-ZM","version":"Release 10"},"bez":{"language":"Bena","location":null,"id":4096,"tag":"bez","version":"Release 10"},"bez-tz":{"language":"Bena","location":"Tanzania","id":4096,"tag":"bez-TZ","version":"Release 10"},"byn":{"language":"Blin","location":null,"id":4096,"tag":"byn","version":"Release 10"},"byn-er":{"language":"Blin","location":"Eritrea","id":4096,"tag":"byn-ER","version":"Release 10"},"brx":{"language":"Bodo","location":null,"id":4096,"tag":"brx","version":"Release 10"},"brx-in":{"language":"Bodo","location":"India","id":4096,"tag":"brx-IN","version":"Release 10"},"bs-cyrl":{"language":"Bosnian (Cyrillic)","location":null,"id":25626,"tag":"bs-Cyrl","version":"Windows 7"},"bs-cyrl-ba":{"language":"Bosnian (Cyrillic)","location":"Bosnia and Herzegovina","id":8218,"tag":"bs-Cyrl-BA","version":"Release E1"},"bs-latn":{"language":"Bosnian (Latin)","location":null,"id":26650,"tag":"bs-Latn","version":"Windows 7"},"bs":{"language":"Bosnian (Latin)","location":null,"id":30746,"tag":"bs","version":"Release 7"},"bs-latn-ba":{"language":"Bosnian (Latin)","location":"Bosnia and Herzegovina","id":5146,"tag":"bs-Latn-BA","version":"Release E1"},"br":{"language":"Breton","location":null,"id":126,"tag":"br","version":"Release 7"},"br-fr":{"language":"Breton","location":"France","id":1150,"tag":"br-FR","version":"Release V"},"bg":{"language":"Bulgarian","location":null,"id":2,"tag":"bg","version":"Release 7"},"bg-bg":{"language":"Bulgarian","location":"Bulgaria","id":1026,"tag":"bg-BG","version":"Release B"},"my":{"language":"Burmese","location":null,"id":85,"tag":"my","version":"Release 8.1"},"my-mm":{"language":"Burmese","location":"Myanmar","id":1109,"tag":"my-MM","version":"Release 8.1"},"ca":{"language":"Catalan","location":null,"id":3,"tag":"ca","version":"Release 7"},"ca-ad":{"language":"Catalan","location":"Andorra","id":4096,"tag":"ca-AD","version":"Release 10"},"ca-fr":{"language":"Catalan","location":"France","id":4096,"tag":"ca-FR","version":"Release 10"},"ca-it":{"language":"Catalan","location":"Italy","id":4096,"tag":"ca-IT","version":"Release 10"},"ca-es":{"language":"Catalan","location":"Spain","id":1027,"tag":"ca-ES","version":"Release B"},"ceb":{"language":"Cebuano","location":null,"id":4096,"tag":"ceb","version":"Release 10.5"},"ceb-latn":{"language":"Cebuan (Latin)","location":null,"id":4096,"tag":"ceb-Latn","version":"Release 10.5"},"ceb-latn-ph":{"language":"Cebuan (Latin)","location":"Philippines","id":4096,"tag":"ceb-Latn-PH","version":"Release 10.5"},"tzm-latn-":{"language":"Central Atlas Tamazight (Latin)","location":"Morocco","id":4096,"tag":"tzm-Latn-","version":"Release 10"},"ku":{"language":"Central Kurdish","location":null,"id":146,"tag":"ku","version":"Release 8"},"ku-arab":{"language":"Central Kurdish","location":null,"id":31890,"tag":"ku-Arab","version":"Release 8"},"ku-arab-iq":{"language":"Central Kurdish","location":"Iraq","id":1170,"tag":"ku-Arab-IQ","version":"Release 8"},"ccp":{"language":"Chakma","location":null,"id":4096,"tag":"ccp","version":"Release 10.5"},"ccp-cakm":{"language":"Chakma","location":"Chakma","id":4096,"tag":"ccp-Cakm","version":"Release 10.5"},"ccp-cakm-":{"language":"Chakma","location":"India","id":4096,"tag":"ccp-Cakm-","version":"Release 10.5"},"cd-ru":{"language":"Chechen","location":"Russia","id":4096,"tag":"cd-RU","version":"Release 10.1"},"chr":{"language":"Cherokee","location":null,"id":92,"tag":"chr","version":"Release 8"},"chr-cher":{"language":"Cherokee","location":null,"id":31836,"tag":"chr-Cher","version":"Release 8"},"chr-cher-us":{"language":"Cherokee","location":"United States","id":1116,"tag":"chr-Cher-US","version":"Release 8"},"cgg":{"language":"Chiga","location":null,"id":4096,"tag":"cgg","version":"Release 10"},"cgg-ug":{"language":"Chiga","location":"Uganda","id":4096,"tag":"cgg-UG","version":"Release 10"},"zh-hans":{"language":"Chinese (Simplified)","location":null,"id":4,"tag":"zh-Hans","version":"Release A"},"zh":{"language":"Chinese (Simplified)","location":null,"id":30724,"tag":"zh","version":"Windows 7"},"zh-cn":{"language":"Chinese (Simplified)","location":"People's Republic of China","id":2052,"tag":"zh-CN","version":"Release A"},"zh-sg":{"language":"Chinese (Simplified)","location":"Singapore","id":4100,"tag":"zh-SG","version":"Release A"},"zh-hant":{"language":"Chinese (Traditional)","location":null,"id":31748,"tag":"zh-Hant","version":"Release A"},"zh-hk":{"language":"Chinese (Traditional)","location":"Hong Kong S.A.R.","id":3076,"tag":"zh-HK","version":"Release A"},"zh-mo":{"language":"Chinese (Traditional)","location":"Macao S.A.R.","id":5124,"tag":"zh-MO","version":"Release D"},"zh-tw":{"language":"Chinese (Traditional)","location":"Taiwan","id":1028,"tag":"zh-TW","version":"Release A"},"cu-ru":{"language":"Church Slavic","location":"Russia","id":4096,"tag":"cu-RU","version":"Release 10.1"},"swc":{"language":"Congo Swahili","location":null,"id":4096,"tag":"swc","version":"Release 10"},"swc-cd":{"language":"Congo Swahili","location":"Congo DRC","id":4096,"tag":"swc-CD","version":"Release 10"},"kw":{"language":"Cornish","location":null,"id":4096,"tag":"kw","version":"Release 10"},"kw-gb":{"language":"Cornish","location":"United Kingdom","id":4096,"tag":"kw-GB","version":"Release 10"},"co":{"language":"Corsican","location":null,"id":131,"tag":"co","version":"Release 7"},"co-fr":{"language":"Corsican","location":"France","id":1155,"tag":"co-FR","version":"Release V"},"hr,":{"language":"Croatian","location":null,"id":26,"tag":"hr,","version":"Release 7"},"hr-hr":{"language":"Croatian","location":"Croatia","id":1050,"tag":"hr-HR","version":"Release A"},"hr-ba":{"language":"Croatian (Latin)","location":"Bosnia and Herzegovina","id":4122,"tag":"hr-BA","version":"Release E1"},"cs":{"language":"Czech","location":null,"id":5,"tag":"cs","version":"Release 7"},"cs-cz":{"language":"Czech","location":"Czech Republic","id":1029,"tag":"cs-CZ","version":"Release A"},"da":{"language":"Danish","location":null,"id":6,"tag":"da","version":"Release 7"},"da-dk":{"language":"Danish","location":"Denmark","id":1030,"tag":"da-DK","version":"Release A"},"da-gl":{"language":"Danish","location":"Greenland","id":4096,"tag":"da-GL","version":"Release 10"},"prs":{"language":"Dari","location":null,"id":140,"tag":"prs","version":"Release 7"},"prs-af":{"language":"Dari","location":"Afghanistan","id":1164,"tag":"prs-AF","version":"Release V"},"dv":{"language":"Divehi","location":null,"id":101,"tag":"dv","version":"Release 7"},"dv-mv":{"language":"Divehi","location":"Maldives","id":1125,"tag":"dv-MV","version":"Release D"},"dua":{"language":"Duala","location":null,"id":4096,"tag":"dua","version":"Release 10"},"dua-cm":{"language":"Duala","location":"Cameroon","id":4096,"tag":"dua-CM","version":"Release 10"},"nl":{"language":"Dutch","location":null,"id":19,"tag":"nl","version":"Release 7"},"nl-aw":{"language":"Dutch","location":"Aruba","id":4096,"tag":"nl-AW","version":"Release 10"},"nl-be":{"language":"Dutch","location":"Belgium","id":2067,"tag":"nl-BE","version":"Release A"},"nl-bq":{"language":"Dutch","location":"Bonaire, Sint Eustatius and Saba","id":4096,"tag":"nl-BQ","version":"Release 10"},"nl-cw":{"language":"Dutch","location":"Curaçao","id":4096,"tag":"nl-CW","version":"Release 10"},"nl-nl":{"language":"Dutch","location":"Netherlands","id":1043,"tag":"nl-NL","version":"Release A"},"nl-sx":{"language":"Dutch","location":"Sint Maarten","id":4096,"tag":"nl-SX","version":"Release 10"},"nl-sr":{"language":"Dutch","location":"Suriname","id":4096,"tag":"nl-SR","version":"Release 10"},"dz":{"language":"Dzongkha","location":null,"id":4096,"tag":"dz","version":"Release 10"},"dz-bt":{"language":"Dzongkha","location":"Bhutan","id":3153,"tag":"dz-BT","version":"Release 10"},"ebu":{"language":"Embu","location":null,"id":4096,"tag":"ebu","version":"Release 10"},"ebu-ke":{"language":"Embu","location":"Kenya","id":4096,"tag":"ebu-KE","version":"Release 10"},"en":{"language":"English","location":null,"id":9,"tag":"en","version":"Release 7"},"en-as":{"language":"English","location":"American Samoa","id":4096,"tag":"en-AS","version":"Release 10"},"en-ai":{"language":"English","location":"Anguilla","id":4096,"tag":"en-AI","version":"Release 10"},"en-ag":{"language":"English","location":"Antigua and Barbuda","id":4096,"tag":"en-AG","version":"Release 10"},"en-au":{"language":"English","location":"Australia","id":3081,"tag":"en-AU","version":"Release A"},"en-at":{"language":"English","location":"Austria","id":4096,"tag":"en-AT","version":"Release 10.1"},"en-bs":{"language":"English","location":"Bahamas","id":4096,"tag":"en-BS","version":"Release 10"},"en-bb":{"language":"English","location":"Barbados","id":4096,"tag":"en-BB","version":"Release 10"},"en-be":{"language":"English","location":"Belgium","id":4096,"tag":"en-BE","version":"Release 10"},"en-bz":{"language":"English","location":"Belize","id":10249,"tag":"en-BZ","version":"Release B"},"en-bm":{"language":"English","location":"Bermuda","id":4096,"tag":"en-BM","version":"Release 10"},"en-bw":{"language":"English","location":"Botswana","id":4096,"tag":"en-BW","version":"Release 10"},"en-io":{"language":"English","location":"British Indian Ocean Territory","id":4096,"tag":"en-IO","version":"Release 10"},"en-vg":{"language":"English","location":"British Virgin Islands","id":4096,"tag":"en-VG","version":"Release 10"},"en-bi":{"language":"English","location":"Burundi","id":4096,"tag":"en-BI","version":"Release 10.1"},"en-cm":{"language":"English","location":"Cameroon","id":4096,"tag":"en-CM","version":"Release 10"},"en-ca":{"language":"English","location":"Canada","id":4105,"tag":"en-CA","version":"Release A"},"en-029":{"language":"English","location":"Caribbean","id":9225,"tag":"en-029","version":"Release B"},"en-ky":{"language":"English","location":"Cayman Islands","id":4096,"tag":"en-KY","version":"Release 10"},"en-cx":{"language":"English","location":"Christmas Island","id":4096,"tag":"en-CX","version":"Release 10"},"en-cc":{"language":"English","location":"Cocos [Keeling] Islands","id":4096,"tag":"en-CC","version":"Release 10"},"en-ck":{"language":"English","location":"Cook Islands","id":4096,"tag":"en-CK","version":"Release 10"},"en-cy":{"language":"English","location":"Cyprus","id":4096,"tag":"en-CY","version":"Release 10.1"},"en-dk":{"language":"English","location":"Denmark","id":4096,"tag":"en-DK","version":"Release 10.1"},"en-dm":{"language":"English","location":"Dominica","id":4096,"tag":"en-DM","version":"Release 10"},"en-er":{"language":"English","location":"Eritrea","id":4096,"tag":"en-ER","version":"Release 10"},"en-150":{"language":"English","location":"Europe","id":4096,"tag":"en-150","version":"Release 10"},"en-fk":{"language":"English","location":"Falkland Islands","id":4096,"tag":"en-FK","version":"Release 10"},"en-fi":{"language":"English","location":"Finland","id":4096,"tag":"en-FI","version":"Release 10.1"},"en-fj":{"language":"English","location":"Fiji","id":4096,"tag":"en-FJ","version":"Release 10"},"en-gm":{"language":"English","location":"Gambia","id":4096,"tag":"en-GM","version":"Release 10"},"en-de":{"language":"English","location":"Germany","id":4096,"tag":"en-DE","version":"Release 10.1"},"en-gh":{"language":"English","location":"Ghana","id":4096,"tag":"en-GH","version":"Release 10"},"en-gi":{"language":"English","location":"Gibraltar","id":4096,"tag":"en-GI","version":"Release 10"},"en-gd":{"language":"English","location":"Grenada","id":4096,"tag":"en-GD","version":"Release 10"},"en-gu":{"language":"English","location":"Guam","id":4096,"tag":"en-GU","version":"Release 10"},"en-gg":{"language":"English","location":"Guernsey","id":4096,"tag":"en-GG","version":"Release 10"},"en-gy":{"language":"English","location":"Guyana","id":4096,"tag":"en-GY","version":"Release 10"},"en-hk":{"language":"English","location":"Hong Kong","id":15369,"tag":"en-HK","version":"Release 8.1"},"en-in":{"language":"English","location":"India","id":16393,"tag":"en-IN","version":"Release V"},"en-ie":{"language":"English","location":"Ireland","id":6153,"tag":"en-IE","version":"Release A"},"en-im":{"language":"English","location":"Isle of Man","id":4096,"tag":"en-IM","version":"Release 10"},"en-il":{"language":"English","location":"Israel","id":4096,"tag":"en-IL","version":"Release 10.1"},"en-jm":{"language":"English","location":"Jamaica","id":8201,"tag":"en-JM","version":"Release B"},"en-je":{"language":"English","location":"Jersey","id":4096,"tag":"en-JE","version":"Release 10"},"en-ke":{"language":"English","location":"Kenya","id":4096,"tag":"en-KE","version":"Release 10"},"en-ki":{"language":"English","location":"Kiribati","id":4096,"tag":"en-KI","version":"Release 10"},"en-ls":{"language":"English","location":"Lesotho","id":4096,"tag":"en-LS","version":"Release 10"},"en-lr":{"language":"English","location":"Liberia","id":4096,"tag":"en-LR","version":"Release 10"},"en-mo":{"language":"English","location":"Macao SAR","id":4096,"tag":"en-MO","version":"Release 10"},"en-mg":{"language":"English","location":"Madagascar","id":4096,"tag":"en-MG","version":"Release 10"},"en-mw":{"language":"English","location":"Malawi","id":4096,"tag":"en-MW","version":"Release 10"},"en-my":{"language":"English","location":"Malaysia","id":17417,"tag":"en-MY","version":"Release V"},"en-mt":{"language":"English","location":"Malta","id":4096,"tag":"en-MT","version":"Release 10"},"en-mh":{"language":"English","location":"Marshall Islands","id":4096,"tag":"en-MH","version":"Release 10"},"en-mu":{"language":"English","location":"Mauritius","id":4096,"tag":"en-MU","version":"Release 10"},"en-fm":{"language":"English","location":"Micronesia","id":4096,"tag":"en-FM","version":"Release 10"},"en-ms":{"language":"English","location":"Montserrat","id":4096,"tag":"en-MS","version":"Release 10"},"en-na":{"language":"English","location":"Namibia","id":4096,"tag":"en-NA","version":"Release 10"},"en-nr":{"language":"English","location":"Nauru","id":4096,"tag":"en-NR","version":"Release 10"},"en-nl":{"language":"English","location":"Netherlands","id":4096,"tag":"en-NL","version":"Release 10.1"},"en-nz":{"language":"English","location":"New Zealand","id":5129,"tag":"en-NZ","version":"Release A"},"en-ng":{"language":"English","location":"Nigeria","id":4096,"tag":"en-NG","version":"Release 10"},"en-nu":{"language":"English","location":"Niue","id":4096,"tag":"en-NU","version":"Release 10"},"en-nf":{"language":"English","location":"Norfolk Island","id":4096,"tag":"en-NF","version":"Release 10"},"en-mp":{"language":"English","location":"Northern Mariana Islands","id":4096,"tag":"en-MP","version":"Release 10"},"en-pk":{"language":"English","location":"Pakistan","id":4096,"tag":"en-PK","version":"Release 10"},"en-pw":{"language":"English","location":"Palau","id":4096,"tag":"en-PW","version":"Release 10"},"en-pg":{"language":"English","location":"Papua New Guinea","id":4096,"tag":"en-PG","version":"Release 10"},"en-pn":{"language":"English","location":"Pitcairn Islands","id":4096,"tag":"en-PN","version":"Release 10"},"en-pr":{"language":"English","location":"Puerto Rico","id":4096,"tag":"en-PR","version":"Release 10"},"en-ph":{"language":"English","location":"Republic of the Philippines","id":13321,"tag":"en-PH","version":"Release C"},"en-rw":{"language":"English","location":"Rwanda","id":4096,"tag":"en-RW","version":"Release 10"},"en-kn":{"language":"English","location":"Saint Kitts and Nevis","id":4096,"tag":"en-KN","version":"Release 10"},"en-lc":{"language":"English","location":"Saint Lucia","id":4096,"tag":"en-LC","version":"Release 10"},"en-vc":{"language":"English","location":"Saint Vincent and the Grenadines","id":4096,"tag":"en-VC","version":"Release 10"},"en-ws":{"language":"English","location":"Samoa","id":4096,"tag":"en-WS","version":"Release 10"},"en-sc":{"language":"English","location":"Seychelles","id":4096,"tag":"en-SC","version":"Release 10"},"en-sl":{"language":"English","location":"Sierra Leone","id":4096,"tag":"en-SL","version":"Release 10"},"en-sg":{"language":"English","location":"Singapore","id":18441,"tag":"en-SG","version":"Release V"},"en-sx":{"language":"English","location":"Sint Maarten","id":4096,"tag":"en-SX","version":"Release 10"},"en-si":{"language":"English","location":"Slovenia","id":4096,"tag":"en-SI","version":"Release 10.1"},"en-sb":{"language":"English","location":"Solomon Islands","id":4096,"tag":"en-SB","version":"Release 10"},"en-za":{"language":"English","location":"South Africa","id":7177,"tag":"en-ZA","version":"Release B"},"en-ss":{"language":"English","location":"South Sudan","id":4096,"tag":"en-SS","version":"Release 10"},"en-sh":{"language":"English","location":"St Helena, Ascension,  Tristan da Cunha","id":4096,"tag":"en-SH","version":"Release 10"},"en-sd":{"language":"English","location":"Sudan","id":4096,"tag":"en-SD","version":"Release 10"},"en-sz":{"language":"English","location":"Swaziland","id":4096,"tag":"en-SZ","version":"Release 10"},"en-se":{"language":"English","location":"Sweden","id":4096,"tag":"en-SE","version":"Release 10.1"},"en-ch":{"language":"English","location":"Switzerland","id":4096,"tag":"en-CH","version":"Release 10.1"},"en-tz":{"language":"English","location":"Tanzania","id":4096,"tag":"en-TZ","version":"Release 10"},"en-tk":{"language":"English","location":"Tokelau","id":4096,"tag":"en-TK","version":"Release 10"},"en-to":{"language":"English","location":"Tonga","id":4096,"tag":"en-TO","version":"Release 10"},"en-tt":{"language":"English","location":"Trinidad and Tobago","id":11273,"tag":"en-TT","version":"Release B"},"en-tc":{"language":"English","location":"Turks and Caicos Islands","id":4096,"tag":"en-TC","version":"Release 10"},"en-tv":{"language":"English","location":"Tuvalu","id":4096,"tag":"en-TV","version":"Release 10"},"en-ug":{"language":"English","location":"Uganda","id":4096,"tag":"en-UG","version":"Release 10"},"en-ae":{"language":"English","location":"United Arab Emirates","id":19465,"tag":"en-AE","version":"Release 10.5"},"en-gb":{"language":"English","location":"United Kingdom","id":2057,"tag":"en-GB","version":"Release A"},"en-us":{"language":"English","location":"United States","id":1033,"tag":"en-US","version":"Release A"},"en-um":{"language":"English","location":"US Minor Outlying Islands","id":4096,"tag":"en-UM","version":"Release 10"},"en-vi":{"language":"English","location":"US Virgin Islands","id":4096,"tag":"en-VI","version":"Release 10"},"en-vu":{"language":"English","location":"Vanuatu","id":4096,"tag":"en-VU","version":"Release 10"},"en-001":{"language":"English","location":"World","id":4096,"tag":"en-001","version":"Release 10"},"en-zm":{"language":"English","location":"Zambia","id":4096,"tag":"en-ZM","version":"Release 10"},"en-zw":{"language":"English","location":"Zimbabwe","id":12297,"tag":"en-ZW","version":"Release C"},"eo":{"language":"Esperanto","location":null,"id":4096,"tag":"eo","version":"Release 10"},"eo-001":{"language":"Esperanto","location":"World","id":4096,"tag":"eo-001","version":"Release 10"},"et":{"language":"Estonian","location":null,"id":37,"tag":"et","version":"Release 7"},"et-ee":{"language":"Estonian","location":"Estonia","id":1061,"tag":"et-EE","version":"Release B"},"ee":{"language":"Ewe","location":null,"id":4096,"tag":"ee","version":"Release 10"},"ee-gh":{"language":"Ewe","location":"Ghana","id":4096,"tag":"ee-GH","version":"Release 10"},"ee-tg":{"language":"Ewe","location":"Togo","id":4096,"tag":"ee-TG","version":"Release 10"},"ewo":{"language":"Ewondo","location":null,"id":4096,"tag":"ewo","version":"Release 10"},"ewo-cm":{"language":"Ewondo","location":"Cameroon","id":4096,"tag":"ewo-CM","version":"Release 10"},"fo":{"language":"Faroese","location":null,"id":56,"tag":"fo","version":"Release 7"},"fo-dk":{"language":"Faroese","location":"Denmark","id":4096,"tag":"fo-DK","version":"Release 10.1"},"fo-fo":{"language":"Faroese","location":"Faroe Islands","id":1080,"tag":"fo-FO","version":"Release B"},"fil":{"language":"Filipino","location":null,"id":100,"tag":"fil","version":"Release 7"},"fil-ph":{"language":"Filipino","location":"Philippines","id":1124,"tag":"fil-PH","version":"Release E2"},"fi":{"language":"Finnish","location":null,"id":11,"tag":"fi","version":"Release 7"},"fi-fi":{"language":"Finnish","location":"Finland","id":1035,"tag":"fi-FI","version":"Release A"},"fr":{"language":"French","location":null,"id":12,"tag":"fr","version":"Release 7"},"fr-dz":{"language":"French","location":"Algeria","id":4096,"tag":"fr-DZ","version":"Release 10"},"fr-be":{"language":"French","location":"Belgium","id":2060,"tag":"fr-BE","version":"Release A"},"fr-bj":{"language":"French","location":"Benin","id":4096,"tag":"fr-BJ","version":"Release 10"},"fr-bf":{"language":"French","location":"Burkina Faso","id":4096,"tag":"fr-BF","version":"Release 10"},"fr-bi":{"language":"French","location":"Burundi","id":4096,"tag":"fr-BI","version":"Release 10"},"fr-cm":{"language":"French","location":"Cameroon","id":11276,"tag":"fr-CM","version":"Release 8.1"},"fr-ca":{"language":"French","location":"Canada","id":3084,"tag":"fr-CA","version":"Release A"},"fr-cf":{"language":"French","location":"Central African Republic","id":4096,"tag":"fr-CF","version":"Release10"},"fr-td":{"language":"French","location":"Chad","id":4096,"tag":"fr-TD","version":"Release 10"},"fr-km":{"language":"French","location":"Comoros","id":4096,"tag":"fr-KM","version":"Release 10"},"fr-cg":{"language":"French","location":"Congo","id":4096,"tag":"fr-CG","version":"Release 10"},"fr-cd":{"language":"French","location":"Congo, DRC","id":9228,"tag":"fr-CD","version":"Release 8.1"},"fr-ci":{"language":"French","location":"Côte d'Ivoire","id":12300,"tag":"fr-CI","version":"Release 8.1"},"fr-dj":{"language":"French","location":"Djibouti","id":4096,"tag":"fr-DJ","version":"Release 10"},"fr-gq":{"language":"French","location":"Equatorial Guinea","id":4096,"tag":"fr-GQ","version":"Release 10"},"fr-fr":{"language":"French","location":"France","id":1036,"tag":"fr-FR","version":"Release A"},"fr-gf":{"language":"French","location":"French Guiana","id":4096,"tag":"fr-GF","version":"Release 10"},"fr-pf":{"language":"French","location":"French Polynesia","id":4096,"tag":"fr-PF","version":"Release 10"},"fr-ga":{"language":"French","location":"Gabon","id":4096,"tag":"fr-GA","version":"Release 10"},"fr-gp":{"language":"French","location":"Guadeloupe","id":4096,"tag":"fr-GP","version":"Release 10"},"fr-gn":{"language":"French","location":"Guinea","id":4096,"tag":"fr-GN","version":"Release 10"},"fr-ht":{"language":"French","location":"Haiti","id":15372,"tag":"fr-HT","version":"Release 8.1"},"fr-lu":{"language":"French","location":"Luxembourg","id":5132,"tag":"fr-LU","version":"Release A"},"fr-mg":{"language":"French","location":"Madagascar","id":4096,"tag":"fr-MG","version":"Release 10"},"fr-ml":{"language":"French","location":"Mali","id":13324,"tag":"fr-ML","version":"Release 8.1"},"fr-mq":{"language":"French","location":"Martinique","id":4096,"tag":"fr-MQ","version":"Release 10"},"fr-mr":{"language":"French","location":"Mauritania","id":4096,"tag":"fr-MR","version":"Release 10"},"fr-mu":{"language":"French","location":"Mauritius","id":4096,"tag":"fr-MU","version":"Release 10"},"fr-yt":{"language":"French","location":"Mayotte","id":4096,"tag":"fr-YT","version":"Release 10"},"fr-ma":{"language":"French","location":"Morocco","id":14348,"tag":"fr-MA","version":"Release 8.1"},"fr-nc":{"language":"French","location":"New Caledonia","id":4096,"tag":"fr-NC","version":"Release 10"},"fr-ne":{"language":"French","location":"Niger","id":4096,"tag":"fr-NE","version":"Release 10"},"fr-mc":{"language":"French","location":"Principality of Monaco","id":6156,"tag":"fr-MC","version":"Release A"},"fr-re":{"language":"French","location":"Reunion","id":8204,"tag":"fr-RE","version":"Release 8.1"},"fr-rw":{"language":"French","location":"Rwanda","id":4096,"tag":"fr-RW","version":"Release 10"},"fr-bl":{"language":"French","location":"Saint Barthélemy","id":4096,"tag":"fr-BL","version":"Release 10"},"fr-mf":{"language":"French","location":"Saint Martin","id":4096,"tag":"fr-MF","version":"Release 10"},"fr-pm":{"language":"French","location":"Saint Pierre and Miquelon","id":4096,"tag":"fr-PM","version":"Release 10"},"fr-sn":{"language":"French","location":"Senegal","id":10252,"tag":"fr-SN","version":"Release 8.1"},"fr-sc":{"language":"French","location":"Seychelles","id":4096,"tag":"fr-SC","version":"Release 10"},"fr-ch":{"language":"French","location":"Switzerland","id":4108,"tag":"fr-CH","version":"Release A"},"fr-sy":{"language":"French","location":"Syria","id":4096,"tag":"fr-SY","version":"Release 10"},"fr-tg":{"language":"French","location":"Togo","id":4096,"tag":"fr-TG","version":"Release 10"},"fr-tn":{"language":"French","location":"Tunisia","id":4096,"tag":"fr-TN","version":"Release 10"},"fr-vu":{"language":"French","location":"Vanuatu","id":4096,"tag":"fr-VU","version":"Release 10"},"fr-wf":{"language":"French","location":"Wallis and Futuna","id":4096,"tag":"fr-WF","version":"Release 10"},"fy":{"language":"Frisian","location":null,"id":98,"tag":"fy","version":"Release 7"},"fy-nl":{"language":"Frisian","location":"Netherlands","id":1122,"tag":"fy-NL","version":"Release E2"},"fur":{"language":"Friulian","location":null,"id":4096,"tag":"fur","version":"Release 10"},"fur-it":{"language":"Friulian","location":"Italy","id":4096,"tag":"fur-IT","version":"Release 10"},"ff":{"language":"Fulah","location":null,"id":103,"tag":"ff","version":"Release 8"},"ff-latn":{"language":"Fulah (Latin)","location":null,"id":31847,"tag":"ff-Latn","version":"Release 8"},"ff-latn-bf":{"language":"Fulah (Latin)","location":"Burkina Faso","id":4096,"tag":"ff-Latn-BF","version":"Release 10.4"},"ff-cm":{"language":"Fulah","location":"Cameroon","id":4096,"tag":"ff-CM","version":"Release 10"},"ff-latn-cm":{"language":"Fulah (Latin)","location":"Cameroon","id":4096,"tag":"ff-Latn-CM","version":"Release 10.4"},"ff-latn-gm":{"language":"Fulah (Latin)","location":"Gambia","id":4096,"tag":"ff-Latn-GM","version":"Release 10.4"},"ff-latn-gh":{"language":"Fulah (Latin)","location":"Ghana","id":4096,"tag":"ff-Latn-GH","version":"Release 10.4"},"ff-gn":{"language":"Fulah","location":"Guinea","id":4096,"tag":"ff-GN","version":"Release 10"},"ff-latn-gn":{"language":"Fulah (Latin)","location":"Guinea","id":4096,"tag":"ff-Latn-GN","version":"Release 10.4"},"ff-latn-gw":{"language":"Fulah (Latin)","location":"Guinea-Bissau","id":4096,"tag":"ff-Latn-GW","version":"Release 10.4"},"ff-latn-lr":{"language":"Fulah (Latin)","location":"Liberia","id":4096,"tag":"ff-Latn-LR","version":"Release 10.4"},"ff-mr":{"language":"Fulah","location":"Mauritania","id":4096,"tag":"ff-MR","version":"Release 10"},"ff-latn-mr":{"language":"Fulah (Latin)","location":"Mauritania","id":4096,"tag":"ff-Latn-MR","version":"Release 10.4"},"ff-latn-ne":{"language":"Fulah (Latin)","location":"Niger","id":4096,"tag":"ff-Latn-NE","version":"Release 10.4"},"ff-ng":{"language":"Fulah","location":"Nigeria","id":4096,"tag":"ff-NG","version":"Release 10"},"ff-latn-ng":{"language":"Fulah (Latin)","location":"Nigeria","id":4096,"tag":"ff-Latn-NG","version":"Release 10.4"},"ff-latn-sn":{"language":"Fulah","location":"Senegal","id":2151,"tag":"ff-Latn-SN","version":"Release 8"},"ff-latn-sl":{"language":"Fulah (Latin)","location":"Sierra Leone","id":4096,"tag":"ff-Latn-SL","version":"Release 10.4"},"gl":{"language":"Galician","location":null,"id":86,"tag":"gl","version":"Release 7"},"gl-es":{"language":"Galician","location":"Spain","id":1110,"tag":"gl-ES","version":"Release D"},"lg":{"language":"Ganda","location":null,"id":4096,"tag":"lg","version":"Release 10"},"lg-ug":{"language":"Ganda","location":"Uganda","id":4096,"tag":"lg-UG","version":"Release 10"},"ka":{"language":"Georgian","location":null,"id":55,"tag":"ka","version":"Release 7"},"ka-ge":{"language":"Georgian","location":"Georgia","id":1079,"tag":"ka-GE","version":"Release C"},"de":{"language":"German","location":null,"id":7,"tag":"de","version":"Release 7"},"de-at":{"language":"German","location":"Austria","id":3079,"tag":"de-AT","version":"Release A"},"de-be":{"language":"German","location":"Belgium","id":4096,"tag":"de-BE","version":"Release 10"},"de-de":{"language":"German","location":"Germany","id":1031,"tag":"de-DE","version":"Release A"},"de-it":{"language":"German","location":"Italy","id":4096,"tag":"de-IT","version":"Release 10.2"},"de-li":{"language":"German","location":"Liechtenstein","id":5127,"tag":"de-LI","version":"Release B"},"de-lu":{"language":"German","location":"Luxembourg","id":4103,"tag":"de-LU","version":"Release B"},"de-ch":{"language":"German","location":"Switzerland","id":2055,"tag":"de-CH","version":"Release A"},"el":{"language":"Greek","location":null,"id":8,"tag":"el","version":"Release 7"},"el-cy":{"language":"Greek","location":"Cyprus","id":4096,"tag":"el-CY","version":"Release 10"},"el-gr":{"language":"Greek","location":"Greece","id":1032,"tag":"el-GR","version":"Release A"},"kl":{"language":"Greenlandic","location":null,"id":111,"tag":"kl","version":"Release 7"},"kl-gl":{"language":"Greenlandic","location":"Greenland","id":1135,"tag":"kl-GL","version":"Release V"},"gn":{"language":"Guarani","location":null,"id":116,"tag":"gn","version":"Release 8.1"},"gn-py":{"language":"Guarani","location":"Paraguay","id":1140,"tag":"gn-PY","version":"Release 8.1"},"gu":{"language":"Gujarati","location":null,"id":71,"tag":"gu","version":"Release 7"},"gu-in":{"language":"Gujarati","location":"India","id":1095,"tag":"gu-IN","version":"Release D"},"guz":{"language":"Gusii","location":null,"id":4096,"tag":"guz","version":"Release 10"},"guz-ke":{"language":"Gusii","location":"Kenya","id":4096,"tag":"guz-KE","version":"Release 10"},"ha":{"language":"Hausa (Latin)","location":null,"id":104,"tag":"ha","version":"Release 7"},"ha-latn":{"language":"Hausa (Latin)","location":null,"id":31848,"tag":"ha-Latn","version":"Windows 7"},"ha-latn-gh":{"language":"Hausa (Latin)","location":"Ghana","id":4096,"tag":"ha-Latn-GH","version":"Release 10"},"ha-latn-ne":{"language":"Hausa (Latin)","location":"Niger","id":4096,"tag":"ha-Latn-NE","version":"Release 10"},"ha-latn-ng":{"language":"Hausa (Latin)","location":"Nigeria","id":1128,"tag":"ha-Latn-NG","version":"Release V"},"haw":{"language":"Hawaiian","location":null,"id":117,"tag":"haw","version":"Release 8"},"haw-us":{"language":"Hawaiian","location":"United States","id":1141,"tag":"haw-US","version":"Release 8"},"he":{"language":"Hebrew","location":null,"id":13,"tag":"he","version":"Release 7"},"he-il":{"language":"Hebrew","location":"Israel","id":1037,"tag":"he-IL","version":"Release B"},"hi":{"language":"Hindi","location":null,"id":57,"tag":"hi","version":"Release 7"},"hi-in":{"language":"Hindi","location":"India","id":1081,"tag":"hi-IN","version":"Release C"},"hu":{"language":"Hungarian","location":null,"id":14,"tag":"hu","version":"Release 7"},"hu-hu":{"language":"Hungarian","location":"Hungary","id":1038,"tag":"hu-HU","version":"Release A"},"is":{"language":"Icelandic","location":null,"id":15,"tag":"is","version":"Release 7"},"is-is":{"language":"Icelandic","location":"Iceland","id":1039,"tag":"is-IS","version":"Release A"},"ig":{"language":"Igbo","location":null,"id":112,"tag":"ig","version":"Release 7"},"ig-ng":{"language":"Igbo","location":"Nigeria","id":1136,"tag":"ig-NG","version":"Release V"},"id":{"language":"Indonesian","location":null,"id":33,"tag":"id","version":"Release 7"},"id-id":{"language":"Indonesian","location":"Indonesia","id":1057,"tag":"id-ID","version":"Release B"},"ia":{"language":"Interlingua","location":null,"id":4096,"tag":"ia","version":"Release 10"},"ia-fr":{"language":"Interlingua","location":"France","id":4096,"tag":"ia-FR","version":"Release 10"},"ia-001":{"language":"Interlingua","location":"World","id":4096,"tag":"ia-001","version":"Release 10"},"iu":{"language":"Inuktitut (Latin)","location":null,"id":93,"tag":"iu","version":"Release 7"},"iu-latn":{"language":"Inuktitut (Latin)","location":null,"id":31837,"tag":"iu-Latn","version":"Windows 7"},"iu-latn-ca":{"language":"Inuktitut (Latin)","location":"Canada","id":2141,"tag":"iu-Latn-CA","version":"Release E2"},"iu-cans":{"language":"Inuktitut (Syllabics)","location":null,"id":30813,"tag":"iu-Cans","version":"Windows 7"},"iu-cans-ca":{"language":"Inuktitut (Syllabics)","location":"Canada","id":1117,"tag":"iu-Cans-CA","version":"Release V"},"ga":{"language":"Irish","location":null,"id":60,"tag":"ga","version":"Windows 7"},"ga-ie":{"language":"Irish","location":"Ireland","id":2108,"tag":"ga-IE","version":"Release E2"},"it":{"language":"Italian","location":null,"id":16,"tag":"it","version":"Release 7"},"it-it":{"language":"Italian","location":"Italy","id":1040,"tag":"it-IT","version":"Release A"},"it-sm":{"language":"Italian","location":"San Marino","id":4096,"tag":"it-SM","version":"Release 10"},"it-ch":{"language":"Italian","location":"Switzerland","id":2064,"tag":"it-CH","version":"Release A"},"it-va":{"language":"Italian","location":"Vatican City","id":4096,"tag":"it-VA","version":"Release 10.3"},"ja":{"language":"Japanese","location":null,"id":17,"tag":"ja","version":"Release 7"},"ja-jp":{"language":"Japanese","location":"Japan","id":1041,"tag":"ja-JP","version":"Release A"},"jv":{"language":"Javanese","location":null,"id":4096,"tag":"jv","version":"Release 8.1"},"jv-latn":{"language":"Javanese","location":"Latin","id":4096,"tag":"jv-Latn","version":"Release 8.1"},"jv-latn-id":{"language":"Javanese","location":"Latin, Indonesia","id":4096,"tag":"jv-Latn-ID","version":"Release 8.1"},"dyo":{"language":"Jola-Fonyi","location":null,"id":4096,"tag":"dyo","version":"Release 10"},"dyo-sn":{"language":"Jola-Fonyi","location":"Senegal","id":4096,"tag":"dyo-SN","version":"Release 10"},"kea":{"language":"Kabuverdianu","location":null,"id":4096,"tag":"kea","version":"Release 10"},"kea-cv":{"language":"Kabuverdianu","location":"Cabo Verde","id":4096,"tag":"kea-CV","version":"Release 10"},"kab":{"language":"Kabyle","location":null,"id":4096,"tag":"kab","version":"Release 10"},"kab-dz":{"language":"Kabyle","location":"Algeria","id":4096,"tag":"kab-DZ","version":"Release 10"},"kkj":{"language":"Kako","location":null,"id":4096,"tag":"kkj","version":"Release 10"},"kkj-cm":{"language":"Kako","location":"Cameroon","id":4096,"tag":"kkj-CM","version":"Release 10"},"kln":{"language":"Kalenjin","location":null,"id":4096,"tag":"kln","version":"Release 10"},"kln-ke":{"language":"Kalenjin","location":"Kenya","id":4096,"tag":"kln-KE","version":"Release 10"},"kam":{"language":"Kamba","location":null,"id":4096,"tag":"kam","version":"Release 10"},"kam-ke":{"language":"Kamba","location":"Kenya","id":4096,"tag":"kam-KE","version":"Release 10"},"kn":{"language":"Kannada","location":null,"id":75,"tag":"kn","version":"Release 7"},"kn-in":{"language":"Kannada","location":"India","id":1099,"tag":"kn-IN","version":"Release D"},"ks":{"language":"Kashmiri","location":null,"id":96,"tag":"ks","version":"Release 10"},"ks-arab":{"language":"Kashmiri","location":"Perso-Arabic","id":1120,"tag":"ks-Arab","version":"Release 10"},"ks-arab-in":{"language":"Kashmiri","location":"Perso-Arabic","id":4096,"tag":"ks-Arab-IN","version":"Release 10"},"kk":{"language":"Kazakh","location":null,"id":63,"tag":"kk","version":"Release 7"},"kk-kz":{"language":"Kazakh","location":"Kazakhstan","id":1087,"tag":"kk-KZ","version":"Release C"},"km":{"language":"Khmer","location":null,"id":83,"tag":"km","version":"Release 7"},"km-kh":{"language":"Khmer","location":"Cambodia","id":1107,"tag":"km-KH","version":"Release V"},"quc":{"language":"K'iche","location":null,"id":134,"tag":"quc","version":"Release 10"},"quc-latn-gt":{"language":"K'iche","location":"Guatemala","id":1158,"tag":"quc-Latn-GT","version":"Release 10"},"ki":{"language":"Kikuyu","location":null,"id":4096,"tag":"ki","version":"Release 10"},"ki-ke":{"language":"Kikuyu","location":"Kenya","id":4096,"tag":"ki-KE","version":"Release 10"},"rw":{"language":"Kinyarwanda","location":null,"id":135,"tag":"rw","version":"Release 7"},"rw-rw":{"language":"Kinyarwanda","location":"Rwanda","id":1159,"tag":"rw-RW","version":"Release V"},"sw":{"language":"Kiswahili","location":null,"id":65,"tag":"sw","version":"Release 7"},"sw-ke":{"language":"Kiswahili","location":"Kenya","id":1089,"tag":"sw-KE","version":"Release C"},"sw-tz":{"language":"Kiswahili","location":"Tanzania","id":4096,"tag":"sw-TZ","version":"Release 10"},"sw-ug":{"language":"Kiswahili","location":"Uganda","id":4096,"tag":"sw-UG","version":"Release 10"},"kok":{"language":"Konkani","location":null,"id":87,"tag":"kok","version":"Release 7"},"kok-in":{"language":"Konkani","location":"India","id":1111,"tag":"kok-IN","version":"Release C"},"ko":{"language":"Korean","location":null,"id":18,"tag":"ko","version":"Release 7"},"ko-kr":{"language":"Korean","location":"Korea","id":1042,"tag":"ko-KR","version":"Release A"},"ko-kp":{"language":"Korean","location":"North Korea","id":4096,"tag":"ko-KP","version":"Release 10.1"},"khq":{"language":"Koyra Chiini","location":null,"id":4096,"tag":"khq","version":"Release 10"},"khq-ml":{"language":"Koyra Chiini","location":"Mali","id":4096,"tag":"khq-ML","version":"Release 10"},"ses":{"language":"Koyraboro Senni","location":null,"id":4096,"tag":"ses","version":"Release 10"},"ses-ml":{"language":"Koyraboro Senni","location":"Mali","id":4096,"tag":"ses-ML","version":"Release 10"},"nmg":{"language":"Kwasio","location":null,"id":4096,"tag":"nmg","version":"Release 10"},"nmg-cm":{"language":"Kwasio","location":"Cameroon","id":4096,"tag":"nmg-CM","version":"Release 10"},"ky":{"language":"Kyrgyz","location":null,"id":64,"tag":"ky","version":"Release 7"},"ky-kg":{"language":"Kyrgyz","location":"Kyrgyzstan","id":1088,"tag":"ky-KG","version":"Release D"},"ku-arab-ir":{"language":"Kurdish","location":"Perso-Arabic, Iran","id":4096,"tag":"ku-Arab-IR","version":"Release 10.1"},"lkt":{"language":"Lakota","location":null,"id":4096,"tag":"lkt","version":"Release 10"},"lkt-us":{"language":"Lakota","location":"United States","id":4096,"tag":"lkt-US","version":"Release 10"},"lag":{"language":"Langi","location":null,"id":4096,"tag":"lag","version":"Release 10"},"lag-tz":{"language":"Langi","location":"Tanzania","id":4096,"tag":"lag-TZ","version":"Release 10"},"lo":{"language":"Lao","location":null,"id":84,"tag":"lo","version":"Release 7"},"lo-la":{"language":"Lao","location":"Lao P.D.R.","id":1108,"tag":"lo-LA","version":"Release V"},"lv":{"language":"Latvian","location":null,"id":38,"tag":"lv","version":"Release 7"},"lv-lv":{"language":"Latvian","location":"Latvia","id":1062,"tag":"lv-LV","version":"Release B"},"ln":{"language":"Lingala","location":null,"id":4096,"tag":"ln","version":"Release 10"},"ln-ao":{"language":"Lingala","location":"Angola","id":4096,"tag":"ln-AO","version":"Release 10"},"ln-cf":{"language":"Lingala","location":"Central African Republic","id":4096,"tag":"ln-CF","version":"Release 10"},"ln-cg":{"language":"Lingala","location":"Congo","id":4096,"tag":"ln-CG","version":"Release 10"},"ln-cd":{"language":"Lingala","location":"Congo DRC","id":4096,"tag":"ln-CD","version":"Release 10"},"lt":{"language":"Lithuanian","location":null,"id":39,"tag":"lt","version":"Release 7"},"lt-lt":{"language":"Lithuanian","location":"Lithuania","id":1063,"tag":"lt-LT","version":"Release B"},"nds":{"language":"Low German","location":null,"id":4096,"tag":"nds","version":"Release 10.2"},"nds-de":{"language":"Low German","location":"Germany","id":4096,"tag":"nds-DE","version":"Release 10.2"},"nds-nl":{"language":"Low German","location":"Netherlands","id":4096,"tag":"nds-NL","version":"Release 10.2"},"dsb":{"language":"Lower Sorbian","location":null,"id":31790,"tag":"dsb","version":"Windows 7"},"dsb-de":{"language":"Lower Sorbian","location":"Germany","id":2094,"tag":"dsb-DE","version":"Release V"},"lu":{"language":"Luba-Katanga","location":null,"id":4096,"tag":"lu","version":"Release 10"},"lu-cd":{"language":"Luba-Katanga","location":"Congo DRC","id":4096,"tag":"lu-CD","version":"Release 10"},"luo":{"language":"Luo","location":null,"id":4096,"tag":"luo","version":"Release 10"},"luo-ke":{"language":"Luo","location":"Kenya","id":4096,"tag":"luo-KE","version":"Release 10"},"lb":{"language":"Luxembourgish","location":null,"id":110,"tag":"lb","version":"Release 7"},"lb-lu":{"language":"Luxembourgish","location":"Luxembourg","id":1134,"tag":"lb-LU","version":"Release E2"},"luy":{"language":"Luyia","location":null,"id":4096,"tag":"luy","version":"Release 10"},"luy-ke":{"language":"Luyia","location":"Kenya","id":4096,"tag":"luy-KE","version":"Release 10"},"mk":{"language":"Macedonian","location":null,"id":47,"tag":"mk","version":"Release 7"},"mk-mk":{"language":"Macedonian","location":"North Macedonia","id":1071,"tag":"mk-MK","version":"Release C"},"jmc":{"language":"Machame","location":null,"id":4096,"tag":"jmc","version":"Release 10"},"jmc-tz":{"language":"Machame","location":"Tanzania","id":4096,"tag":"jmc-TZ","version":"Release 10"},"mgh":{"language":"Makhuwa-Meetto","location":null,"id":4096,"tag":"mgh","version":"Release 10"},"mgh-mz":{"language":"Makhuwa-Meetto","location":"Mozambique","id":4096,"tag":"mgh-MZ","version":"Release 10"},"kde":{"language":"Makonde","location":null,"id":4096,"tag":"kde","version":"Release 10"},"kde-tz":{"language":"Makonde","location":"Tanzania","id":4096,"tag":"kde-TZ","version":"Release 10"},"mg":{"language":"Malagasy","location":null,"id":4096,"tag":"mg","version":"Release 8.1"},"mg-mg":{"language":"Malagasy","location":"Madagascar","id":4096,"tag":"mg-MG","version":"Release 8.1"},"ms":{"language":"Malay","location":null,"id":62,"tag":"ms","version":"Release 7"},"ms-bn":{"language":"Malay","location":"Brunei Darussalam","id":2110,"tag":"ms-BN","version":"Release C"},"ms-my":{"language":"Malay","location":"Malaysia","id":1086,"tag":"ms-MY","version":"Release C"},"ml":{"language":"Malayalam","location":null,"id":76,"tag":"ml","version":"Release 7"},"ml-in":{"language":"Malayalam","location":"India","id":1100,"tag":"ml-IN","version":"Release E1"},"mt":{"language":"Maltese","location":null,"id":58,"tag":"mt","version":"Release 7"},"mt-mt":{"language":"Maltese","location":"Malta","id":1082,"tag":"mt-MT","version":"Release E1"},"gv":{"language":"Manx","location":null,"id":4096,"tag":"gv","version":"Release 10"},"gv-im":{"language":"Manx","location":"Isle of Man","id":4096,"tag":"gv-IM","version":"Release 10"},"mi":{"language":"Maori","location":null,"id":129,"tag":"mi","version":"Release 7"},"mi-nz":{"language":"Maori","location":"New Zealand","id":1153,"tag":"mi-NZ","version":"Release E1"},"arn":{"language":"Mapudungun","location":null,"id":122,"tag":"arn","version":"Release 7"},"arn-cl":{"language":"Mapudungun","location":"Chile","id":1146,"tag":"arn-CL","version":"Release E2"},"mr":{"language":"Marathi","location":null,"id":78,"tag":"mr","version":"Release 7"},"mr-in":{"language":"Marathi","location":"India","id":1102,"tag":"mr-IN","version":"Release C"},"mas":{"language":"Masai","location":null,"id":4096,"tag":"mas","version":"Release 10"},"mas-ke":{"language":"Masai","location":"Kenya","id":4096,"tag":"mas-KE","version":"Release 10"},"mas-tz":{"language":"Masai","location":"Tanzania","id":4096,"tag":"mas-TZ","version":"Release 10"},"mzn-ir":{"language":"Mazanderani","location":"Iran","id":4096,"tag":"mzn-IR","version":"Release 10.1"},"mer":{"language":"Meru","location":null,"id":4096,"tag":"mer","version":"Release 10"},"mer-ke":{"language":"Meru","location":"Kenya","id":4096,"tag":"mer-KE","version":"Release 10"},"mgo":{"language":"Meta'","location":null,"id":4096,"tag":"mgo","version":"Release 10"},"mgo-cm":{"language":"Meta'","location":"Cameroon","id":4096,"tag":"mgo-CM","version":"Release 10"},"moh":{"language":"Mohawk","location":null,"id":124,"tag":"moh","version":"Release 7"},"moh-ca":{"language":"Mohawk","location":"Canada","id":1148,"tag":"moh-CA","version":"Release E2"},"mn":{"language":"Mongolian (Cyrillic)","location":null,"id":80,"tag":"mn","version":"Release 7"},"mn-cyrl":{"language":"Mongolian (Cyrillic)","location":null,"id":30800,"tag":"mn-Cyrl","version":"Windows 7"},"mn-mn":{"language":"Mongolian (Cyrillic)","location":"Mongolia","id":1104,"tag":"mn-MN","version":"Release D"},"mn-mong":{"language":"Mongolian (Traditional Mongolian)","location":null,"id":31824,"tag":"mn-Mong","version":"Windows 7"},"mn-mong-cn":{"language":"Mongolian (Traditional Mongolian)","location":"People's Republic of China","id":2128,"tag":"mn-Mong-CN","version":"Windows V"},"mn-mong-mn":{"language":"Mongolian (Traditional Mongolian)","location":"Mongolia","id":3152,"tag":"mn-Mong-MN","version":"Windows 7"},"mfe":{"language":"Morisyen","location":null,"id":4096,"tag":"mfe","version":"Release 10"},"mfe-mu":{"language":"Morisyen","location":"Mauritius","id":4096,"tag":"mfe-MU","version":"Release 10"},"mua":{"language":"Mundang","location":null,"id":4096,"tag":"mua","version":"Release 10"},"mua-cm":{"language":"Mundang","location":"Cameroon","id":4096,"tag":"mua-CM","version":"Release 10"},"nqo":{"language":"N'ko","location":null,"id":4096,"tag":"nqo","version":"Release 8.1"},"nqo-gn":{"language":"N'ko","location":"Guinea","id":4096,"tag":"nqo-GN","version":"Release 8.1"},"naq":{"language":"Nama","location":null,"id":4096,"tag":"naq","version":"Release 10"},"naq-na":{"language":"Nama","location":"Namibia","id":4096,"tag":"naq-NA","version":"Release 10"},"ne":{"language":"Nepali","location":null,"id":97,"tag":"ne","version":"Release 7"},"ne-in":{"language":"Nepali","location":"India","id":2145,"tag":"ne-IN","version":"Release 8.1"},"ne-np":{"language":"Nepali","location":"Nepal","id":1121,"tag":"ne-NP","version":"Release E2"},"nnh":{"language":"Ngiemboon","location":null,"id":4096,"tag":"nnh","version":"Release 10"},"nnh-cm":{"language":"Ngiemboon","location":"Cameroon","id":4096,"tag":"nnh-CM","version":"Release 10"},"jgo":{"language":"Ngomba","location":null,"id":4096,"tag":"jgo","version":"Release 10"},"jgo-cm":{"language":"Ngomba","location":"Cameroon","id":4096,"tag":"jgo-CM","version":"Release 10"},"lrc-iq":{"language":"Northern Luri","location":"Iraq","id":4096,"tag":"lrc-IQ","version":"Release 10.1"},"lrc-ir":{"language":"Northern Luri","location":"Iran","id":4096,"tag":"lrc-IR","version":"Release 10.1"},"nd":{"language":"North Ndebele","location":null,"id":4096,"tag":"nd","version":"Release 10"},"nd-zw":{"language":"North Ndebele","location":"Zimbabwe","id":4096,"tag":"nd-ZW","version":"Release 10"},"no":{"language":"Norwegian (Bokmal)","location":null,"id":20,"tag":"no","version":"Release 7"},"nb":{"language":"Norwegian (Bokmal)","location":null,"id":31764,"tag":"nb","version":"Release 7"},"nb-no":{"language":"Norwegian (Bokmal)","location":"Norway","id":1044,"tag":"nb-NO","version":"Release A"},"nn":{"language":"Norwegian (Nynorsk)","location":null,"id":30740,"tag":"nn","version":"Release 7"},"nn-no":{"language":"Norwegian (Nynorsk)","location":"Norway","id":2068,"tag":"nn-NO","version":"Release A"},"nb-sj":{"language":"Norwegian Bokmål","location":"Svalbard and Jan Mayen","id":4096,"tag":"nb-SJ","version":"Release 10"},"nus":{"language":"Nuer","location":null,"id":4096,"tag":"nus","version":"Release 10"},"nus-sd":{"language":"Nuer","location":"Sudan","id":4096,"tag":"nus-SD","version":"Release 10"},"nus-ss":{"language":"Nuer","location":"South Sudan","id":4096,"tag":"nus-SS","version":"Release 10.1"},"nyn":{"language":"Nyankole","location":null,"id":4096,"tag":"nyn","version":"Release 10"},"nyn-ug":{"language":"Nyankole","location":"Uganda","id":4096,"tag":"nyn-UG","version":"Release 10"},"oc":{"language":"Occitan","location":null,"id":130,"tag":"oc","version":"Release 7"},"oc-fr":{"language":"Occitan","location":"France","id":1154,"tag":"oc-FR","version":"Release V"},"or":{"language":"Odia","location":null,"id":72,"tag":"or","version":"Release 7"},"or-in":{"language":"Odia","location":"India","id":1096,"tag":"or-IN","version":"Release V"},"om":{"language":"Oromo","location":null,"id":114,"tag":"om","version":"Release 8.1"},"om-et":{"language":"Oromo","location":"Ethiopia","id":1138,"tag":"om-ET","version":"Release 8.1"},"om-ke":{"language":"Oromo","location":"Kenya","id":4096,"tag":"om-KE","version":"Release 10"},"os":{"language":"Ossetian","location":null,"id":4096,"tag":"os","version":"Release 10"},"os-ge":{"language":"Ossetian","location":"Cyrillic, Georgia","id":4096,"tag":"os-GE","version":"Release 10"},"os-ru":{"language":"Ossetian","location":"Cyrillic, Russia","id":4096,"tag":"os-RU","version":"Release 10"},"ps":{"language":"Pashto","location":null,"id":99,"tag":"ps","version":"Release 7"},"ps-af":{"language":"Pashto","location":"Afghanistan","id":1123,"tag":"ps-AF","version":"Release E2"},"ps-pk":{"language":"Pashto","location":"Pakistan","id":4096,"tag":"ps-PK","version":"Release 10.5"},"fa":{"language":"Persian","location":null,"id":41,"tag":"fa","version":"Release 7"},"fa-af":{"language":"Persian","location":"Afghanistan","id":4096,"tag":"fa-AF","version":"Release 10"},"fa-ir":{"language":"Persian","location":"Iran","id":1065,"tag":"fa-IR","version":"Release B"},"pl":{"language":"Polish","location":null,"id":21,"tag":"pl","version":"Release 7"},"pl-pl":{"language":"Polish","location":"Poland","id":1045,"tag":"pl-PL","version":"Release A"},"pt":{"language":"Portuguese","location":null,"id":22,"tag":"pt","version":"Release 7"},"pt-ao":{"language":"Portuguese","location":"Angola","id":4096,"tag":"pt-AO","version":"Release 8.1"},"pt-br":{"language":"Portuguese","location":"Brazil","id":1046,"tag":"pt-BR","version":"Release A"},"pt-cv":{"language":"Portuguese","location":"Cabo Verde","id":4096,"tag":"pt-CV","version":"Release 10"},"pt-gq":{"language":"Portuguese","location":"Equatorial Guinea","id":4096,"tag":"pt-GQ","version":"Release 10.2"},"pt-gw":{"language":"Portuguese","location":"Guinea-Bissau","id":4096,"tag":"pt-GW","version":"Release 10"},"pt-lu":{"language":"Portuguese","location":"Luxembourg","id":4096,"tag":"pt-LU","version":"Release 10.2"},"pt-mo":{"language":"Portuguese","location":"Macao SAR","id":4096,"tag":"pt-MO","version":"Release 10"},"pt-mz":{"language":"Portuguese","location":"Mozambique","id":4096,"tag":"pt-MZ","version":"Release 10"},"pt-pt":{"language":"Portuguese","location":"Portugal","id":2070,"tag":"pt-PT","version":"Release A"},"pt-st":{"language":"Portuguese","location":"São Tomé and Príncipe","id":4096,"tag":"pt-ST","version":"Release 10"},"pt-ch":{"language":"Portuguese","location":"Switzerland","id":4096,"tag":"pt-CH","version":"Release 10.2"},"pt-tl":{"language":"Portuguese","location":"Timor-Leste","id":4096,"tag":"pt-TL","version":"Release 10"},"prg-001":{"language":"Prussian","location":null,"id":4096,"tag":"prg-001","version":"Release 10.1"},"qps-ploca":{"language":"Pseudo Language","location":"Pseudo locale for east Asian/complex script localization testing","id":1534,"tag":"qps-ploca","version":"Release 7"},"qps-ploc":{"language":"Pseudo Language","location":"Pseudo locale used for localization testing","id":1281,"tag":"qps-ploc","version":"Release 7"},"qps-plocm":{"language":"Pseudo Language","location":"Pseudo locale used for localization testing of mirrored locales","id":2559,"tag":"qps-plocm","version":"Release 7"},"pa":{"language":"Punjabi","location":null,"id":70,"tag":"pa","version":"Release 7"},"pa-arab":{"language":"Punjabi","location":null,"id":31814,"tag":"pa-Arab","version":"Release 8"},"pa-in":{"language":"Punjabi","location":"India","id":1094,"tag":"pa-IN","version":"Release D"},"pa-arab-pk":{"language":"Punjabi","location":"Islamic Republic of Pakistan","id":2118,"tag":"pa-Arab-PK","version":"Release 8"},"quz":{"language":"Quechua","location":null,"id":107,"tag":"quz","version":"Release 7"},"quz-bo":{"language":"Quechua","location":"Bolivia","id":1131,"tag":"quz-BO","version":"Release E1"},"quz-ec":{"language":"Quechua","location":"Ecuador","id":2155,"tag":"quz-EC","version":"Release E1"},"quz-pe":{"language":"Quechua","location":"Peru","id":3179,"tag":"quz-PE","version":"Release E1"},"ksh":{"language":"Ripuarian","location":null,"id":4096,"tag":"ksh","version":"Release 10"},"ksh-de":{"language":"Ripuarian","location":"Germany","id":4096,"tag":"ksh-DE","version":"Release 10"},"ro":{"language":"Romanian","location":null,"id":24,"tag":"ro","version":"Release 7"},"ro-md":{"language":"Romanian","location":"Moldova","id":2072,"tag":"ro-MD","version":"Release 8.1"},"ro-ro":{"language":"Romanian","location":"Romania","id":1048,"tag":"ro-RO","version":"Release A"},"rm":{"language":"Romansh","location":null,"id":23,"tag":"rm","version":"Release 7"},"rm-ch":{"language":"Romansh","location":"Switzerland","id":1047,"tag":"rm-CH","version":"Release E2"},"rof":{"language":"Rombo","location":null,"id":4096,"tag":"rof","version":"Release 10"},"rof-tz":{"language":"Rombo","location":"Tanzania","id":4096,"tag":"rof-TZ","version":"Release 10"},"rn":{"language":"Rundi","location":null,"id":4096,"tag":"rn","version":"Release 10"},"rn-bi":{"language":"Rundi","location":"Burundi","id":4096,"tag":"rn-BI","version":"Release 10"},"ru":{"language":"Russian","location":null,"id":25,"tag":"ru","version":"Release 7"},"ru-by":{"language":"Russian","location":"Belarus","id":4096,"tag":"ru-BY","version":"Release 10"},"ru-kz":{"language":"Russian","location":"Kazakhstan","id":4096,"tag":"ru-KZ","version":"Release 10"},"ru-kg":{"language":"Russian","location":"Kyrgyzstan","id":4096,"tag":"ru-KG","version":"Release 10"},"ru-md":{"language":"Russian","location":"Moldova","id":2073,"tag":"ru-MD","version":"Release 10"},"ru-ru":{"language":"Russian","location":"Russia","id":1049,"tag":"ru-RU","version":"Release A"},"ru-ua":{"language":"Russian","location":"Ukraine","id":4096,"tag":"ru-UA","version":"Release 10"},"rwk":{"language":"Rwa","location":null,"id":4096,"tag":"rwk","version":"Release 10"},"rwk-tz":{"language":"Rwa","location":"Tanzania","id":4096,"tag":"rwk-TZ","version":"Release 10"},"ssy":{"language":"Saho","location":null,"id":4096,"tag":"ssy","version":"Release 10"},"ssy-er":{"language":"Saho","location":"Eritrea","id":4096,"tag":"ssy-ER","version":"Release 10"},"sah":{"language":"Sakha","location":null,"id":133,"tag":"sah","version":"Release 7"},"sah-ru":{"language":"Sakha","location":"Russia","id":1157,"tag":"sah-RU","version":"Release V"},"saq":{"language":"Samburu","location":null,"id":4096,"tag":"saq","version":"Release 10"},"saq-ke":{"language":"Samburu","location":"Kenya","id":4096,"tag":"saq-KE","version":"Release 10"},"smn":{"language":"Sami (Inari)","location":null,"id":28731,"tag":"smn","version":"Windows 7"},"smn-fi":{"language":"Sami (Inari)","location":"Finland","id":9275,"tag":"smn-FI","version":"Release E1"},"smj":{"language":"Sami (Lule)","location":null,"id":31803,"tag":"smj","version":"Windows 7"},"smj-no":{"language":"Sami (Lule)","location":"Norway","id":4155,"tag":"smj-NO","version":"Release E1"},"smj-se":{"language":"Sami (Lule)","location":"Sweden","id":5179,"tag":"smj-SE","version":"Release E1"},"se":{"language":"Sami (Northern)","location":null,"id":59,"tag":"se","version":"Release 7"},"se-fi":{"language":"Sami (Northern)","location":"Finland","id":3131,"tag":"se-FI","version":"Release E1"},"se-no":{"language":"Sami (Northern)","location":"Norway","id":1083,"tag":"se-NO","version":"Release E1"},"se-se":{"language":"Sami (Northern)","location":"Sweden","id":2107,"tag":"se-SE","version":"Release E1"},"sms":{"language":"Sami (Skolt)","location":null,"id":29755,"tag":"sms","version":"Windows 7"},"sms-fi":{"language":"Sami (Skolt)","location":"Finland","id":8251,"tag":"sms-FI","version":"Release E1"},"sma":{"language":"Sami (Southern)","location":null,"id":30779,"tag":"sma","version":"Windows 7"},"sma-no":{"language":"Sami (Southern)","location":"Norway","id":6203,"tag":"sma-NO","version":"Release E1"},"sma-se":{"language":"Sami (Southern)","location":"Sweden","id":7227,"tag":"sma-SE","version":"Release E1"},"sg":{"language":"Sango","location":null,"id":4096,"tag":"sg","version":"Release 10"},"sg-cf":{"language":"Sango","location":"Central African Republic","id":4096,"tag":"sg-CF","version":"Release 10"},"sbp":{"language":"Sangu","location":null,"id":4096,"tag":"sbp","version":"Release 10"},"sbp-tz":{"language":"Sangu","location":"Tanzania","id":4096,"tag":"sbp-TZ","version":"Release 10"},"sa":{"language":"Sanskrit","location":null,"id":79,"tag":"sa","version":"Release 7"},"sa-in":{"language":"Sanskrit","location":"India","id":1103,"tag":"sa-IN","version":"Release C"},"gd":{"language":"Scottish Gaelic","location":null,"id":145,"tag":"gd","version":"Windows 7"},"gd-gb":{"language":"Scottish Gaelic","location":"United Kingdom","id":1169,"tag":"gd-GB","version":"Release 7"},"seh":{"language":"Sena","location":null,"id":4096,"tag":"seh","version":"Release 10"},"seh-mz":{"language":"Sena","location":"Mozambique","id":4096,"tag":"seh-MZ","version":"Release 10"},"sr-cyrl":{"language":"Serbian (Cyrillic)","location":null,"id":27674,"tag":"sr-Cyrl","version":"Windows 7"},"sr-cyrl-ba":{"language":"Serbian (Cyrillic)","location":"Bosnia and Herzegovina","id":7194,"tag":"sr-Cyrl-BA","version":"Release E1"},"sr-cyrl-me":{"language":"Serbian (Cyrillic)","location":"Montenegro","id":12314,"tag":"sr-Cyrl-ME","version":"Release 7"},"sr-cyrl-rs":{"language":"Serbian (Cyrillic)","location":"Serbia","id":10266,"tag":"sr-Cyrl-RS","version":"Release 7"},"sr-cyrl-cs":{"language":"Serbian (Cyrillic)","location":"Serbia and Montenegro (Former)","id":3098,"tag":"sr-Cyrl-CS","version":"Release B"},"sr-latn":{"language":"Serbian (Latin)","location":null,"id":28698,"tag":"sr-Latn","version":"Windows 7"},"sr":{"language":"Serbian (Latin)","location":null,"id":31770,"tag":"sr","version":"Release 7"},"sr-latn-ba":{"language":"Serbian (Latin)","location":"Bosnia and Herzegovina","id":6170,"tag":"sr-Latn-BA","version":"Release E1"},"sr-latn-me":{"language":"Serbian (Latin)","location":"Montenegro","id":11290,"tag":"sr-Latn-ME","version":"Release 7"},"sr-latn-rs":{"language":"Serbian (Latin)","location":"Serbia","id":9242,"tag":"sr-Latn-RS","version":"Release 7"},"sr-latn-cs":{"language":"Serbian (Latin)","location":"Serbia and Montenegro (Former)","id":2074,"tag":"sr-Latn-CS","version":"Release B"},"nso":{"language":"Sesotho sa Leboa","location":null,"id":108,"tag":"nso","version":"Release 7"},"nso-za":{"language":"Sesotho sa Leboa","location":"South Africa","id":1132,"tag":"nso-ZA","version":"Release E1"},"tn":{"language":"Setswana","location":null,"id":50,"tag":"tn","version":"Release 7"},"tn-bw":{"language":"Setswana","location":"Botswana","id":2098,"tag":"tn-BW","version":"Release 8"},"tn-za":{"language":"Setswana","location":"South Africa","id":1074,"tag":"tn-ZA","version":"Release E1"},"ksb":{"language":"Shambala","location":null,"id":4096,"tag":"ksb","version":"Release 10"},"ksb-tz":{"language":"Shambala","location":"Tanzania","id":4096,"tag":"ksb-TZ","version":"Release 10"},"sn":{"language":"Shona","location":null,"id":4096,"tag":"sn","version":"Release 8.1"},"sn-latn":{"language":"Shona","location":"Latin","id":4096,"tag":"sn-Latn","version":"Release 8.1"},"sn-latn-zw":{"language":"Shona","location":"Zimbabwe","id":4096,"tag":"sn-Latn-ZW","version":"Release 8.1"},"sd":{"language":"Sindhi","location":null,"id":89,"tag":"sd","version":"Release 8"},"sd-arab":{"language":"Sindhi","location":null,"id":31833,"tag":"sd-Arab","version":"Release 8"},"sd-arab-pk":{"language":"Sindhi","location":"Islamic Republic of Pakistan","id":2137,"tag":"sd-Arab-PK","version":"Release 8"},"si":{"language":"Sinhala","location":null,"id":91,"tag":"si","version":"Release 7"},"si-lk":{"language":"Sinhala","location":"Sri Lanka","id":1115,"tag":"si-LK","version":"Release V"},"sk":{"language":"Slovak","location":null,"id":27,"tag":"sk","version":"Release 7"},"sk-sk":{"language":"Slovak","location":"Slovakia","id":1051,"tag":"sk-SK","version":"Release A"},"sl":{"language":"Slovenian","location":null,"id":36,"tag":"sl","version":"Release 7"},"sl-si":{"language":"Slovenian","location":"Slovenia","id":1060,"tag":"sl-SI","version":"Release A"},"xog":{"language":"Soga","location":null,"id":4096,"tag":"xog","version":"Release 10"},"xog-ug":{"language":"Soga","location":"Uganda","id":4096,"tag":"xog-UG","version":"Release 10"},"so":{"language":"Somali","location":null,"id":119,"tag":"so","version":"Release 8.1"},"so-dj":{"language":"Somali","location":"Djibouti","id":4096,"tag":"so-DJ","version":"Release 10"},"so-et":{"language":"Somali","location":"Ethiopia","id":4096,"tag":"so-ET","version":"Release 10"},"so-ke":{"language":"Somali","location":"Kenya","id":4096,"tag":"so-KE","version":"Release 10"},"so-so":{"language":"Somali","location":"Somalia","id":1143,"tag":"so-SO","version":"Release 8.1"},"st":{"language":"Sotho","location":null,"id":48,"tag":"st","version":"Release 8.1"},"st-za":{"language":"Sotho","location":"South Africa","id":1072,"tag":"st-ZA","version":"Release 8.1"},"nr":{"language":"South Ndebele","location":null,"id":4096,"tag":"nr","version":"Release 10"},"nr-za":{"language":"South Ndebele","location":"South Africa","id":4096,"tag":"nr-ZA","version":"Release 10"},"st-ls":{"language":"Southern Sotho","location":"Lesotho","id":4096,"tag":"st-LS","version":"Release 10"},"es":{"language":"Spanish","location":null,"id":10,"tag":"es","version":"Release 7"},"es-ar":{"language":"Spanish","location":"Argentina","id":11274,"tag":"es-AR","version":"Release B"},"es-bz":{"language":"Spanish","location":"Belize","id":4096,"tag":"es-BZ","version":"Release 10.3"},"es-ve":{"language":"Spanish","location":"Bolivarian Republic of Venezuela","id":8202,"tag":"es-VE","version":"Release B"},"es-bo":{"language":"Spanish","location":"Bolivia","id":16394,"tag":"es-BO","version":"Release B"},"es-br":{"language":"Spanish","location":"Brazil","id":4096,"tag":"es-BR","version":"Release 10.2"},"es-cl":{"language":"Spanish","location":"Chile","id":13322,"tag":"es-CL","version":"Release B"},"es-co":{"language":"Spanish","location":"Colombia","id":9226,"tag":"es-CO","version":"Release B"},"es-cr":{"language":"Spanish","location":"Costa Rica","id":5130,"tag":"es-CR","version":"Release B"},"es-cu":{"language":"Spanish","location":"Cuba","id":23562,"tag":"es-CU","version":"Release 10"},"es-do":{"language":"Spanish","location":"Dominican Republic","id":7178,"tag":"es-DO","version":"Release B"},"es-ec":{"language":"Spanish","location":"Ecuador","id":12298,"tag":"es-EC","version":"Release B"},"es-sv":{"language":"Spanish","location":"El Salvador","id":17418,"tag":"es-SV","version":"Release B"},"es-gq":{"language":"Spanish","location":"Equatorial Guinea","id":4096,"tag":"es-GQ","version":"Release 10"},"es-gt":{"language":"Spanish","location":"Guatemala","id":4106,"tag":"es-GT","version":"Release B"},"es-hn":{"language":"Spanish","location":"Honduras","id":18442,"tag":"es-HN","version":"Release B"},"es-419":{"language":"Spanish","location":"Latin America","id":22538,"tag":"es-419","version":"Release 8.1"},"es-mx":{"language":"Spanish","location":"Mexico","id":2058,"tag":"es-MX","version":"Release A"},"es-ni":{"language":"Spanish","location":"Nicaragua","id":19466,"tag":"es-NI","version":"Release B"},"es-pa":{"language":"Spanish","location":"Panama","id":6154,"tag":"es-PA","version":"Release B"},"es-py":{"language":"Spanish","location":"Paraguay","id":15370,"tag":"es-PY","version":"Release B"},"es-pe":{"language":"Spanish","location":"Peru","id":10250,"tag":"es-PE","version":"Release B"},"es-ph":{"language":"Spanish","location":"Philippines","id":4096,"tag":"es-PH","version":"Release 10"},"es-pr":{"language":"Spanish","location":"Puerto Rico","id":20490,"tag":"es-PR","version":"Release B"},"es-es_tradnl":{"language":"Spanish","location":"Spain","id":1034,"tag":"es-ES_tradnl","version":"Release A"},"es-es":{"language":"Spanish","location":"Spain","id":3082,"tag":"es-ES","version":"Release A"},"es-us":{"language":"Spanish","location":"UnitedStates","id":21514,"tag":"es-US","version":"Release V"},"es-uy":{"language":"Spanish","location":"Uruguay","id":14346,"tag":"es-UY","version":"Release B"},"zgh":{"language":"Standard Moroccan Tamazight","location":null,"id":4096,"tag":"zgh","version":"Release 8.1"},"zgh-tfng-ma":{"language":"Standard Moroccan Tamazight","location":"Morocco","id":4096,"tag":"zgh-Tfng-MA","version":"Release 8.1"},"zgh-tfng":{"language":"Standard Moroccan Tamazight","location":"Tifinagh","id":4096,"tag":"zgh-Tfng","version":"Release 8.1"},"ss":{"language":"Swati","location":null,"id":4096,"tag":"ss","version":"Release 10"},"ss-za":{"language":"Swati","location":"South Africa","id":4096,"tag":"ss-ZA","version":"Release 10"},"ss-sz":{"language":"Swati","location":"Swaziland","id":4096,"tag":"ss-SZ","version":"Release 10"},"sv":{"language":"Swedish","location":null,"id":29,"tag":"sv","version":"Release 7"},"sv-ax":{"language":"Swedish","location":"Åland Islands","id":4096,"tag":"sv-AX","version":"Release 10"},"sv-fi":{"language":"Swedish","location":"Finland","id":2077,"tag":"sv-FI","version":"Release B"},"sv-se":{"language":"Swedish","location":"Sweden","id":1053,"tag":"sv-SE","version":"Release A"},"syr":{"language":"Syriac","location":null,"id":90,"tag":"syr","version":"Release 7"},"syr-sy":{"language":"Syriac","location":"Syria","id":1114,"tag":"syr-SY","version":"Release D"},"shi":{"language":"Tachelhit","location":null,"id":4096,"tag":"shi","version":"Release 10"},"shi-tfng":{"language":"Tachelhit","location":"Tifinagh","id":4096,"tag":"shi-Tfng","version":"Release 10"},"shi-tfng-ma":{"language":"Tachelhit","location":"Tifinagh, Morocco","id":4096,"tag":"shi-Tfng-MA","version":"Release 10"},"shi-latn":{"language":"Tachelhit (Latin)","location":null,"id":4096,"tag":"shi-Latn","version":"Release 10"},"shi-latn-ma":{"language":"Tachelhit (Latin)","location":"Morocco","id":4096,"tag":"shi-Latn-MA","version":"Release 10"},"dav":{"language":"Taita","location":null,"id":4096,"tag":"dav","version":"Release 10"},"dav-ke":{"language":"Taita","location":"Kenya","id":4096,"tag":"dav-KE","version":"Release 10"},"tg":{"language":"Tajik (Cyrillic)","location":null,"id":40,"tag":"tg","version":"Release 7"},"tg-cyrl":{"language":"Tajik (Cyrillic)","location":null,"id":31784,"tag":"tg-Cyrl","version":"Windows 7"},"tg-cyrl-tj":{"language":"Tajik (Cyrillic)","location":"Tajikistan","id":1064,"tag":"tg-Cyrl-TJ","version":"Release V"},"tzm":{"language":"Tamazight (Latin)","location":null,"id":95,"tag":"tzm","version":"Release 7"},"tzm-latn":{"language":"Tamazight (Latin)","location":null,"id":31839,"tag":"tzm-Latn","version":"Windows 7"},"tzm-latn-dz":{"language":"Tamazight (Latin)","location":"Algeria","id":2143,"tag":"tzm-Latn-DZ","version":"Release V"},"ta":{"language":"Tamil","location":null,"id":73,"tag":"ta","version":"Release 7"},"ta-in":{"language":"Tamil","location":"India","id":1097,"tag":"ta-IN","version":"Release C"},"ta-my":{"language":"Tamil","location":"Malaysia","id":4096,"tag":"ta-MY","version":"Release 10"},"ta-sg":{"language":"Tamil","location":"Singapore","id":4096,"tag":"ta-SG","version":"Release 10"},"ta-lk":{"language":"Tamil","location":"Sri Lanka","id":2121,"tag":"ta-LK","version":"Release 8"},"twq":{"language":"Tasawaq","location":null,"id":4096,"tag":"twq","version":"Release 10"},"twq-ne":{"language":"Tasawaq","location":"Niger","id":4096,"tag":"twq-NE","version":"Release 10"},"tt":{"language":"Tatar","location":null,"id":68,"tag":"tt","version":"Release 7"},"tt-ru":{"language":"Tatar","location":"Russia","id":1092,"tag":"tt-RU","version":"Release D"},"te":{"language":"Telugu","location":null,"id":74,"tag":"te","version":"Release 7"},"te-in":{"language":"Telugu","location":"India","id":1098,"tag":"te-IN","version":"Release D"},"teo":{"language":"Teso","location":null,"id":4096,"tag":"teo","version":"Release 10"},"teo-ke":{"language":"Teso","location":"Kenya","id":4096,"tag":"teo-KE","version":"Release 10"},"teo-ug":{"language":"Teso","location":"Uganda","id":4096,"tag":"teo-UG","version":"Release 10"},"th":{"language":"Thai","location":null,"id":30,"tag":"th","version":"Release 7"},"th-th":{"language":"Thai","location":"Thailand","id":1054,"tag":"th-TH","version":"Release B"},"bo":{"language":"Tibetan","location":null,"id":81,"tag":"bo","version":"Release 7"},"bo-in":{"language":"Tibetan","location":"India","id":4096,"tag":"bo-IN","version":"Release 10"},"bo-cn":{"language":"Tibetan","location":"People's Republic of China","id":1105,"tag":"bo-CN","version":"Release V"},"tig":{"language":"Tigre","location":null,"id":4096,"tag":"tig","version":"Release 10"},"tig-er":{"language":"Tigre","location":"Eritrea","id":4096,"tag":"tig-ER","version":"Release 10"},"ti":{"language":"Tigrinya","location":null,"id":115,"tag":"ti","version":"Release 8"},"ti-er":{"language":"Tigrinya","location":"Eritrea","id":2163,"tag":"ti-ER","version":"Release 8"},"ti-et":{"language":"Tigrinya","location":"Ethiopia","id":1139,"tag":"ti-ET","version":"Release 8"},"to":{"language":"Tongan","location":null,"id":4096,"tag":"to","version":"Release 10"},"to-to":{"language":"Tongan","location":"Tonga","id":4096,"tag":"to-TO","version":"Release 10"},"ts":{"language":"Tsonga","location":null,"id":49,"tag":"ts","version":"Release 8.1"},"ts-za":{"language":"Tsonga","location":"South Africa","id":1073,"tag":"ts-ZA","version":"Release 8.1"},"tr":{"language":"Turkish","location":null,"id":31,"tag":"tr","version":"Release 7"},"tr-cy":{"language":"Turkish","location":"Cyprus","id":4096,"tag":"tr-CY","version":"Release 10"},"tr-tr":{"language":"Turkish","location":"Turkey","id":1055,"tag":"tr-TR","version":"Release A"},"tk":{"language":"Turkmen","location":null,"id":66,"tag":"tk","version":"Release 7"},"tk-tm":{"language":"Turkmen","location":"Turkmenistan","id":1090,"tag":"tk-TM","version":"Release V"},"uk":{"language":"Ukrainian","location":null,"id":34,"tag":"uk","version":"Release 7"},"uk-ua":{"language":"Ukrainian","location":"Ukraine","id":1058,"tag":"uk-UA","version":"Release B"},"hsb":{"language":"Upper Sorbian","location":null,"id":46,"tag":"hsb","version":"Release 7"},"hsb-de":{"language":"Upper Sorbian","location":"Germany","id":1070,"tag":"hsb-DE","version":"Release V"},"ur":{"language":"Urdu","location":null,"id":32,"tag":"ur","version":"Release 7"},"ur-in":{"language":"Urdu","location":"India","id":2080,"tag":"ur-IN","version":"Release 8.1"},"ur-pk":{"language":"Urdu","location":"Islamic Republic of Pakistan","id":1056,"tag":"ur-PK","version":"Release C"},"ug":{"language":"Uyghur","location":null,"id":128,"tag":"ug","version":"Release 7"},"ug-cn":{"language":"Uyghur","location":"People's Republic of China","id":1152,"tag":"ug-CN","version":"Release V"},"uz-arab":{"language":"Uzbek","location":"Perso-Arabic","id":4096,"tag":"uz-Arab","version":"Release 10"},"uz-arab-af":{"language":"Uzbek","location":"Perso-Arabic, Afghanistan","id":4096,"tag":"uz-Arab-AF","version":"Release 10"},"uz-cyrl":{"language":"Uzbek (Cyrillic)","location":null,"id":30787,"tag":"uz-Cyrl","version":"Windows 7"},"uz-cyrl-uz":{"language":"Uzbek (Cyrillic)","location":"Uzbekistan","id":2115,"tag":"uz-Cyrl-UZ","version":"Release C"},"uz":{"language":"Uzbek (Latin)","location":null,"id":67,"tag":"uz","version":"Release 7"},"uz-latn":{"language":"Uzbek (Latin)","location":null,"id":31811,"tag":"uz-Latn","version":"Windows7"},"uz-latn-uz":{"language":"Uzbek (Latin)","location":"Uzbekistan","id":1091,"tag":"uz-Latn-UZ","version":"Release C"},"vai":{"language":"Vai","location":null,"id":4096,"tag":"vai","version":"Release 10"},"vai-vaii":{"language":"Vai","location":null,"id":4096,"tag":"vai-Vaii","version":"Release 10"},"vai-vaii-lr":{"language":"Vai","location":"Liberia","id":4096,"tag":"vai-Vaii-LR","version":"Release 10"},"vai-latn-lr":{"language":"Vai (Latin)","location":"Liberia","id":4096,"tag":"vai-Latn-LR","version":"Release 10"},"vai-latn":{"language":"Vai (Latin)","location":null,"id":4096,"tag":"vai-Latn","version":"Release 10"},"ca-es-":{"language":"Valencian","location":"Spain","id":2051,"tag":"ca-ES-","version":"Release 8"},"ve":{"language":"Venda","location":null,"id":51,"tag":"ve","version":"Release 10"},"ve-za":{"language":"Venda","location":"South Africa","id":1075,"tag":"ve-ZA","version":"Release 10"},"vi":{"language":"Vietnamese","location":null,"id":42,"tag":"vi","version":"Release 7"},"vi-vn":{"language":"Vietnamese","location":"Vietnam","id":1066,"tag":"vi-VN","version":"Release B"},"vo":{"language":"Volapük","location":null,"id":4096,"tag":"vo","version":"Release 10"},"vo-001":{"language":"Volapük","location":"World","id":4096,"tag":"vo-001","version":"Release 10"},"vun":{"language":"Vunjo","location":null,"id":4096,"tag":"vun","version":"Release 10"},"vun-tz":{"language":"Vunjo","location":"Tanzania","id":4096,"tag":"vun-TZ","version":"Release 10"},"wae":{"language":"Walser","location":null,"id":4096,"tag":"wae","version":"Release 10"},"wae-ch":{"language":"Walser","location":"Switzerland","id":4096,"tag":"wae-CH","version":"Release 10"},"cy":{"language":"Welsh","location":null,"id":82,"tag":"cy","version":"Release 7"},"cy-gb":{"language":"Welsh","location":"United Kingdom","id":1106,"tag":"cy-GB","version":"ReleaseE1"},"wal":{"language":"Wolaytta","location":null,"id":4096,"tag":"wal","version":"Release 10"},"wal-et":{"language":"Wolaytta","location":"Ethiopia","id":4096,"tag":"wal-ET","version":"Release 10"},"wo":{"language":"Wolof","location":null,"id":136,"tag":"wo","version":"Release 7"},"wo-sn":{"language":"Wolof","location":"Senegal","id":1160,"tag":"wo-SN","version":"Release V"},"xh":{"language":"Xhosa","location":null,"id":52,"tag":"xh","version":"Release 7"},"xh-za":{"language":"Xhosa","location":"South Africa","id":1076,"tag":"xh-ZA","version":"Release E1"},"yav":{"language":"Yangben","location":null,"id":4096,"tag":"yav","version":"Release 10"},"yav-cm":{"language":"Yangben","location":"Cameroon","id":4096,"tag":"yav-CM","version":"Release 10"},"ii":{"language":"Yi","location":null,"id":120,"tag":"ii","version":"Release 7"},"ii-cn":{"language":"Yi","location":"People's Republic of China","id":1144,"tag":"ii-CN","version":"Release V"},"yo":{"language":"Yoruba","location":null,"id":106,"tag":"yo","version":"Release 7"},"yo-bj":{"language":"Yoruba","location":"Benin","id":4096,"tag":"yo-BJ","version":"Release 10"},"yo-ng":{"language":"Yoruba","location":"Nigeria","id":1130,"tag":"yo-NG","version":"Release V"},"dje":{"language":"Zarma","location":null,"id":4096,"tag":"dje","version":"Release 10"},"dje-ne":{"language":"Zarma","location":"Niger","id":4096,"tag":"dje-NE","version":"Release 10"},"zu":{"language":"Zulu","location":null,"id":53,"tag":"zu","version":"Release 7"},"zu-za":{"language":"Zulu","location":"South Africa","id":1077,"tag":"zu-ZA","version":"Release E1"}}

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }]
}));

/***/ }),

/***/ "cKR8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*jslint browser: true */
/*jslint this */

var d3 = __webpack_require__("vwbq");

/**
 * Create a d3 range slider that selects ranges between `rangeMin` and `rangeMax`, and add it to the
 * `containerSelector`. The contents of the container is laid out as follows
 * <code>
 * <div class="drag">
 *     <div class="handle WW"></div>
 *     <div class="handle EE"></div>
 * </div>
 * </code>
 * The appearance can be changed with CSS, but the `position` must be `relative`, and the width of `.slider` should be
 * left unaltered.
 *
 * @param rangeMin Minimum value of the range
 * @param rangeMax Maximum value of the range
 * @param containerSelector A CSS selection indicating exactly one element in the document
 * @returns {{range: function(number, number), onChange: function(function)}}
 */
function createD3RangeSlider(rangeMin, rangeMax, containerSelector, playButton) {
    "use strict";

    var minWidth = 10;

    var sliderRange = { begin: rangeMin, end: rangeMin };
    var changeListeners = [];
    var touchEndListeners = [];
    var container = d3.select(containerSelector);
    var playing = false;
    var resumePlaying = false; // Used by drag-events to resume playing on release
    var playingRate = 100;
    var containerHeight = container.node().offsetHeight;

    // Set up play button if requested
    if (playButton) {
        // Wrap an additional container inside the main one, and set up a box-layout, see also
        // http://stackoverflow.com/questions/14319097/css-auto-resize-div-to-fit-container-width
        var box = container.append("div").style("display", "box").style("display", "-moz-box").style("display", "-webkit-box").style("box-orient", "horizontal").style("-moz-box-orient", "horizontal").style("-webkit-box-orient", "horizontal");

        var playBox = box.append("div").style("width", containerHeight + "px").style("height", containerHeight + "px").style("margin-right", "10px").style("box-flex", "0").style("-moz-box-flex", "0").style("-webkit-box-flex", "0").classed("play-container", true);

        var sliderBox = box.append("div").style("position", "relative").style("min-width", minWidth * 2 + "px").style("height", containerHeight + "px").style("box-flex", "1").style("-moz-box-flex", "1").style("-webkit-box-flex", "1").classed("slider-container", true);

        var playSVG = playBox.append("svg").attr("width", containerHeight + "px").attr("height", containerHeight + "px").style("overflow", "visible");

        var circleSymbol = playSVG.append("circle").attr("cx", containerHeight / 2).attr("cy", containerHeight / 2).attr("r", containerHeight / 2).classed("button", true);

        var h = containerHeight;
        var stopSymbol = playSVG.append("rect").attr("x", 0.3 * h).attr("y", 0.3 * h).attr("width", 0.4 * h).attr("height", 0.4 * h).style("visibility", "hidden").classed("stop", true);

        var playSymbol = playSVG.append("polygon").attr("points", 0.37 * h + "," + 0.2 * h + " " + 0.37 * h + "," + 0.8 * h + " " + 0.75 * h + "," + 0.5 * h).classed("play", true);

        //Circle that captures mouse interactions
        playSVG.append("circle").attr("cx", containerHeight / 2).attr("cy", containerHeight / 2).attr("r", containerHeight / 2).style("fill-opacity", "0.0").style("cursor", "pointer").on("click", togglePlayButton).on("mouseenter", function () {
            circleSymbol.transition().attr("r", 1.2 * containerHeight / 2).transition().attr("r", containerHeight / 2);
        });
    } else {
        var sliderBox = container.append("div").style("position", "relative").style("height", containerHeight + "px").style("min-width", minWidth * 2 + "px").classed("slider-container", true);
    }

    //Create elements in container
    var slider = sliderBox.append("div").attr("class", "slider");
    var handleW = slider.append("div").attr("class", "handle WW");
    var handleE = slider.append("div").attr("class", "handle EE");

    /** Update the `left` and `width` attributes of `slider` based on `sliderRange` */
    function updateUIFromRange() {
        var conW = sliderBox.node().clientWidth;
        // var conW = parseFloat(container.style("width"));
        var rangeW = sliderRange.end - sliderRange.begin;
        var slope = (conW - minWidth) / (rangeMax - rangeMin);
        var uirangeW = minWidth + rangeW * slope;
        var ratio = (sliderRange.begin - rangeMin) / (rangeMax - rangeMin - rangeW);
        if (isNaN(ratio)) {
            ratio = 0;
        }
        var uirangeL = ratio * (conW - uirangeW);

        slider.style("left", uirangeL + "px").style("width", uirangeW + "px");
    }

    /** Update the `sliderRange` based on the `left` and `width` attributes of `slider` */
    function updateRangeFromUI() {
        var uirangeL = parseFloat(slider.style("left"));
        var uirangeW = parseFloat(slider.style("width"));
        var conW = sliderBox.node().clientWidth;
        // var conW = parseFloat(container.style("width"));
        var slope = (conW - minWidth) / (rangeMax - rangeMin);
        var rangeW = (uirangeW - minWidth) / slope;
        if (conW == uirangeW) {
            var uislope = 0;
        } else {
            var uislope = (rangeMax - rangeMin - rangeW) / (conW - uirangeW);
        }
        var rangeL = rangeMin + uislope * uirangeL;
        sliderRange.begin = Math.round(rangeL);
        sliderRange.end = Math.round(rangeL + rangeW);

        //Fire change listeners
        changeListeners.forEach(function (callback) {
            callback({ begin: sliderRange.begin, end: sliderRange.end });
        });
    }

    // configure drag behavior for handles and slider
    var dragResizeE = d3.drag().on("start", function () {
        d3.event.sourceEvent.stopPropagation();
        resumePlaying = playing;
        playing = false;
    }).on("end", function () {
        if (resumePlaying) {
            startPlaying();
        }
        touchEndListeners.forEach(function (callback) {
            callback({ begin: sliderRange.begin, end: sliderRange.end });
        });
    }).on("drag", function () {
        var dx = d3.event.dx;
        if (dx == 0) return;
        var conWidth = sliderBox.node().clientWidth; //parseFloat(container.style("width"));
        var newLeft = parseInt(slider.style("left"));
        var newWidth = parseFloat(slider.style("width")) + dx;
        newWidth = Math.max(newWidth, minWidth);
        newWidth = Math.min(newWidth, conWidth - newLeft);
        slider.style("width", newWidth + "px");
        updateRangeFromUI();
    });

    var dragResizeW = d3.drag().on("start", function () {
        this.startX = d3.mouse(this)[0];
        d3.event.sourceEvent.stopPropagation();
        resumePlaying = playing;
        playing = false;
    }).on("end", function () {
        if (resumePlaying) {
            startPlaying();
        }
        touchEndListeners.forEach(function (callback) {
            callback({ begin: sliderRange.begin, end: sliderRange.end });
        });
    }).on("drag", function () {
        var dx = d3.mouse(this)[0] - this.startX;
        if (dx == 0) return;
        var newLeft = parseFloat(slider.style("left")) + dx;
        var newWidth = parseFloat(slider.style("width")) - dx;

        if (newLeft < 0) {
            newWidth += newLeft;
            newLeft = 0;
        }
        if (newWidth < minWidth) {
            newLeft -= minWidth - newWidth;
            newWidth = minWidth;
        }

        slider.style("left", newLeft + "px");
        slider.style("width", newWidth + "px");

        updateRangeFromUI();
    });

    var dragMove = d3.drag().on("start", function () {
        d3.event.sourceEvent.stopPropagation();
        resumePlaying = playing;
        playing = false;
    }).on("end", function () {
        if (resumePlaying) {
            startPlaying();
        }
        touchEndListeners.forEach(function (callback) {
            callback({ begin: sliderRange.begin, end: sliderRange.end });
        });
    }).on("drag", function () {
        var dx = d3.event.dx;
        var conWidth = sliderBox.node().clientWidth; //parseInt(container.style("width"));
        var newLeft = parseInt(slider.style("left")) + dx;
        var newWidth = parseInt(slider.style("width"));

        newLeft = Math.max(newLeft, 0);
        newLeft = Math.min(newLeft, conWidth - newWidth);
        slider.style("left", newLeft + "px");

        updateRangeFromUI();
    });

    handleE.call(dragResizeE);
    handleW.call(dragResizeW);
    slider.call(dragMove);

    //Click on bar
    sliderBox.on("mousedown", function (ev) {
        var x = d3.mouse(sliderBox.node())[0];
        var props = {};
        var sliderWidth = parseFloat(slider.style("width"));
        var conWidth = sliderBox.node().clientWidth; //parseFloat(container.style("width"));
        props.left = Math.min(conWidth - sliderWidth, Math.max(x - sliderWidth / 2, 0));
        props.left = Math.round(props.left);
        props.width = Math.round(props.width);
        slider.style("left", props.left + "px").style("width", props.width + "px");
        updateRangeFromUI();
    });

    function onChange(callback) {
        changeListeners.push(callback);
        return this;
    }

    function onTouchEnd(callback) {
        touchEndListeners.push(callback);
        return this;
    }

    function setRange(b, e) {
        sliderRange.begin = b;
        sliderRange.end = e;

        updateUIFromRange();

        //Fire change listeners
        changeListeners.forEach(function (callback) {
            callback({ begin: sliderRange.begin, end: sliderRange.end });
        });
    }

    /**
     * Returns or sets the range depending on arguments.
     * If `b` and `e` are both numbers then the range is set to span from `b` to `e`.
     * If `b` is a number and `e` is undefined the beginning of the slider is moved to `b`.
     * If both `b` and `e` are undefined the currently set range is returned as an object with `begin` and `end`
     * attributes.
     * If any arguments cause the range to be outside of the `rangeMin` and `rangeMax` specified on slider creation
     * then a warning is printed and the range correspondingly clamped.
     * @param b beginning of range
     * @param e end of range
     * @returns {{begin: number, end: number}}
     */
    function range(b, e) {
        var rLower;
        var rUpper;

        if (typeof b === "number" && typeof e === "number") {

            rLower = Math.min(b, e);
            rUpper = Math.max(b, e);

            //Check that lower and upper range are within their bounds
            if (rLower < rangeMin || rUpper > rangeMax) {
                console.log("Warning: trying to set range (" + rLower + "," + rUpper + ") which is outside of bounds (" + rangeMin + "," + rangeMax + "). ");
                rLower = Math.max(rLower, rangeMin);
                rUpper = Math.min(rUpper, rangeMax);
            }

            //Set the range
            setRange(rLower, rUpper);
        } else if (typeof b === "number") {

            rLower = b;
            var dif = sliderRange.end - sliderRange.begin;
            rUpper = rLower + dif;

            if (rLower < rangeMin) {
                console.log("Warning: trying to set range (" + rLower + "," + rUpper + ") which is outside of bounds (" + rangeMin + "," + rangeMax + "). ");
                rLower = rangeMin;
            }
            if (rUpper > rangeMax) {
                console.log("Warning: trying to set range (" + rLower + "," + rUpper + ") which is outside of bounds (" + rangeMin + "," + rangeMax + "). ");
                rLower = rangeMax - dif;
                rUpper = rangeMax;
            }

            setRange(rLower, rUpper);
        }

        return { begin: sliderRange.begin, end: sliderRange.end };
    }

    function togglePlayButton() {
        if (playing) {
            stopPlaying();
        } else {
            startPlaying();
        }
    }

    function frameTick() {
        if (!playing) {
            return;
        }

        var limitWidth = rangeMax - rangeMin + 1;
        var rangeWidth = sliderRange.end - sliderRange.begin + 1;
        var delta = Math.min(Math.ceil(rangeWidth / 10), Math.ceil(limitWidth / 100));

        // Check if playback has reached the end
        if (sliderRange.end + delta > rangeMax) {
            delta = rangeMax - sliderRange.end;
            stopPlaying();
        }

        setRange(sliderRange.begin + delta, sliderRange.end + delta);

        setTimeout(frameTick, playingRate);
    }

    function startPlaying(rate) {
        if (rate !== undefined) {
            playingRate = rate;
        }

        if (playing) {
            return;
        }

        playing = true;
        if (playButton) {
            playSymbol.style("visibility", "hidden");
            stopSymbol.style("visibility", "visible");
        }
        frameTick();
    }

    function stopPlaying() {
        playing = false;
        if (playButton) {
            playSymbol.style("visibility", "visible");
            stopSymbol.style("visibility", "hidden");
        }
    }

    setRange(sliderRange.begin, sliderRange.end);

    //Reposition slider on window resize
    window.addEventListener("resize", function () {
        updateUIFromRange();
    });

    // updateUIFromRange();

    return {
        range: range,
        startPlaying: startPlaying,
        stopPlaying: stopPlaying,
        onChange: onChange,
        onTouchEnd: onTouchEnd,
        updateUIFromRange: updateUIFromRange
    };
}

/* harmony default export */ __webpack_exports__["a"] = (createD3RangeSlider);

/***/ }),

/***/ "gZpW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_openlayers_css_ol_css__ = __webpack_require__("If3l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_openlayers_css_ol_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_openlayers_css_ol_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol3_photon_src_ol3_photon_css__ = __webpack_require__("oiZJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol3_photon_src_ol3_photon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_ol3_photon_src_ol3_photon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__distribution_d3RangeSlider_d3RangeSlider_css__ = __webpack_require__("q1+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__distribution_d3RangeSlider_d3RangeSlider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__distribution_d3RangeSlider_d3RangeSlider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_main_css__ = __webpack_require__("IYLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_openlayers__ = __webpack_require__("GRLA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_openlayers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_openlayers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_proj4__ = __webpack_require__("nvAS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_csv2geojson__ = __webpack_require__("jDNL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_csv2geojson___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_csv2geojson__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__distribution_micromustache__ = __webpack_require__("ye6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_ol3_photon__ = __webpack_require__("cAko");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__distribution_d3RangeSlider_d3RangeSlider__ = __webpack_require__("cKR8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_d3plus_text__ = __webpack_require__("hIMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_simple_statistics__ = __webpack_require__("DUc9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_simple_statistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_simple_statistics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_file_saver_FileSaver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_file_saver_FileSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_file_saver_FileSaver__);




















__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.setProj4(__WEBPACK_IMPORTED_MODULE_18_proj4__["a" /* default */]);




// Photon = Photon.Photon;





var resolutions = [];
var matrixIds = [];
var proj3857 = __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.get('EPSG:3857');
var maxResolution = __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.extent.getWidth(proj3857.getExtent()) / 256;

__WEBPACK_IMPORTED_MODULE_18_proj4__["a" /* default */].defs('EPSG:2154', '+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
var bboxProj2154AsWGS = [51.56, -9.86, 41.15, 10.38];
var proj2154 = __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.get('EPSG:2154');

var fromLonLatTransform = __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.getTransform('EPSG:4326', proj2154);
// very approximate calculation of projection extent
// var extentProj2154 = ol.extent.applyTransform([
//   bboxProj2154AsWGS[1],
//   bboxProj2154AsWGS[2],
//   bboxProj2154AsWGS[3],
//   bboxProj2154AsWGS[0]
// ], fromLonLatTransform);

// proj2154.setExtent(extentProj2154);
var extentZoom = __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.transformExtent([-1.954971843164693, 46.9190887269987, 5.623188812268172, 50.08899006978729], 'EPSG:4326', 'EPSG:3857');

var firstGroup = ['checked_richesse_specifique', 'checked_etat_ipr', 'checked_stations_echantillonnage'];
var rivieresGroup = ['checked_qualite_eau_etat_pc', 'checked_qualite_eau_etat_ps', 'checked_qualite_eau_bio', 'checked_diversite_habitat', 'checked_presence_ripisylve', 'checked_erosion_sol', 'checked_taux_etag', 'checked_taux_frac', 'checked_assemblage_pisci_ref'];

function upper(lower) {
  return lower.replace(/^\w/, function (c) {
    return c.toUpperCase();
  });
}

function removeDuplicates(myArr, prop) {
  return myArr.filter(function (obj, pos, arr) {
    return arr.map(function (mapObj) {
      return mapObj[prop];
    }).indexOf(obj[prop]) === pos;
  });
}

function zip(arrays) {
  return arrays[0].map(function (_, i) {
    return arrays.map(function (array) {
      return array[i];
    });
  });
}

function getLegendGraphicOptions(layerName) {
  return {
    SERVICE: 'WMS',
    VERSION: '1.1.1',
    REQUEST: 'GetLegendGraphic',
    FORMAT: 'image/png',
    TRANSPARENT: true,
    STYLES: '',
    WIDTH: 20,
    HEIGHT: 20,
    LAYER: layerName || 'general:obst_ecoul_bsn',
    LEGEND_OPTIONS: 'forceLabels:on;fontName:Times New Roman;fontAntiAliasing:true;fontColor:#000033;fontSize:11;bgColor:#FFFFEE;dpi:90;'
  };
};

function transformData(json, field, colors, libelles) {
  var sum = json.list.reduce(function (acc, curr) {
    acc += curr.tot;
    return acc;
  }, 0);
  var data = json.list.map(function (stat, idx) {
    var percentage = sum !== 0 ? stat.tot / sum * 100 : 0;
    return {
      name: stat[field],
      count: stat.tot,
      percentage: __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_number_is_integer___default()(percentage) ? percentage : percentage.toFixed(2),
      color: colors[libelles.indexOf(stat[field])]
    };
  });
  return data;
}

var PieChart = function () {
  function PieChart(selector, height, width, radius, colors, libelles) {
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, PieChart);

    this.selector = selector;
    this.height = height;
    this.width = width;
    this.radius = radius;
    this.data = [];

    this.colors = colors;
    this.libelles = libelles;

    var svg = __WEBPACK_IMPORTED_MODULE_23_d3__["select"](selector).append("svg").attr("width", width).attr("height", height).append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
    this.svg = svg;
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(PieChart, [{
    key: 'piechart',
    value: function piechart(data, fieldlibelle) {

      var arc = __WEBPACK_IMPORTED_MODULE_23_d3__["arc"]().outerRadius(this.radius - 10).innerRadius(0);

      var pie = __WEBPACK_IMPORTED_MODULE_23_d3__["pie"]().sort(null).value(function (d) {
        return d.count;
      });

      var content = this.svg.selectAll(".arc").data(pie(data));

      var g = content.enter().append("g").merge(content);

      this.svg.selectAll('path').remove();
      this.svg.selectAll('text').remove();

      var arcs = g.append("path").merge(g).attr("d", arc).style("fill", function (d, i) {
        return d.data.color;
      });

      if (fieldlibelle === 'name') {
        var div = __WEBPACK_IMPORTED_MODULE_23_d3__["select"]("body").append("div").attr("class", "tooltip").style("opacity", 0);

        arcs.on("mouseover", function (d) {
          div.transition().duration(200).style("opacity", .9);
          div.html((d.data[fieldlibelle] !== 'Autres' ? upper(especes_by_key[d.data[fieldlibelle]]) : 'Autres') + "<br/>" + d.data.percentage + '%').style("left", __WEBPACK_IMPORTED_MODULE_23_d3__["event"].pageX + "px").style("top", __WEBPACK_IMPORTED_MODULE_23_d3__["event"].pageY - 28 + "px");
        }).on("mouseout", function (d) {
          div.transition().duration(500).style("opacity", 0);
        });
      }

      g.append("text").attr("dy", ".50em").style("text-anchor", "middle").style("font", "14px Quicksand")
      // .merge(g)
      .attr("transform", function (d) {
        var _d = arc.centroid(d);
        _d[0] *= 2.4; // multiply by a constant factor
        _d[1] *= 2.4; // multiply by a constant factor
        return "translate(" + _d + ")";
      }).text(function (d) {
        return d.data[fieldlibelle];
      });
    }
  }, {
    key: 'fetchPieChart',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee(url, field, transform) {
        var json, patch_libelles, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(url).then(function (response) {
                  return response.json();
                });

              case 2:
                json = _context.sent;
                patch_libelles = {
                  'zones_humides': 'Restauration de zones humides',
                  'continuite': 'Restauration de la continuit\xE9 \xE9cologique',
                  'hydromorphologie': 'Restauration hydromorphologique'
                };

                if ('list' in json) {
                  json.list.forEach(function (el) {
                    if (__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(patch_libelles).includes(el.type_op)) {
                      el.type_op = patch_libelles[el.type_op];
                    }
                  });
                }

                data = transform(json, field, this.colors, this.libelles);

                if (json.species) {
                  if (data.length > 0) {
                    this.piechart(data, 'name');
                  }
                  this.data = data;
                } else {
                  this.piechart(data, 'count');
                }
                return _context.abrupt('return', data);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchPieChart(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return fetchPieChart;
    }()
  }]);

  return PieChart;
}();

var BarChart = function () {
  function BarChart(selector, height, width, margin, colors, libelles) {
    var colorbar = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '#5a9ad7';

    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, BarChart);

    this.selector = selector;
    this.height = height;
    this.width = width;
    this.margin = margin;
    this.x = __WEBPACK_IMPORTED_MODULE_23_d3__["scaleBand"]().rangeRound([0, width]).padding(0.1);
    this.xAxis = __WEBPACK_IMPORTED_MODULE_23_d3__["axisBottom"](this.x);

    var svg = __WEBPACK_IMPORTED_MODULE_23_d3__["select"](selector).append("svg").attr("width", width + this.margin.left + this.margin.right).attr("height", height + this.margin.top + this.margin.bottom).append("g").attr("transform", 'translate(' + this.margin.left + ', ' + this.margin.top + ')');

    this.colors = colors;
    this.libelles = libelles;
    this.svg = svg;
    this.colorbar = colorbar;
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(BarChart, [{
    key: 'updateBarChart',
    value: function updateBarChart(data, field) {
      var _this = this;

      var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(data.map(function (el) {
        return el.count;
      })));
      // Change libelle to add count to the name
      data.forEach(function (el) {
        el.name = el.name.replace('hydromorphologique', 'hydromorpho.') + ' (' + String(el.count) + ')';
      });
      this.x.domain(data.map(function (d) {
        return d.name;
      }));
      this.svg.selectAll("rect").remove();
      var content = this.svg.selectAll("rect").data(data);

      content.enter().append("rect").attr("width", function (d, i) {
        //console.log('bandwith', this.x.bandwidth());
        return _this.x.bandwidth();
        // return (i + 1) * this.width / data.length;
        // return (this.width - (data.length - 1) * 5) / data.length;
      }).attr("fill", function (d) {
        return d.color;
      }).merge(content).attr("x", function (d, i) {
        return _this.x(d.name);
      }).attr("y", function (d) {
        if (d.count == 0) {
          return _this.height;
        } else {
          return _this.height - d.count * (_this.height / max);
        }
      }).attr("height", function (d) {
        if (d.count == 0) {
          return 1;
        } else {
          return d.count * (_this.height / max); // <-- Times four!
        }
      });

      content.exit().remove();

      // debugger;
      this.svg.selectAll('.x.axis').remove();

      this.svg.append("g").attr("class", "x axis").attr("transform", 'translate(0, ' + this.height + ')').call(this.xAxis).selectAll(".tick text").call(wrap, this.x.bandwidth());

      function wrap(text, width) {
        text.each(function () {
          var text = __WEBPACK_IMPORTED_MODULE_23_d3__["select"](this),
              words = text.text().split(/\s+/).reverse(),
              word,
              line = [],
              lineNumber = 0,
              lineHeight = 1.1,
              // ems
          y = text.attr("y"),
              dy = parseFloat(text.attr("dy")),
              tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
          while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + 'em').text(word);
            }
          }
        });
      }
    }
  }, {
    key: 'fetchBarChart',
    value: function fetchBarChart(url, field) {
      var _this2 = this;

      fetch(url).then(function (response) {
        return response.json();
      }).then(function (json) {
        var patch_libelles = {
          'zones_humides': 'Restauration de zones humides',
          'continuite': 'Restauration de la continuit\xE9 \xE9cologique',
          'hydromorphologie': 'Restauration hydromorphologique'
        };
        if ('list' in json) {
          json.list.forEach(function (el) {
            if (__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(patch_libelles).includes(el.type_op)) {
              el.type_op = patch_libelles[el.type_op];
            }
          });
        }
        var sum = json.list.reduce(function (acc, curr) {
          acc += curr.tot;
          return acc;
        }, 0);
        var data = json.list.map(function (stat, idx) {
          var percentage = sum !== 0 ? stat.tot / sum * 100 : 0;
          return {
            name: stat[field],
            count: stat.tot,
            percentage: __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_number_is_integer___default()(percentage) ? percentage : percentage.toFixed(2),
            color: _this2.colors[_this2.libelles.indexOf(stat[field])]
          };
        });
        _this2.updateBarChart(data, field);
      });
    }
  }]);

  return BarChart;
}();

var BarChartIPR = function () {
  function BarChartIPR(selector, height, width, margin) {
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, BarChartIPR);

    this.selector = selector;
    this.height = height;
    this.width = width;
    this.margin = margin;

    var svg = __WEBPACK_IMPORTED_MODULE_23_d3__["select"](selector).append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", 'translate(' + margin.left + ', ' + margin.top + ')');

    var x = __WEBPACK_IMPORTED_MODULE_23_d3__["scaleBand"]().rangeRound([0, width]).padding(0.1),
        y = __WEBPACK_IMPORTED_MODULE_23_d3__["scaleLinear"]().rangeRound([height, 0]);

    var colorsQuali = {
      "Excellent": '#25408f',
      "Bonne": '#41ad49',
      "Médiocre": '#fff200',
      "Mauvaise": '#f8971d',
      "Très mauvaise": '#d2232a',
      "Absence de données": '#6792fd'
    };

    this.colorsQuali = colorsQuali;
    this.svg = svg;
    this.x = x;
    this.y = y;
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(BarChartIPR, [{
    key: 'updateBarChart',
    value: function updateBarChart(data, maxY) {
      var _this3 = this;

      this.x.domain(data.map(function (d) {
        return d.classe_quali;
      }));
      // this.y.domain([0, d3.max(data, function(d) {
      //   return d.tot;
      // })]);
      this.y.domain([0, maxY]);
      this.svg.selectAll('g').remove();
      var textX = this.svg.append("g").attr("class", "axis axis--x").attr("transform", "translate(0," + this.height + ")").call(__WEBPACK_IMPORTED_MODULE_23_d3__["axisBottom"](this.x)).selectAll("text");

      textX.merge(textX).style("text-anchor", "end").attr("dx", "-.8em").attr("dy", ".15em").attr("transform", "rotate(-65)");

      var textY = this.svg.append("g").attr("class", "axis axis--y").call(__WEBPACK_IMPORTED_MODULE_23_d3__["axisLeft"](this.y).ticks(5, "s"));
      textY.append("text").merge(textY).attr("y", 6).attr("dy", "1.71em").attr("text-anchor", "end").text("Frequency");

      this.svg.selectAll("rect").remove();
      this.svg.selectAll(".bar").data(data).enter().append("rect").attr("x", function (d) {
        return _this3.x(d.classe_quali);
      }).attr("y", function (d) {
        return _this3.y(d.tot);
      }).attr("fill", function (d) {
        return _this3.colorsQuali[d.classe_quali];
      }).attr("width", this.x.bandwidth()).attr("height", function (d) {
        // console.log(this.height - this.y(d.tot));
        return _this3.height - _this3.y(d.tot) == 0 ? _this3.height - _this3.y(0.1) : _this3.height - _this3.y(d.tot);
      });
    }
  }, {
    key: 'fetchBarChart',
    value: function fetchBarChart(url, maxY) {
      var _this4 = this;

      fetch(url).then(function (response) {
        return response.json();
      }).then(function (json) {
        var data = json.list.filter(function (el) {
          return el.classe_quali !== "Absence de données";
        });
        _this4.updateBarChart(data, maxY);
      });
    }
  }]);

  return BarChartIPR;
}();

var BarChartEvolutionSpecies = function () {
  function BarChartEvolutionSpecies(selector, height, width, margin, colors, libelles) {
    var colorbar = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '#5a9ad7';

    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, BarChartEvolutionSpecies);

    this.selector = selector;
    this.height = height;
    this.width = width;
    this.margin = margin;
    this.data = [];
    var x = __WEBPACK_IMPORTED_MODULE_23_d3__["scaleTime"]().range([0, width]);

    var y = __WEBPACK_IMPORTED_MODULE_23_d3__["scaleLinear"]().range([height, 0]);

    var xAxis = __WEBPACK_IMPORTED_MODULE_23_d3__["axisBottom"](x).ticks(__WEBPACK_IMPORTED_MODULE_23_d3__["timeYear"].every(1));
    var yAxis = __WEBPACK_IMPORTED_MODULE_23_d3__["axisLeft"](y);
    xAxis.tickFormat(__WEBPACK_IMPORTED_MODULE_23_d3__["timeFormat"]("%y"));

    var svg = __WEBPACK_IMPORTED_MODULE_23_d3__["select"](selector).append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    this.x = x;
    this.y = y;
    this.xAxis = xAxis;
    this.yAxis = yAxis;
    this.height = height;
    this.svg = svg;
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(BarChartEvolutionSpecies, [{
    key: 'updateBarChart',
    value: function updateBarChart(data, field) {
      var _this5 = this;

      // console.log('BarChartEvolutionSpecies data', data);
      this.x.domain(__WEBPACK_IMPORTED_MODULE_23_d3__["extent"](data, function (d) {
        return d.date_ech;
      }));
      this.y.domain(__WEBPACK_IMPORTED_MODULE_23_d3__["extent"](data, function (d) {
        return d.value;
      }));

      var line = __WEBPACK_IMPORTED_MODULE_23_d3__["line"]().x(function (d) {
        return _this5.x(d.date_ech);
      }).y(function (d) {
        return _this5.y(d.value);
      });

      // Derive a linear regression
      var regression = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_simple_statistics__["linearRegression"])(data.map(function (d) {
        return [+d.date_ech, d.value];
      }));

      var lin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_simple_statistics__["linearRegressionLine"])(regression);

      // Create a line based on the beginning and endpoints of the range
      var lindata = this.x.domain().map(function (x) {
        return {
          date_ech: new Date(x),
          value: lin(+x)
        };
      });

      this.svg.selectAll("*").remove();

      this.svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + this.height + ")").call(this.xAxis);

      this.svg.append("g").attr("class", "y axis").call(this.yAxis).append("text").attr("transform", "rotate(-90)").attr("y", 6).attr("dy", ".71em").style("text-anchor", "end");

      this.svg.append("path").datum(data).attr("class", "line").attr("d", line);

      this.svg.selectAll(".dot").data(data).enter().append("circle").attr("class", "dot").attr("opacity", 0.9).attr("r", 2).attr("cx", function (d) {
        return _this5.x(d.date_ech);
      }).attr("cy", function (d) {
        return _this5.y(d.value);
      }).style("fill", "red").style("stroke", " lightgrey").style("stroke-width", "1px");

      this.svg.append("path").datum(lindata).attr("class", "reg").attr("d", line);

      // text label for the x axis
      this.svg.append("text").attr("transform", "translate(" + this.width / 2 + " ," + (this.height + this.margin.top + 20) + ")").style("text-anchor", "middle").style("font", "14px Quicksand").text("Année");

      // text label for the y axis
      this.svg.append("text").attr("transform", "rotate(-90)").attr("y", 0 - this.margin.left - 5).attr("x", 0 - this.height / 2).attr("dy", "1em").style("text-anchor", "middle").style("font", "14px Quicksand").text("Densité");
    }
  }, {
    key: 'fetchBarChart',
    value: function fetchBarChart(url, field) {
      var _this6 = this;

      var that = this;
      fetch(url).then(function (response) {
        return response.json();
      }).then(function (json) {
        var parseDate = __WEBPACK_IMPORTED_MODULE_23_d3__["timeParse"]("%Y-%m-%d");
        if (__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(json.species).length > 0) {
          var data = json.species[field].map(function (el, index) {
            return {
              date_ech: parseDate(json.species['date_ech'][index]),
              value: el
            };
          });
          // console.log(data);
          _this6.updateBarChart(data, field);
          that.data = data;
        } else {
          that.data = [];
          console.log('Pas de données');
        }
      });
    }
  }]);

  return BarChartEvolutionSpecies;
}();

/*  Copyright (c) 2016 Jean-Marc VIGLINO,
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/
/** A simple push button control
* @constructor
* @extends {ol.control.Control}
* @param {Object=} options Control options.
* @param {String} options.className class of the control
* @param {String} options.title title of the control
* @param {String} options.html html to insert in the control
* @param {function} options.handleClick callback when control is clicked (or use change:active event)
*/


__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.Button = function (options) {
  options = options || {};
  var element = document.createElement('div');
  element.className = (options.className || '') + ' ol-button ol-unselectable ol-control';

  var self = this;
  var bt = document.createElement('button');
  bt.type = 'button';
  bt.title = options.title;
  bt.innerHTML = options.html || "";
  bt.addEventListener("click", function (e) {
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (options.handleClick) {
      options.handleClick.call(self, e);
    }
  });
  element.appendChild(bt);

  if (!options.title) {
    bt.title = bt.firstElementChild.title;
  }
  __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.Control.call(this, {
    element: element,
    target: options.target
  });
  if (options.title) {
    this.set("title", options.title);
  }
};

__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.inherits(__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.Button, __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.Control);

function getHeight(el) {
  var styles = window.getComputedStyle(el);
  var height = el.offsetHeight;
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderBottomWidth = parseFloat(styles.borderBottomWidth);
  var paddingTop = parseFloat(styles.paddingTop);
  var paddingBottom = parseFloat(styles.paddingBottom);
  return height - borderBottomWidth - borderTopWidth - paddingTop - paddingBottom;
}

/*  Copyright (c) 2015 Jean-Marc VIGLINO,
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/
/**
 * @classdesc
 *    OpenLayers 3 Scale Line Control integrated in the canvas (for jpeg/png
 * @see http://www.kreidefossilien.de/webgis/dokumentation/beispiele/export-map-to-png-with-scale
 *
 * @constructor
 * @extends {ol.control.ScaleLine}
 * @param {Object=} options extend the ol.control.ScaleLine options.
 *  @param {ol.style.Style} options.style used to draw the scale line (default is black/white, 10px Arial).
 */

__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasScaleLine = function (options) {
  __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.ScaleLine.call(this, options);
  this.scaleHeight_ = 6;
  // Get style options
  if (!options) options = {};
  if (!options.style) options.style = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style();
  this.setStyle(options.style);
};
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.inherits(__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasScaleLine, __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.ScaleLine);
/**
 * Remove the control from its current map and attach it to the new map.
 * Subclasses may set up event handlers to get notified about changes to
 * the map here.
 * @param {_ol_Map_} map Map.
 * @api stable
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasScaleLine.prototype.setMap = function (map) {
  var oldmap = this.getMap();
  if (this._listener) {
    __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.Observable.unByKey(this._listener);
  }
  this._listener = null;
  __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.ScaleLine.prototype.setMap.call(this, map);
  if (oldmap) {
    oldmap.renderSync();
  }
  // Add postcompose on the map
  if (map) {
    this._listener = map.on('postcompose', this.drawScale_.bind(this));
  }
  // Hide the default DOM element
  this.element.style.visibility = 'hidden';
  this.olscale = this.element.querySelector(".ol-scale-line-inner");
};
/**
 * Change the control style
 * @param {_ol_style_Style_} style
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasScaleLine.prototype.setStyle = function (style) {
  var stroke = style.getStroke();
  this.strokeStyle_ = stroke ? __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.color.asString(stroke.getColor()) : "#000";
  this.strokeWidth_ = stroke ? stroke.getWidth() : 2;
  var fill = style.getFill();
  this.fillStyle_ = fill ? __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.color.asString(fill.getColor()) : "#fff";
  var text = style.getText();
  this.font_ = text ? text.getFont() : "10px Arial";
  stroke = text ? text.getStroke() : null;
  fill = text ? text.getFill() : null;
  this.fontStrokeStyle_ = stroke ? __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.color.asString(stroke.getColor()) : this.fillStyle_;
  this.fontStrokeWidth_ = stroke ? stroke.getWidth() : 3;
  this.fontFillStyle_ = fill ? __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.color.asString(fill.getColor()) : this.strokeStyle_;
  // refresh
  if (this.getMap()) this.getMap().render();
};
/*
  * Draw attribution in the final canvas
  * @private
  */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasScaleLine.prototype.drawScale_ = function (e) {
  if (this.element.style.visibility !== "hidden") return;
  var ctx = e.context;
  // Get size of the scale div
  var scalewidth = parseInt(this.olscale.style.width);
  if (!scalewidth) return;
  var text = this.olscale.textContent;
  var position = { left: this.element.offsetLeft, top: this.element.offsetTop };
  // Retina device
  var ratio = e.frameState.pixelRatio;
  ctx.save();
  ctx.scale(ratio, ratio);
  // Position if transform:scale()
  var container = this.getMap().getTargetElement();
  var scx = container.offsetWidth / container.getBoundingClientRect().width;
  var scy = container.offsetHeight / container.getBoundingClientRect().height;
  position.left *= scx;
  position.top *= scy;
  // On top
  position.top += getHeight(this.element) - this.scaleHeight_;
  // Draw scale text
  ctx.beginPath();
  ctx.strokeStyle = this.fontStrokeStyle_;
  ctx.fillStyle = this.fontFillStyle_;
  ctx.lineWidth = this.fontStrokeWidth_;
  ctx.textAlign = "center";
  ctx.textBaseline = "bottom";
  ctx.font = this.font_;
  ctx.strokeText(text, position.left + scalewidth / 2, position.top);
  ctx.fillText(text, position.left + scalewidth / 2, position.top);
  ctx.closePath();
  // Draw scale bar
  position.top += 2;
  ctx.lineWidth = this.strokeWidth_;
  ctx.strokeStyle = this.strokeStyle_;
  var max = 4;
  var n = parseInt(text);
  while (n % 10 === 0) {
    n /= 10;
  }if (n % 5 === 0) max = 5;
  for (var i = 0; i < max; i++) {
    ctx.beginPath();
    ctx.fillStyle = i % 2 ? this.fillStyle_ : this.strokeStyle_;
    ctx.rect(position.left + i * scalewidth / max, position.top, scalewidth / max, this.scaleHeight_);
    ctx.stroke();
    ctx.fill();
    ctx.closePath();
  }
  ctx.restore();
};

/*  Copyright (c) 2015 Jean-Marc VIGLINO,
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/
/**
 * OpenLayers 3 Title Control integrated in the canvas (for jpeg/png
 *
 * @constructor
 * @extends {ol.control.Control}
 * @param {Object=} options extend the ol.control options.
 *  @param {ol.style.Style} options.style style usesd to draw the title.
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle = function (options) {
  if (!options) options = {};
  // Get style options
  if (!options.style) options.style = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style();
  this.setStyle(options.style);
  // Initialize parent
  var elt = document.createElement('div');
  elt.textContent = this.text_;
  elt.className = 'ol-title ol-unselectable';
  var css = {
    font: this.font_,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    display: 'block',
    visibility: 'hidden'
  };
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(css).forEach(function (key) {
    elt.style[key] = css[key];
  });
  __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.Control.call(this, { element: elt,
    target: options.target
  });
};
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.inherits(__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle, __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.Control);
/**
 * Remove the control from its current map and attach it to the new map.
 * Subclasses may set up event handlers to get notified about changes to
 * the map here.
 * @param {_ol_Map_} map Map.
 * @api stable
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle.prototype.setMap = function (map) {
  var oldmap = this.getMap();
  if (this._listener) __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.Observable.unByKey(this._listener);
  this._listener = null;
  __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.Control.prototype.setMap.call(this, map);
  if (oldmap) oldmap.renderSync();
  // Get change (new layer added or removed)
  if (map) {
    this._listener = map.on('postcompose', this.drawTitle_.bind(this));
  }
};
/**
 * Change the control style
 * @param {ol.style.Style} style
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle.prototype.setStyle = function (style) {
  var text = style.getText();
  this.font_ = text ? text.getFont() || "20px Arial" : "20px Arial";
  this.text_ = text ? text.getText() : "";
  var stroke = text ? text.getStroke() : null;
  var fill = text ? text.getFill() : null;
  this.strokeStyle_ = stroke ? __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.color.asString(stroke.getColor()) : "#fff";
  this.fillStyle_ = fill ? __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.color.asString(fill.getColor()) : "#000";
  if (this.element) {
    this.element.textContent = this.text_;
    this.element.style.font = this.font_;
  }
  // refresh
  if (this.getMap()) this.getMap().render();
};
/**
 * Set the map title
 * @param {string} map title.
 * @api stable
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle.prototype.setTitle = function (title) {
  this.text_ = title;
  this.element.textContent = this.text_;
  if (this.getMap()) this.getMap().renderSync();
};
/**
 * Get the map title
 * @param {string} map title.
 * @api stable
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle.prototype.getTitle = function (title) {
  return this.text_;
};
/**
 * Set control visibility
 * @param {bool} b
 * @api stable
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle.prototype.setVisible = function (b) {
  if (b) el.style.display = '';else el.style.display = 'none';
  if (this.getMap()) this.getMap().renderSync();
};
/**
 * Get control visibility
 * @return {bool}
 * @api stable
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle.prototype.getVisible = function (b) {
  return this.element.style.display !== 'none';
};
/** Draw scale line in the final canvas
*/
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle.prototype.drawTitle_ = function (e) {
  if (!this.getVisible()) return;
  var ctx = e.context;
  // Retina device
  var ratio = e.frameState.pixelRatio;
  ctx.save();
  ctx.scale(ratio, ratio);
  var w = ctx.canvas.width / ratio;
  var h = getHeight(this.element);
  var position = { top: 0, left: w / 2 };
  ctx.beginPath();
  ctx.fillStyle = this.strokeStyle_;
  ctx.rect(0, 0, w, h);
  ctx.fill();
  ctx.closePath();
  ctx.beginPath();
  ctx.fillStyle = this.fillStyle_;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = this.font_;
  ctx.fillText(this.text_, position.left, position.top + h / 2);
  ctx.closePath();
  ctx.restore();
};

/*  Copyright (c) 2015 Jean-Marc VIGLINO,
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/
/**
 * @classdesc
 *   OpenLayers 3 Attribution Control integrated in the canvas (for jpeg/png
 * @see http://www.kreidefossilien.de/webgis/dokumentation/beispiele/export-map-to-png-with-scale
 *
 * @constructor
 * @extends {ol.control.Attribution}
 * @param {Object=} options extend the ol.control.Attribution options.
 *  @param {ol.style.Style} options.style  option is usesd to draw the text.
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasAttribution = function (options) {
  if (!options) options = {};
  __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.Attribution.call(this, options);
  // Draw in canvas
  this.isCanvas_ = !!options.canvas;
  // Get style options
  if (!options) options = {};
  if (!options.style) options.style = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style();
  this.setStyle(options.style);
};
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.inherits(__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasAttribution, __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.Attribution);
/**
 * Draw attribution on canvas
 * @param {boolean} b draw the attribution on canvas.
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasAttribution.prototype.setCanvas = function (b) {
  this.isCanvas_ = b;
  this.element.style.visibility = b ? "hidden" : "visible";
  if (this.map_) this.map_.renderSync();
};
/**
 * Change the control style
 * @param {ol.style.Style} style
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasAttribution.prototype.setStyle = function (style) {
  var text = style.getText();
  this.font_ = text ? text.getFont() : "10px Arial";
  var stroke = text ? text.getStroke() : null;
  var fill = text ? text.getFill() : null;
  this.fontStrokeStyle_ = stroke ? __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.color.asString(stroke.getColor()) : "#fff";
  this.fontFillStyle_ = fill ? __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.color.asString(fill.getColor()) : "#000";
  this.fontStrokeWidth_ = stroke ? stroke.getWidth() : 3;
  if (this.getMap()) this.getMap().render();
};
/**
 * Remove the control from its current map and attach it to the new map.
 * Subclasses may set up event handlers to get notified about changes to
 * the map here.
 * @param {ol.Map} map Map.
 * @api stable
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasAttribution.prototype.setMap = function (map) {
  var oldmap = this.getMap();
  if (this._listener) __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.Observable.unByKey(this._listener);
  this._listener = null;
  __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.ScaleLine.prototype.setMap.call(this, map);
  if (oldmap) oldmap.renderSync();
  // Get change (new layer added or removed)
  if (map) {
    this._listener = map.on('postcompose', this.drawAttribution_.bind(this));
  }
  this.map_ = map;
  this.setCanvas(this.isCanvas_);
};
/**
 * Draw attribution in the final canvas
 * @private
 */
__WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasAttribution.prototype.drawAttribution_ = function (e) {
  var ctx = e.context;
  if (!this.isCanvas_) return;
  var text = "";
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from___default()(this.element.querySelectorAll('li')).filter(function (el) {
    return el.style.display !== "none";
  }).map(function (el) {
    text += (text ? " - " : "") + el.textContent;
  });
  // Get size of the scale div
  var position = { left: this.element.offsetLeft, top: this.element.offsetTop };
  // Retina device
  var ratio = e.frameState.pixelRatio;
  ctx.save();
  ctx.scale(ratio, ratio);
  // Position if transform:scale()
  var container = this.getMap().getTargetElement();
  var scx = container.offsetWidth / container.getBoundingClientRect().width;
  var scy = container.offsetHeight / container.getBoundingClientRect().height;
  position.left *= scx;
  position.top *= scy;
  position.right = position.left + this.element.offsetWidth;
  position.bottom = position.top + this.element.offsetHeight;
  // Draw scale text
  ctx.beginPath();
  ctx.strokeStyle = this.fontStrokeStyle_;
  ctx.fillStyle = this.fontFillStyle_;
  ctx.lineWidth = this.fontStrokeWidth_;
  ctx.textAlign = "right";
  ctx.textBaseline = "bottom";
  ctx.font = this.font_;
  ctx.strokeText(text, position.right, position.bottom);
  ctx.fillText(text, position.right, position.bottom);
  ctx.closePath();
  ctx.restore();
};

for (var i = 0; i < 20; i++) {
  matrixIds[i] = i.toString();
  resolutions[i] = maxResolution / Math.pow(2, i);
}

// var key = '3mdalal1m4zhug5t1gytqnly'; // Own key
var key = 'ocfbpru9z3lkhexj2ovquub8';

var especes = [{
  "code": "ABH",
  "genre": "M",
  "article": "L'",
  "nom_commun": "able de Heckel",
  "type_espece": "eih"
}, {
  "code": "ABL",
  "genre": "F",
  "article": "L'",
  "nom_commun": "ablette",
  "type_espece": "enp"
}, {
  "code": "CTI",
  "genre": "M",
  "article": "L'",
  "nom_commun": "amour blanc",
  "type_espece": "eih"
}, {
  "code": "ASP",
  "genre": "M",
  "article": "L'",
  "nom_commun": "aspe",
  "type_espece": "eih"
}, {
  "code": "BAF",
  "genre": "M",
  "article": "Le",
  "nom_commun": "barbeau fluviatile",
  "type_espece": "enp"
}, {
  "code": "BBG",
  "genre": "M",
  "article": "Le",
  "nom_commun": "black bass à grande bouche",
  "type_espece": "eih"
}, {
  "code": "BLN",
  "genre": "M",
  "article": "Le",
  "nom_commun": "blageon",
  "type_espece": "eih"
}, {
  "code": "BOU",
  "genre": "F",
  "article": "La",
  "nom_commun": "bouvière",
  "type_espece": "enp"
}, {
  "code": "BRB",
  "genre": "F",
  "article": "La",
  "nom_commun": "brème bordelière",
  "type_espece": "enp"
}, {
  "code": "BRE",
  "genre": "F",
  "article": "La",
  "nom_commun": "brème commune",
  "type_espece": "enp"
}, {
  "code": "BRO",
  "genre": "M",
  "article": "Le",
  "nom_commun": "brochet",
  "type_espece": "enp"
}, {
  "code": "CAG",
  "genre": "M",
  "article": "Le",
  "nom_commun": "carassin argenté",
  "type_espece": "eih"
}, {
  "code": "CAS",
  "genre": "M",
  "article": "Le",
  "nom_commun": "carassin commun",
  "type_espece": "eih"
}, {
  "code": "CAD",
  "genre": "M",
  "article": "Le",
  "nom_commun": "carassin doré",
  "type_espece": "eih"
}, {
  "code": "CAR",
  "genre": "F",
  "article": "La",
  "nom_commun": "carpe argentée",
  "type_espece": "eih"
}, {
  "code": "CCO",
  "genre": "F",
  "article": "La",
  "nom_commun": "carpe commune",
  "type_espece": "eih"
},
// {
//   "code": "CCU",
//   "genre": "F",
//   "article": "La",
//   "nom_commun": "carpe cuir",
//   "type_espece": "eih"
// },
// {
//   "code": "CMI",
//   "genre": "F",
//   "article": "La",
//   "nom_commun": "carpe miroir",
//   "type_espece": "eih"
// },
{
  "code": "CHA",
  "genre": "M",
  "article": "Le",
  "nom_commun": "chabot",
  "type_espece": "enp"
}, {
  "code": "CHE",
  "genre": "M",
  "article": "Le",
  "nom_commun": "chevesne",
  "type_espece": "enp"
}, {
  "code": "EPI",
  "genre": "M",
  "article": "L'",
  "nom_commun": "épinoche",
  "type_espece": "enp"
}, {
  "code": "EPT",
  "genre": "M",
  "article": "L'",
  "nom_commun": "épinochette",
  "type_espece": "enp"
}, {
  "code": "GAR",
  "genre": "M",
  "article": "Le",
  "nom_commun": "gardon",
  "type_espece": "enp"
}, {
  "code": "GOB",
  "genre": "M",
  "article": "Le",
  "nom_commun": "gobie des sables",
  "type_espece": "enp"
}, {
  "code": "GOU",
  "genre": "M",
  "article": "Le",
  "nom_commun": "goujon",
  "type_espece": "enp"
}, {
  "code": "GRE",
  "genre": "F",
  "article": "La",
  "nom_commun": "gremille",
  "type_espece": "eih"
}, {
  "code": "HOT",
  "genre": "M",
  "article": "Le",
  "nom_commun": "hotu",
  "type_espece": "eih"
}, {
  "code": "IDE",
  "genre": "M",
  "article": "L'",
  "nom_commun": "ide mélanote",
  "type_espece": "eih"
}, {
  "code": "LPP",
  "genre": "F",
  "article": "La",
  "nom_commun": "lamproie de planer",
  "type_espece": "enp"
}, {
  "code": "LOE",
  "genre": "F",
  "article": "La",
  "nom_commun": "loche d'étang",
  "type_espece": "eih"
}, {
  "code": "LOR",
  "genre": "F",
  "article": "La",
  "nom_commun": "loche de rivière",
  "type_espece": "enp"
}, {
  "code": "LOF",
  "genre": "F",
  "article": "La",
  "nom_commun": "loche franche",
  "type_espece": "enp"
}, {
  "code": "LOT",
  "genre": "F",
  "article": "La",
  "nom_commun": "lote de rivière",
  "type_espece": "enp"
}, {
  "code": "SDF",
  "genre": "M",
  "article": "L'",
  "nom_commun": "omble de fontaine",
  "type_espece": "eih"
}, {
  "code": "OBR",
  "genre": "M",
  "article": "L'",
  "nom_commun": "ombre commun",
  "type_espece": "enp"
}, {
  "code": "PER",
  "genre": "F",
  "article": "La",
  "nom_commun": "perche",
  "type_espece": "enp"
}, {
  "code": "PES",
  "genre": "F",
  "article": "La",
  "nom_commun": "perche soleil",
  "type_espece": "eih"
}, {
  "code": "PCH",
  "genre": "M",
  "article": "Le",
  "nom_commun": "poisson chat",
  "type_espece": "eih"
}, {
  "code": "PSR",
  "genre": "M",
  "article": "Le",
  "nom_commun": "pseudorasbora",
  "type_espece": "eih"
}, {
  "code": "ROT",
  "genre": "M",
  "article": "Le",
  "nom_commun": "rotengle",
  "type_espece": "enp"
}, {
  "code": "SAN",
  "genre": "M",
  "article": "Le",
  "nom_commun": "sandre",
  "type_espece": "eih"
}, {
  "code": "SIL",
  "genre": "M",
  "article": "Le",
  "nom_commun": "silure glane",
  "type_espece": "eih"
}, {
  "code": "SPI",
  "genre": "M",
  "article": "Le",
  "nom_commun": "spirlin",
  "type_espece": "enp"
}, {
  "code": "TAN",
  "genre": "F",
  "article": "La",
  "nom_commun": "tanche",
  "type_espece": "enp"
}, {
  "code": "TAC",
  "genre": "F",
  "article": "La",
  "nom_commun": "truite arc en ciel",
  "type_espece": "eih"
}, {
  "code": "TRF",
  "genre": "F",
  "article": "La",
  "nom_commun": "truite fario",
  "type_espece": "enp"
}, {
  "code": "UMP",
  "genre": "M",
  "article": "L'",
  "nom_commun": "umbre pygmée",
  "type_espece": "eih"
}, {
  "code": "VAI",
  "genre": "M",
  "article": "Le",
  "nom_commun": "vairon",
  "type_espece": "enp"
}, {
  "code": "VAN",
  "genre": "F",
  "article": "La",
  "nom_commun": "vandoise",
  "type_espece": "enp"
}, {
  "code": "VAR",
  "genre": "F",
  "article": "La",
  "nom_commun": "vandoise rostrée",
  "type_espece": "eih"
}];

function removeAccents(str) {
  var accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
  var accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
  str = str.split('');
  str.forEach(function (letter, index) {
    var i = accents.indexOf(letter);
    if (i != -1) {
      str[index] = accentsOut[i];
    }
  });
  return str.join('');
}

function compare_nom_commun(a, b) {
  // TODO: use localeCompare instead of upper + remove accents
  // Use toUpperCase() to ignore character casing
  var nom_commun_a = removeAccents(a.nom_commun.toUpperCase());
  var nom_commun_b = removeAccents(b.nom_commun.toUpperCase());

  var comparison = 0;
  if (nom_commun_a > nom_commun_b) {
    comparison = 1;
  } else if (nom_commun_a < nom_commun_b) {
    comparison = -1;
  }
  return comparison;
}

var especes_sorted_by_nom_commun = Array.prototype.slice.call(especes).sort(compare_nom_commun);

var especes_by_key = especes.reduce(function (acc, curr) {
  acc[curr.code.toLowerCase()] = curr.nom_commun;
  return acc;
}, {});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      map: '',
      highlight_layer_secteurs: null,
      highlight_layer: null,
      travaux_filters: [{ lib: 'Restauration de la continuité écologique', value: 'continuite', 'filtering': 'type_op', lib_all: 'Tous travaux', lib_title: 'Type d\'opération' }, { lib: 'Restauration de zones humides', value: 'zones_humides', 'filtering': 'type_op', lib_all: 'Tous travaux', lib_title: 'Type d\'opération' }, { lib: 'Restauration hydromorphologique', value: 'hydromorphologie', 'filtering': 'type_op', lib_all: 'Tous travaux', lib_title: 'Type d\'opération' }, { lib: 'Collectivité', value: 'collectivite', 'filtering': 'type_structure', lib_all: 'Toutes structures', lib_title: 'Type de structure' }, { lib: 'Institution', value: 'institution', 'filtering': 'type_structure', lib_all: 'Toutes structures', lib_title: 'Type de structure' }, { lib: 'Privé', value: 'prive', 'filtering': 'type_structure', lib_all: 'Toutes structures', lib_title: 'Type de structure' }, { lib: 'Structure de pêche de loisir', value: 'peche_loisir', 'filtering': 'type_structure', lib_all: 'Toutes structures', lib_title: 'Type de structure' }],
      activateOnceTypeStructure: true,
      checked_rapport: false,
      minDate: 1990,
      maxDate: 2024,
      minSelectedDate: 1990,
      maxSelectedDate: 2024,
      slider: null,
      travaux_layer: null,
      checked_travaux_vector_layer: false,
      draw_travaux: false,
      draw_travaux_evt_key: null,
      firstGroup: firstGroup,
      rivieresGroup: rivieresGroup,
      contextTitle: 'Bassin Seine Normandie',
      current_zoom: 7,
      current_center: [1.834108, 48.528835],
      queryable_layers: [],
      correspondances: [],
      basemap: 'OPENSTREETMAP-CARTO-POSITRON',
      locked_cadenas: false,
      show_couches: false,
      show_poissons: false,
      show_poissons_popup: true,
      show_cours_eau: false,
      show_block_stat: false,
      show_block_interpretation: false,
      show_block_stat_echantillonnage: false,
      show_block_stat_restauration: false,
      show_block_poissons: false,
      show_block_rivieres: false,
      show_block_actions: false,
      show_block_obstacles: false,
      show_toggletopdown_poissons: true,
      show_togglelateral_poissons: true,
      show_toggletopdown_rivieres: true,
      show_toggletopdown_obstacles: true,
      show_block_stations: true,
      show_togglelateral_rivieres: true,
      show_toggletopdown_actions: true,
      show_togglelateral_actions: true,
      show_restauration_ecologique: false,
      show_especes_categories: {
        enp: false,
        eih: false
      },
      selected_especes: [], // 2, 3
      checkboxes_left_menu: {
        checked_stations_echantillonnage: false, // 1
        // checked_qualite_eau: false,
        especes_temps: 'temps_etat__all',
        especes_protocole: 'protocole_full',
        checked_richesse_specifique: false, // 4 (5 non inclus)
        checked_etat_ipr: false, // 6,
        checked_assemblage_pisci_ref: false, // 6bis
        checked_qualite_eau_etat_pc: false, // 7
        checked_qualite_eau_etat_ps: false, // 8
        checked_qualite_eau_bio: false, // 9
        checked_diversite_habitat: false, // 13
        checked_presence_ripisylve: false, // 14,
        checked_erosion_sol: false, // 14bis
        checked_qualite_localisation_obst: false, // 15
        checked_taux_etag: false, // 16
        checked_taux_frac: false, // 17
        checked_prio_restau: false, // 18
        checked_localisation_typologie: false // 20
      },
      handleClickControlPrint: function handleClickControlPrint() {},
      disable_full: false,
      fond_cartes: false,
      left_panel: true,
      right_panel: true,
      legend_panel: false,
      legends: [],
      // show_popup: true,
      popup_element: '',
      popup_travaux: '',
      is_user_logged_in: false,
      textTextArea: '',
      idInfo: '',
      idInfoEvolution: '',
      linkText: '',
      textPdfArea: '',
      idPdf: '',
      external_url: '',
      linkPdfText: '',
      especes: especes_sorted_by_nom_commun,
      baseURL: 'https://www.observatoire-poissons-seine-normandie.fr',
      baseUrlCarto: 'https://www.observatoire-poissons-seine-normandie.fr',
      current_full_url: '',
      // url_article_poisson: undefined,
      // url_image_poisson: undefined,
      pieChartEchantillonnage: null,
      barChartEchantillonnage: null,
      pieChartTravaux: null,
      barChartTravaux: null,
      barChartIPR: null,
      barChartEvolutionSpecies: null,
      pieContextePiscicoleSalmonicole: null,
      pieContextePiscicoleIntermediaire: null,
      pieContextePiscicoleCyprinicole: null,
      commentEvolutionEspeces: null,
      commentRichesseSpecifiqueEvolution: null,
      especesEtatCommentsCache: {},
      especesEtatComments: null,
      layers_background_list: [{
        "title": "Satellite",
        "identifier": "ORTHOIMAGERY.ORTHOPHOTOS",
        "format": "image/jpeg",
        "styles": ["normal"],
        "opacity": 0.5,
        "type": "WMTS-IGN",
        "picto": "picto-carte-satellite.png",
        "basemap": true
      }, {
        "title": "Carte IGN",
        "identifier": "GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2",
        "format": "image/png",
        "styles": ["normal"],
        "opacity": 0.5,
        "type": "WMTS-IGN",
        "picto": "picto-carte-ign.png",
        "basemap": true
      }, {
        "title": "OSM",
        "title_alt": "OpenStreetMap",
        "identifier": "OPENSTREETMAP-CARTO-POSITRON",
        "type": "XYZ",
        "url": "https://{a-d}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_333x_1_8aced4398b94c5fcd4316790",
        "picto": "picto-carte-osm.png",
        "basemap": true
      }, {
        "title": "Parcelles cadastrales",
        "identifier": "CADASTRALPARCELS.PARCELS",
        "format": "image/png",
        "styles": ["normal"],
        "type": "WMTS-IGN",
        "basemap": false
      }, {
        "title": "Départements",
        "identifier": "departements",
        "url": "https://www.observatoire-poissons-seine-normandie.fr/geoserver/general/wms",
        "params": {
          "FORMAT": "image/png",
          "VERSION": "1.1.1",
          "STYLES": "departements_bsn_untiled",
          "LAYERS": "general:departements_bsn"
        },
        "type": "WMS-UNTILED",
        "basemap": false
      }, {
        "title": "Bassins versants",
        "identifier": "bassinsversants",
        "url": "https://www.observatoire-poissons-seine-normandie.fr/geoserver/general/wms",
        "params": {
          "FORMAT": "image/png",
          "VERSION": "1.1.1",
          "STYLES": "secteurs_bsn_untiled",
          "LAYERS": "general:secteurs_bsn"
        },
        "type": "WMS-UNTILED",
        "basemap": false
      }, {
        "title": "Cours d'eau",
        "identifier": "courseau_fxx",
        "url": "https://www.observatoire-poissons-seine-normandie.fr/geoserver/general/wms",
        "params": {
          "FORMAT": "image/png",
          "VERSION": "1.1.1",
          "STYLES": "",
          "LAYERS": "general:courseau_fxx"
        },
        "type": "WMS",
        "basemap": false
      }].map(function (el) {
        el.visible = ['courseau_fxx', 'OPENSTREETMAP-CARTO-POSITRON'].includes(el.identifier);
        return el;
      })
    };
  },

  asyncComputed: {
    url_article_poisson: function url_article_poisson() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var codeEspece, idLayer, matching, id, url, url_article;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                codeEspece = '';

                if (_this7.selected_especes[0]) {
                  codeEspece = _this7.selected_especes[0].replace('temps_', '');
                }
                idLayer = _this7.getIdLayer(codeEspece);
                matching = _this7.correspondances.find(function (el) {
                  return el.id == idLayer;
                });
                // debugger;

                if (!matching) {
                  _context2.next = 14;
                  break;
                }

                id = matching.id.split('_')[1].toLowerCase();

                if (['ccu', 'cmi'].includes(id)) {
                  id = 'cco';
                }

                url = _this7.baseURL + '/wp-admin/admin-ajax.php?action=opsn_poisson_get&id=' + id;
                _context2.next = 10;
                return fetch(url).then(function (response) {
                  return response.json();
                }).then(function (json) {
                  return json.url !== 'false' ? json.url : undefined;
                });

              case 10:
                url_article = _context2.sent;
                return _context2.abrupt('return', url_article);

              case 14:
                return _context2.abrupt('return', undefined);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    url_image_poisson: function url_image_poisson() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var codeEspece, idLayer, matching, id, url, url_photo;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                codeEspece = void 0;

                if (_this8.selected_especes.length > 0) {
                  codeEspece = _this8.selected_especes[0].replace('temps_', '');
                } else {
                  codeEspece = 'empty';
                }
                idLayer = _this8.getIdLayer(codeEspece);
                matching = _this8.correspondances.find(function (el) {
                  return el.id == idLayer;
                });
                // debugger;

                if (!matching) {
                  _context3.next = 14;
                  break;
                }

                id = matching.id.split('_')[1].toLowerCase();

                if (['ccu', 'cmi'].includes(id)) {
                  id = 'cco';
                }
                url = _this8.baseURL + '/wp-admin/admin-ajax.php?action=opsn_poisson_get&id=' + id;
                _context3.next = 10;
                return fetch(url).then(function (response) {
                  return response.json();
                }).then(function (json) {
                  return json.photo !== 'false' ? json.photo : undefined;
                  // this.url_image_poisson = json.photo !== 'false' ? json.photo : undefined;
                  // this.url_article_poisson = json.url !== 'false' ? json.url : undefined;
                });

              case 10:
                url_photo = _context3.sent;
                return _context3.abrupt('return', url_photo);

              case 14:
                return _context3.abrupt('return', undefined);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8);
      }))();
    }
  },
  computed: {
    title_espece: function title_espece() {
      var codeEspece = void 0;
      if (this.selected_especes.length > 0) {
        codeEspece = this.selected_especes[0].replace('temps_', '');
      } else {
        codeEspece = 'empty';
      }
      var idLayer = this.getIdLayer(codeEspece);
      var matching = this.correspondances.find(function (el) {
        return el.id == idLayer;
      });
      if (matching) {
        return matching.layer.title;
      } else {
        return null;
      }
    },
    categories: function categories() {
      var _this9 = this;

      var tickboxExceptEspeces = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(this.checkboxes_left_menu).filter(function (el) {
        return !el.startsWith('especes_');
      }).filter(function (el) {
        return _this9.checkboxes_left_menu[el];
      });

      var category1 = tickboxExceptEspeces.filter(function (el) {
        return el === 'checked_stations_echantillonnage';
      });
      var subCategory1FromCategory2 = tickboxExceptEspeces.filter(function (el) {
        return ['checked_localisation_typologie', 'checked_stations_echantillonnage'].indexOf(el) === -1;
      });
      var subCategory2FromCategory2 = this.selected_especes.length > 0;

      var category2 = subCategory1FromCategory2.length > 0 || subCategory2FromCategory2;
      var category3 = tickboxExceptEspeces.filter(function (el) {
        return el === 'checked_localisation_typologie';
      });

      return [category1.length > 0, [subCategory1FromCategory2.length > 0, subCategory2FromCategory2], category3.length > 0];
    },
    display_evolution_chart: function display_evolution_chart() {
      return (this.checkboxes_left_menu.especes_temps === 'temps__evolution' || this.checkboxes_left_menu.especes_temps === 'temps_evolution') && ['protocole_complet', 'protocole_ponctuel', 'protocole_full'].includes(this.checkboxes_left_menu.especes_protocole) && this.idInfoEvolution && this.barChartEvolutionSpecies && this.barChartEvolutionSpecies.data && this.barChartEvolutionSpecies.data.length > 0;
    },
    display_comment_etat: function display_comment_etat() {
      return (/temps[_]*etat/.test(this.checkboxes_left_menu.especes_temps) && this.selected_especes.length > 0
      );
    },
    display_comment_evolution: function display_comment_evolution() {
      return (/temps[_]*evolution/.test(this.checkboxes_left_menu.especes_temps) && this.selected_especes.length > 0
      );
    },
    legend_poisson: function legend_poisson() {
      var _this10 = this;

      // return [];
      if (this.correspondances.length > 0) {
        var filtered = this.correspondances.find(function (el) {
          return el.id === _this10.selected_especes[0] + '_' + _this10.checkboxes_left_menu.especes_temps.replace('temps_', '') + '_' + _this10.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
        });
        if (filtered) {
          var legends = [{
            layerLabel: filtered.layer.title_legend || filtered.layer.title,
            layerName: filtered.layer.params.LAYERS
          }];
          var contentLegends = legends.map(function (el) {
            var keysVals = getLegendGraphicOptions(el.layerName);
            var urlCouche = _this10.baseUrlCarto + '/geoserver/general/wms?' + __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(keysVals).map(function (key) {
              return key + '=' + keysVals[key];
            }).join('&');
            return {
              layerLabel: el.layerLabel,
              layerUrl: urlCouche
            };
          });
          return contentLegends;
        }
      } else {
        return [];
      }
    },
    legend_travaux_restauration: function legend_travaux_restauration() {
      if (this.correspondances.length > 0) {
        var filtered = void 0;
        if (this.checkboxes_left_menu.checked_localisation_typologie) {
          filtered = this.correspondances.find(function (el) {
            return el.id === 'checked_localisation_typologie';
          });
          var keysVals = getLegendGraphicOptions(filtered.layer.params.LAYERS);
          var urlCouche = this.baseUrlCarto + '/geoserver/general/wms?' + __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(keysVals).map(function (key) {
            return key + '=' + keysVals[key];
          }).join('&');
          return urlCouche;
        }
      }
    },
    legend_to_show: function legend_to_show() {
      var _this11 = this;

      if (this.correspondances.length > 0) {
        var legends = [];
        this.legends = [];
        // Category 1
        if (this.categories[0]) {
          legends.push({
            layerLabel: 'Stations d\'échantillonnage',
            layerName: 'general:stations_echantillonnage'
          });
        }
        // Category 2
        if (this.categories[1][0] || this.categories[1][1]) {
          var filtered = void 0;
          var layerObj = void 0;
          if (this.categories[1][0]) {
            var tickboxExceptEspeces = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(this.checkboxes_left_menu).filter(function (el) {
              return !el.startsWith('especes_');
            }).filter(function (el) {
              return _this11.checkboxes_left_menu[el];
            }).filter(function (el) {
              return ['checked_localisation_typologie', 'checked_stations_echantillonnage'].indexOf(el) === -1;
            });
            filtered = this.correspondances.find(function (el) {
              return el.id === tickboxExceptEspeces[0];
            });
          }
          if (this.categories[1][1]) {
            filtered = this.correspondances.find(function (el) {
              return el.id === _this11.selected_especes[0] + '_' + _this11.checkboxes_left_menu.especes_temps.replace('temps_', '') + '_' + _this11.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
            });
          }
          layerObj = {
            layerLabel: filtered.layer.title_legend || filtered.layer.title,
            layerName: filtered.layer.params.LAYERS
          };
          legends.push(layerObj);
        }
        // Category 3
        if (this.categories[2]) {
          ['checked_localisation_typologie'].forEach(function (cat3el) {
            if (_this11.checkboxes_left_menu[cat3el]) {
              var _filtered = _this11.correspondances.find(function (el) {
                return el.id === cat3el;
              });
              legends.push({
                layerLabel: _filtered.layer.title_legend || _filtered.layer.title,
                layerName: _filtered.layer.params.LAYERS
              });
            }
          });
        }

        var contentLegends = legends.map(function (el) {
          var keysVals = getLegendGraphicOptions(el.layerName);
          var urlCouche = _this11.baseUrlCarto + '/geoserver/general/wms?' + __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(keysVals).map(function (key) {
            return key + '=' + keysVals[key];
          }).join('&');
          return {
            layerLabel: el.layerLabel,
            layerName: urlCouche
          };
        });
        this.legends = legends;
        return contentLegends;
      } else {
        this.legends = [];
        return [];
      }
    }
  },
  watch: {
    show_block_stat_restauration: function show_block_stat_restauration(newVal, oldVal) {
      if (newVal) {
        this.mapSetHash();

        if (this.selected_especes.length > 0) {
          this.updateFromContext(true);
        } else {
          this.updateFromContext(false);
        }
      }
    },
    checked_travaux_vector_layer: function checked_travaux_vector_layer(val) {
      this.travaux_layer.setVisible(val);
      if (this.selected_especes.length > 0) {
        this.updateFromContext(val);
      } else {
        this.updateFromContext(val);
      }
    },
    right_panel: function right_panel(val) {
      if (!val && this.highlight_layer) {
        this.highlight_layer.getSource().clear();
      }
    },
    travaux_filters: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler: function handler(val) {
        // If one type of operation ticked among all, show the layer
        if (val && val.filter(function (filter) {
          return filter.filtering == 'type_op';
        }).some(function (filter) {
          return filter.checked;
        })) {
          // this.checked_travaux_vector_layer = true;
          this.foldAllExcept('show_toggletopdown_actions');
          // If no filter on type of structure, tick all to be sure to show something
          if (this.activateOnceTypeStructure) {
            if (val.filter(function (filter) {
              return filter.filtering == 'type_structure' && filter.checked;
            }) == 0) {
              val.filter(function (filter) {
                return filter.filtering == 'type_structure';
              }).forEach(function (element) {
                element.checked = true;
              });
              this.activateOnceTypeStructure = false;
            }
          }

          if (val.some(function (filter) {
            return filter.filtering == 'type_structure' && filter.checked;
          })) {
            this.checked_travaux_vector_layer = true;
          } else {
            this.checked_travaux_vector_layer = false;
          }
          // console.log(this.write_filter_travaux());
          this.travaux_layer.getSource().refresh();
          this.mapSetHash();
        } else {
          this.checked_travaux_vector_layer = false;
          val.filter(function (filter) {
            return filter.filtering == 'type_structure';
          }).forEach(function (element) {
            element.checked = false;
          });
          this.activateOnceTypeStructure = true;
          this.minSelectedDate = this.minDate;
          this.maxSelectedDate = this.maxDate;
          this.slider.range(this.minSelectedDate, this.maxSelectedDate);
          this.checked_rapport = false;
        }
        // this.mapSetHash();
      }
    },
    minSelectedDate: function minSelectedDate(val) {
      this.travaux_layer.getSource().refresh();
      this.mapSetHash();
    },
    maxSelectedDate: function maxSelectedDate(val) {
      this.travaux_layer.getSource().refresh();
      this.mapSetHash();
    },
    checked_rapport: function checked_rapport(val) {
      this.travaux_layer.getSource().refresh();
      this.mapSetHash();
    }
  },
  methods: {
    reInitializeLayers: function reInitializeLayers() {
      this.checked_travaux_vector_layer = false;
      // this.resetGroup1();
      this.show_toggletopdown_poissons = false;
      this.show_toggletopdown_rivieres = false;
      this.show_toggletopdown_obstacles = false;
      this.show_toggletopdown_actions = false;

      this.show_block_stat = false;
      this.show_block_interpretation = false;
      this.show_block_stat_echantillonnage = false;
      this.show_block_stat_restauration = false;
      this.show_block_poissons = false;
      this.show_block_rivieres = false;
      this.show_block_actions = false;
      this.show_block_obstacles = false;

      this.selected_especes = [];
      var keys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.checkboxes_left_menu).filter(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return !key.startsWith('especes_');
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref4 = _step.value;

          var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref4, 2);

          var _key = _ref5[0];
          var value = _ref5[1];

          if (value) {
            this.checkboxes_left_menu[_key] = false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.travaux_filters.forEach(function (filter) {
        filter.checked = false;
      });
      this.minSelectedDate = this.minDate;
      this.maxSelectedDate = this.maxDate;
      this.slider.range(this.minSelectedDate, this.maxSelectedDate);
      this.checked_rapport = false;

      this.activateOnceTypeStructure = true;
      this.$forceUpdate();
      this.mapSetHash();
    },
    getIdLayer: function getIdLayer(codeEspece) {
      var idLayer = void 0;
      if (this.checkboxes_left_menu.especes_temps.endsWith('_evolution')) {
        idLayer = 'points' + '_' + codeEspece + '_' + 'stations' + '_' + this.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '') + '_' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
      } else {
        idLayer = 'points' + '_' + codeEspece + '__' + this.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '').split('__')[0] + '__' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '') + '__' + this.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '').split('__')[1];
      }
      return idLayer;
    },
    findLayerInCorrespondances: function findLayerInCorrespondances(key) {
      var copy_key = key;
      if (key === 'checked_richesse_specifique') {
        var parts = this.checkboxes_left_menu.especes_temps.split('__');
        var suffix = 'evolution';
        if (parts.length > 0) {
          var _parts$slice = parts.slice(-1);

          var _parts$slice2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_parts$slice, 1);

          suffix = _parts$slice2[0];
        }
        copy_key = 'richesse_specifique__full__' + suffix;
      }
      if (key === 'checked_etat_ipr') {
        if (this.checkboxes_left_menu.especes_temps.includes('evolution')) {
          this.checkboxes_left_menu.especes_temps = 'temps_etat__all';
        };
        var _parts = this.checkboxes_left_menu.especes_temps.split('__');

        var _parts$slice3 = _parts.slice(-1),
            _parts$slice4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_parts$slice3, 1),
            _suffix = _parts$slice4[0];

        copy_key = 'etat_ipr__' + _suffix;
      }
      return this.correspondances.find(function (el) {
        return el.id === copy_key;
      });
    },
    zoomToInitialExtent: function zoomToInitialExtent() {
      this.map.getView().fit(extentZoom);
    },
    openInformationsPDF: function openInformationsPDF() {
      window.open('static/pdf/regles opsn.pdf');
    },

    copyUrlToClipboard: function copyUrlToClipboard() {
      var _this12 = this;

      var url = 'https://tinyurl.com/api-create.php?url=' + encodeURIComponent(this.current_full_url);
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (text) {
        console.log('text', text);
        _this12.$copyText(text).then(function (e) {
          console.log('Copied', e);
        }, function (e) {
          console.log('Can not copy', e);
        });
      });
    },
    openExternalUrl: function openExternalUrl() {
      window.open(this.external_url);
    },
    clickParent: function clickParent(subfilter, typefilter) {
      var filters = this.travaux_filters.filter(function (filter) {
        return filter.filtering == typefilter;
      }).filter(function (filter) {
        return filter.filtering == subfilter[0].filtering;
      });
      if (filters.find(function (filter) {
        return !filter.checked;
      })) {
        filters.forEach(function (filter) {
          return filter.checked = true;
        });
      } else {
        filters.forEach(function (filter) {
          return filter.checked = false;
        });
      }
    },
    foldAllExcept: function foldAllExcept(show_toggletopdown_key) {
      var keys = ['show_toggletopdown_poissons', 'show_toggletopdown_rivieres', 'show_toggletopdown_obstacles', 'show_toggletopdown_actions'];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _key2 = _step2.value;

          if (_key2 !== show_toggletopdown_key) {
            this[_key2] = false;
          } else {
            this[_key2] = true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    filters_travaux: function filters_travaux(filtering) {
      return this.travaux_filters.filter(function (travaux) {
        return travaux.filtering == filtering;
      }).reduce(function (acc, curr) {
        if (!(curr.filtering in acc)) {
          acc[curr.filtering] = [];
        }
        acc[curr.filtering].push(curr);
        return acc;
      }, {});
    },
    filter_travaux_layer_style: function filter_travaux_layer_style(feature) {
      var params = this.write_filter_travaux();
      var type_op = true;
      if ('type_op' in params && params['type_op'].length > 0) {
        type_op = params['type_op'].includes(feature.get('type_op'));
      }
      var type_structure = true;
      if ('type_structure' in params && params['type_structure'].length > 0) {
        type_structure = params['type_structure'].includes(feature.get('type_structure'));
      }
      var fichier = true;
      if ('fichier' in params) {
        fichier = feature.get('fichier').length > 0 || feature.get('url').length > 0;
      }
      var annee_rec = true;
      if ('annee_rec' in params) {
        var _params$annee_rec$spl = params['annee_rec'].split(','),
            _params$annee_rec$spl2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_params$annee_rec$spl, 2),
            min = _params$annee_rec$spl2[0],
            max = _params$annee_rec$spl2[1];

        annee_rec = feature.get('annee_rec') >= min && feature.get('annee_rec') <= max;
      }
      return type_op && type_structure && fichier && annee_rec;
    },
    write_filter_travaux: function write_filter_travaux() {
      var json = this.travaux_filters.reduce(function (acc, curr) {
        if (!(curr.filtering in acc)) {
          acc[curr.filtering] = [];
        }
        acc[curr.filtering].push(curr);
        return acc;
      }, {});
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(json)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref6 = _step3.value;

          var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref6, 2);

          var _key3 = _ref7[0];
          var value = _ref7[1];

          if (value.length > 0) {
            json[_key3] = value.filter(function (filter) {
              return filter.checked;
            }).map(function (element) {
              return element.value;
            });
          } else {
            json[_key3] = [];
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (this.checked_rapport) {
        json['fichier'] = true;
      }
      if (this.minSelectedDate != this.minDate || this.maxSelectedDate != this.maxDate) {
        json['annee_rec'] = this.minSelectedDate + ',' + this.maxSelectedDate;
      }
      return json;
    },
    activateDrawingTravaux: function activateDrawingTravaux() {
      var _this13 = this;

      if (!this.draw_travaux) {
        this.draw_travaux = true;
        this.right_panel = false;
        this.map.getViewport().style.cursor = this.draw_travaux ? 'crosshair' : '';
        this.draw_travaux_evt_key = this.map.once('click', function (evt) {
          var _ol$proj$transform = __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.transform(evt.coordinate, 'EPSG:3857', proj2154),
              _ol$proj$transform2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ol$proj$transform, 2),
              x_l93 = _ol$proj$transform2[0],
              y_l93 = _ol$proj$transform2[1];

          _this13.draw_travaux = false;
          _this13.map.getViewport().style.cursor = '';
          window.open(_this13.baseURL + '/carte/gestion/?type=action&id=new&x_l93=' + x_l93 + '&y_l93=' + y_l93);
        });
      } else {
        if (this.draw_travaux_evt_key) {
          __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.Observable.unByKey(this.draw_travaux_evt_key);
        }
        this.draw_travaux = false;
        this.map.getViewport().style.cursor = '';
      }
    },
    resetGroup1: function resetGroup1() {
      if (this.selected_especes.length > 0) {
        this.selected_especes = [];
      }
      if (this.check_if_first_group()) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.firstGroup), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _key4 = _step4.value;

            if (this.checkboxes_left_menu[_key4]) {
              this.checkboxes_left_menu[_key4] = false;
              break;
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    },
    resetGroupRivieres: function resetGroupRivieres() {
      if (this.check_if_rivieres_group()) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.rivieresGroup), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _key5 = _step5.value;

            if (this.checkboxes_left_menu[_key5]) {
              this.checkboxes_left_menu[_key5] = false;
              break;
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
    },
    get_legend_url: function get_legend_url(idLayer) {
      var withScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.correspondances.length > 0) {
        if (idLayer in this.checkboxes_left_menu || this.selected_especes.length > 0) {
          var filtered = this.findLayerInCorrespondances(idLayer);
          if (idLayer === undefined) {
            return '';
          } else {
            var keysVals = getLegendGraphicOptions(filtered.layer.params.LAYERS);
            if (withScale) {
              keysVals['SCALE'] = String(this.mapScale(72));
            }
            var urlCouche = this.baseUrlCarto + '/geoserver/general/wms?' + __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(keysVals).map(function (key) {
              return key + '=' + encodeURIComponent(keysVals[key]);
            }).join('&');
            return urlCouche;
          }
        }
      }
    },

    set_title_bar_first_group: function set_title_bar_first_group() {
      var self1 = this;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self1.firstGroup), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var k = _step6.value;

          if (this.checkboxes_left_menu[k]) {
            var filtered = this.findLayerInCorrespondances(k);
            return filtered.layer.title.split(' — ')[0];
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    },
    set_title_bar_rivieres_group: function set_title_bar_rivieres_group() {
      var self1 = this;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self1.rivieresGroup), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var k = _step7.value;

          if (this.checkboxes_left_menu[k]) {
            var filtered = this.findLayerInCorrespondances(k);
            return filtered.layer.title.split(' — ')[0];
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    },
    check_if_first_group: function check_if_first_group() {
      var _this14 = this;

      var present = this.firstGroup.filter(function (key) {
        return _this14.checkboxes_left_menu[key];
      });
      return present.length > 0;
    },
    check_if_rivieres_group: function check_if_rivieres_group() {
      var _this15 = this;

      var present = this.rivieresGroup.filter(function (key) {
        return _this15.checkboxes_left_menu[key];
      });
      return present.length > 0;
    },
    isGroup1: function isGroup1() {
      return this.selected_especes.length > 0 || this.check_if_first_group();
    },
    get_first_group_key: function get_first_group_key() {
      var _this16 = this;

      var present = this.firstGroup.filter(function (key) {
        return _this16.checkboxes_left_menu[key];
      });
      if (present.length > 0) {
        return present[0];
      }
    },
    get_rivieres_group_key: function get_rivieres_group_key() {
      var _this17 = this;

      var present = this.rivieresGroup.filter(function (key) {
        return _this17.checkboxes_left_menu[key];
      });
      if (present.length > 0) {
        return present[0];
      }
    },
    switch_left_panel: function switch_left_panel() {
      this.left_panel = !this.left_panel;
      // if (this.left_panel && (window.screen.width * window.devicePixelRatio) <= 1024) {
      //   this.right_panel = false;
      // }
    },
    switch_right_panel: function switch_right_panel() {
      this.right_panel = !this.right_panel;
      // if (this.right_panel && (window.screen.width * window.devicePixelRatio) <= 1024) {
      //   this.left_panel = false;
      // }
    },
    selectBaseMap: function selectBaseMap(identifier) {
      this.basemap = identifier;
      this.map.getLayers().getArray().filter(function (el) {
        if (el.get('basemap')) {
          return true;
        }
        return false;
      }).forEach(function (el) {
        if (el.get('identifier') === identifier) {
          el.setVisible(true);
        } else {
          if (el.getVisible()) {
            el.setVisible(false);
          }
          // el.setVisible(!el.getVisible());
        }
      });
    },
    checkboxToggle: function checkboxToggle(evt) {
      var _this18 = this;

      this.map.getLayers().getArray().filter(function (el) {
        return el.get('identifier') === evt.target.getAttribute('data-identifier');
      }).forEach(function (el) {
        el.setVisible(!el.getVisible());

        _this18.layers_background_list.filter(function (el1) {
          return el1.identifier === el.get('identifier');
        }).forEach(function (el2) {
          el2.visible = el.getVisible();
        });
      });
    },
    switchFondCartes: function switchFondCartes(evt) {
      this.fond_cartes = !this.fond_cartes;
      // this.$refs.scrollmenuleft.clientHeight = 'calc(90% - ' + this.$refs.fondplan.clientHeight + 'px)';
    },
    refreshText: function refreshText(layerId, idElement) {
      var _this19 = this;

      var idInfo = layerId + '__n_action__' + idElement;
      this.idInfo = idInfo;
      // TODO: debug when undefined
      fetch(this.baseURL + '/wp-admin/admin-ajax.php?action=opsnmap_get&type=info&id=' + idInfo).then(function (response) {
        return response.json();
      }).then(function (json) {
        // var textTextArea = '';
        // var linkText = '';
        if ('info' in json && json.info) {
          _this19.textTextArea = json.info;
          _this19.linkText = 'Modifier la description';
        } else {
          _this19.textTextArea = ''; //'<br>Il n\'y a pas de texte associé';
          _this19.linkText = 'Éditer la description';
        }
        if (window.is_user_logged_in) {
          _this19.is_user_logged_in = window.is_user_logged_in;
        }
      });
    },
    refreshPdf: function refreshPdf(layerId, idElement) {
      var _this20 = this;

      var idPdf = layerId + '__n_action__' + idElement;
      this.idPdf = idPdf;
      fetch(this.baseURL + '/wp-admin/admin-ajax.php?action=opsnmap_get&type=pdf&id=' + idPdf).then(function (r) {
        return r.json();
      }).catch(function (error) {
        console.log(error);
      }).then(function (json) {
        if ('file' in json) {
          _this20.textPdfArea = '<a target="_blank" href="' + json.file + '">' + '<img src="' + json.thumbnail + ' "/>' + '</a>';
          _this20.linkPdfText = "Modifier cette action";
        } else {
          _this20.textPdfArea = '';
          _this20.linkPdfText = "Modifier cette action";
        }
        if (window.is_user_logged_in) {
          _this20.is_user_logged_in = window.is_user_logged_in;
        }
      });
    },
    mapSetHash: function mapSetHash() {
      var _this21 = this;

      var urlParams = {
        path: this.$router.history.current.path
      };

      var params = {};

      var k1 = 'checked_stations_echantillonnage';
      var k2s = ['checked_localisation_typologie'];
      var k3 = 'checked_qualite_localisation_obst';
      var excludeCategory1AndCategory3 = [k1].concat(k2s);
      var ks = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(this.checkboxes_left_menu).filter(function (el) {
        return excludeCategory1AndCategory3.indexOf(el) === -1;
      }).filter(function (el) {
        return !el.startsWith('especes_');
      });
      var layers = [];

      if (this.map.getView().getZoom()) {
        this.current_zoom = this.map.getView().getZoom();
      }
      if (this.map.getView().getCenter()) {
        this.current_center = __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.toLonLat(this.map.getView().getCenter()).map(function (coord) {
          return coord.toFixed(5);
        });
      }

      // category 1
      if (this.categories[0]) {
        layers.push(k1);
      }
      // category 2 sub 1
      if (this.categories[1][0]) {
        var result = ks.filter(function (el) {
          return !el.startsWith('especes_');
        }).filter(function (el) {
          return _this21.checkboxes_left_menu[el];
        }).map(function (el) {
          var copy_k = el;
          if (el === 'checked_richesse_specifique') {
            var parts = _this21.checkboxes_left_menu.especes_temps.split('__');
            var suffix = 'evolution';
            if (parts.length > 0) {
              var _parts$slice5 = parts.slice(-1);

              var _parts$slice6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_parts$slice5, 1);

              suffix = _parts$slice6[0];
            }
            copy_k = 'richesse_specifique__full__' + suffix;
          }
          if (el === 'checked_etat_ipr') {
            var _parts2 = _this21.checkboxes_left_menu.especes_temps.split('__');

            var _parts2$slice = _parts2.slice(-1),
                _parts2$slice2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_parts2$slice, 1),
                _suffix2 = _parts2$slice2[0];

            copy_k = 'etat_ipr__' + _suffix2;
          }
          return copy_k;
        });
        layers = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(layers), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(result));
      }
      // category 2 sub 2
      if (this.categories[1][1]) {
        if (this.selected_especes.length > 0) {
          var _result = this.getIdLayer(this.selected_especes[0].split('_')[1]).replace('temps_temps_', 'temps_');
          layers.push(_result);
        }
      }
      // Category 3
      if (this.categories[2]) {
        layers.push(k2s[0]);
      }

      params['map'] = [this.current_zoom].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.current_center)).join('/');

      if (layers.length > 0) {
        params['layers'] = layers.join(',');
      }
      // debugger;
      var filter_travaux = this.write_filter_travaux();
      var _arr = ['type_op', 'type_structure'];
      for (var _i = 0; _i < _arr.length; _i++) {
        var col = _arr[_i];
        if (col in filter_travaux && filter_travaux[col].length > 0) {
          params[col] = filter_travaux[col].join(',');
        }
      }
      var _arr2 = ['fichier', 'annee_rec'];
      for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
        var _col = _arr2[_i2];
        if (_col in filter_travaux) {
          params[_col] = filter_travaux[_col];
        }
      }

      urlParams['hash'] = '#' + __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
        return [key, params[key]].join('=');
      }).join('&');
      this.$router.push(urlParams);
      this.current_full_url = global.window.location.href;
    },
    mapGetHash: function mapGetHash() {
      var _this22 = this;

      var hash = this.$router.history.current.hash;
      if (hash) {
        var keys_vals = hash.replace('#', '').split('&').reduce(function (acc, kv) {
          var kv1 = kv.split('=');
          acc[kv1[0]] = kv1[1];
          return acc;
        }, {});
        if ('map' in keys_vals) {
          var xyz = keys_vals.map.split('/');
          this.current_zoom = Number(xyz[0]);
          this.current_center = xyz.slice(1, 3).map(function (coord) {
            return Number(coord);
          });
        }
        if ('layers' in keys_vals && keys_vals['layers'] !== undefined) {
          var layers = keys_vals['layers'].split(',');
          layers.forEach(function (layer) {
            // If species
            if (layer.indexOf('temps_') == 0 || layer.indexOf('points_') == 0 || layer.indexOf('pointsnext_') == 0) {
              var layer_no_prefix = layer.replace(/temps[_]*/, '').replace(/pointsnext[_]*/, '').replace(/points[_]*/, '');
              var sub = layer.split('_');
              _this22.selected_especes.push('temps_' + layer_no_prefix.split('_')[0]);
              var especes_temps = void 0;
              var especes_protocole = void 0;
              if (layer.includes('evolution')) {
                especes_temps = '_evolution';
                especes_protocole = layer_no_prefix.slice(layer_no_prefix.indexOf(especes_temps) + especes_temps.length + 1, layer_no_prefix.length);
              } else {
                var intermediate = layer_no_prefix.replace(/[a-z]*[_]*/, '').split('__');
                especes_temps = intermediate[0] + '__' + intermediate[2];
                especes_protocole = intermediate[1];
              }
              _this22.checkboxes_left_menu.especes_temps = 'temps_' + especes_temps;
              _this22.checkboxes_left_menu.especes_protocole = 'protocole_' + especes_protocole;
            } else if (layer.startsWith('richesse_specifique')) {
              if (layer.includes('evolution')) {
                _this22.checkboxes_left_menu.especes_temps = 'temps__evolution';
              } else {
                _this22.checkboxes_left_menu.especes_temps = 'temps_etat__' + layer.split('__').slice(-1);
              }
              _this22.checkboxes_left_menu.checked_richesse_specifique = true;
            } else if (layer.startsWith('etat_ipr')) {
              _this22.checkboxes_left_menu.especes_temps = 'temps_etat__' + layer.split('__').slice(-1);
              _this22.checkboxes_left_menu.checked_etat_ipr = true;
            } else {
              _this22.checkboxes_left_menu[layer] = true;
            }
          });
        }

        if ('type_op' in keys_vals && keys_vals['type_op'].length > 0) {
          var type_op_s = keys_vals['type_op'].split(',');

          var _loop = function _loop(type_op) {
            _this22.travaux_filters.find(function (filter) {
              return filter.value === type_op;
            }).checked = true;
          };

          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(type_op_s), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var type_op = _step8.value;

              _loop(type_op);
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        } else {
          this.travaux_filters.filter(function (filter) {
            return filter.filtering === 'type_op';
          }).forEach(function (filter) {
            filter.checked = false;
          });
        }

        if ('type_structure' in keys_vals && keys_vals['type_structure'].length > 0) {
          var type_structure_s = keys_vals['type_structure'].split(',');

          var _loop2 = function _loop2(type_structure) {
            _this22.travaux_filters.find(function (filter) {
              return filter.value === type_structure;
            }).checked = true;
          };

          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(type_structure_s), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var type_structure = _step9.value;

              _loop2(type_structure);
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }
        } else {
          this.travaux_filters.filter(function (filter) {
            return filter.filtering === 'type_op';
          }).forEach(function (filter) {
            filter.checked = false;
          });
        }

        if ('fichier' in keys_vals && keys_vals['fichier'] === 'true') {
          this.checked_rapport = true;
        }
        if ('annee_rec' in keys_vals) {
          var _keys_vals$annee_rec$ = keys_vals['annee_rec'].split(','),
              _keys_vals$annee_rec$2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_keys_vals$annee_rec$, 2),
              min = _keys_vals$annee_rec$2[0],
              max = _keys_vals$annee_rec$2[1];

          this.minSelectedDate = min;
          this.maxSelectedDate = max;
        }
      }
    },
    updateChartsEchantillons: function updateChartsEchantillons(id, field) {
      if (this.checkboxes_left_menu.checked_stations_echantillonnage) {
        if (id) {
          this.pieChartEchantillonnage.fetchPieChart('static/piechart/secteur_all_years_' + id.toLowerCase() + '.json', field, transformData);
          this.barChartEchantillonnage.fetchBarChart('static/barchart/secteur_last_year_' + id.toLowerCase() + '.json', field);
        } else {
          this.pieChartEchantillonnage.fetchPieChart('static/piechart/circonscription_all_years_01.json', field, transformData);
          this.barChartEchantillonnage.fetchBarChart('static/barchart/circonscription_last_year_01.json', field);
        }
      }
    },
    updateEspecesEtatComments: function updateEspecesEtatComments(libelle, id) {
      var _this23 = this;

      if (this.selected_especes.length > 0) {
        var populateText = function populateText(json, id, libelle, article, genre) {
          if (json.zones[id]) {
            if (Number(json.zones[id]) > 0) {
              if (id == '01') {
                return '' + article + json.espece + ' est pr\xE9sent' + (genre == 'M' ? '' : 'e') + ' sur ' + Number(json.zones[id]).toFixed(2) + '%\n                des cours d\'eau \xE9chantillonn\xE9s du bassin Seine Normandie';
              } else {
                return '' + article + json.espece + ' est pr\xE9sent' + (genre == 'M' ? '' : 'e') + ' sur ' + Number(json.zones[id]).toFixed(2) + '%\n                des cours d\'eau \xE9chantillonn\xE9s du ' + libelle.replace(/^Le /, '');
              }
            } else {
              if (id == '01') {
                return '' + article + json.espece + ' n\'a pas \xE9t\xE9 identifi\xE9' + (genre == 'M' ? '' : 'e') + ' sur les cours d\'eau \xE9chantillonn\xE9s du bassin Seine Normandie';
              } else {
                return '' + article + json.espece + ' n\'a pas \xE9t\xE9 identifi\xE9' + (genre == 'M' ? '' : 'e') + ' sur les cours d\'eau \xE9chantillonn\xE9s du ' + libelle.replace(/^Le /, '');
              }
            }
          } else {
            var nom_commun = especes.find(function (esp) {
              return esp.code.toLowerCase() == espece;
            }).nom_commun;
            var bassin;
            if (that.contextTitle === 'Bassin Seine Normandie') {
              bassin = 'bassin Seine Normandie';
            } else if (that.contextTitle.length > 0) {
              bassin = that.contextTitle.replace(/^[lL]e /, '');
            }
            var comment = '' + article + nom_commun + ' n\'a pas \xE9t\xE9 \xE9chantillonn\xE9' + (genre == 'M' ? '' : 'e') + ' sur les cours d\'eau du ' + bassin;
            return comment;
          }
        };
        // On a deja récupéré la donnée


        var espece = this.selected_especes[0].replace('temps_', '').toLowerCase();
        var article = especes.find(function (esp) {
          return esp.code.toLowerCase() == espece;
        }).article;
        if (article !== 'L\'') {
          article += ' ';
        }
        var that = this;
        var genre = especes.find(function (esp) {
          return esp.code.toLowerCase() == espece;
        }).genre;
        if (espece in this.especesEtatCommentsCache) {
          this.especesEtatComments = populateText(this.especesEtatCommentsCache[espece], id, libelle, article, genre);
        } else {
          fetch('static/comments/especes_last_year_' + espece + '.json').then(function (response) {
            return response.json();
          }).then(function (json) {
            _this23.especesEtatCommentsCache[espece] = json;
            _this23.especesEtatComments = populateText(json, id, libelle, article, genre);
          });
        }
      }
    },
    updateChartsTravaux: function updateChartsTravaux(id, field) {
      if (this.checked_travaux_vector_layer) {
        if (id) {
          this.pieChartTravaux.fetchPieChart('static/piechart/secteur_travaux_all_years_' + id.toLowerCase() + '.json', field, transformData);
          this.barChartTravaux.fetchBarChart('static/barchart/secteur_travaux_last_year_' + id.toLowerCase() + '.json', field);
        } else {
          this.pieChartTravaux.fetchPieChart('static/piechart/circonscription_travaux_all_years_01.json', field, transformData);
          this.barChartTravaux.fetchBarChart('static/barchart/circonscription_travaux_last_year_01.json', field);
        }
      }
    },
    updateChartsIPR: function updateChartsIPR(id) {
      if (this.checkboxes_left_menu.checked_etat_ipr) {
        if (id) {
          var maxY = 30;
          this.barChartIPR.fetchBarChart('static/barchart/secteur_ipr_more_recent_' + id.toLowerCase() + '.json', maxY);
        } else {
          var _maxY = 231;
          this.barChartIPR.fetchBarChart('static/barchart/circonscription_ipr_more_recent_01.json', _maxY);
        }
      }
    },
    updateContextes: function updateContextes(id) {
      var _this24 = this;

      if (this.checkboxes_left_menu.checked_richesse_specifique) {
        var transformDataTrend = function transformDataTrend(json, field, colors, libelles) {
          // Only if some data in species
          if (json.species.length > 0) {
            var limit = 5;
            var sum = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(json.species[0]).reduce(function (acc, curr) {
              acc += json.species[0][curr];
              return acc;
            }, 0);
            var data = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(json.species[0]).filter(function (key) {
              return json.species[0][key] > 0;
            }).map(function (key) {
              var percentage = json.species[0][key] / sum * 100;
              return {
                name: key,
                count: json.species[0][key],
                percentage: __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_number_is_integer___default()(percentage) ? percentage : percentage.toFixed(2),
                color: colors[libelles.indexOf(key)]
              };
            }).slice().sort(function (a, b) {
              return a.count - b.count;
            });
            var orderedData = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(data.filter(function (r) {
              return +r.percentage >= limit;
            })));
            if (data.filter(function (r) {
              return +r.percentage < limit;
            }).length > 0) {
              orderedData = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(orderedData), [data.filter(function (r) {
                return +r.percentage < limit;
              }).reduce(function (acc, curr) {
                acc.count = acc.count + curr.count;
                var percentage = acc.count / sum * 100;
                acc.percentage = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_number_is_integer___default()(percentage) ? percentage : +percentage.toFixed(2);
                return acc;
              }, {
                name: 'Autres', count: 0, percentage: 0, color: '#943126'
              })]);
            }
            return orderedData;
          } else {
            return [];
          }
        };

        var secteur = void 0;
        var protocoles = ['salmonicole', 'intermediaire', 'cyprinicole'];

        if (id) {
          secteur = id;
          protocoles.forEach(function (protocole) {
            var variable = 'pieContextePiscicole' + upper(protocole);
            _this24[variable].fetchPieChart('static/piechart/contexte/contexte_piscicole_secteurs_' + secteur.toLowerCase() + '__' + protocole + '.json', undefined, transformDataTrend);
          });
        } else {
          secteur = '01';
          protocoles.forEach(function (protocole) {
            var variable = 'pieContextePiscicole' + upper(protocole);
            _this24[variable].fetchPieChart('static/piechart/contexte/contexte_piscicole_secteurs_' + secteur + '__' + protocole + '.json', undefined, transformDataTrend);
          });
        }
      }
    },
    updateCommentEvolutionEspeces: function updateCommentEvolutionEspeces(id) {
      var _this25 = this;

      if (this.selected_especes.length > 0) {
        // var protocole = this.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
        var protocole = 'full';
        var espece = this.selected_especes[0].replace('temps_', '').toLowerCase();
        var path = 'static/comments/evolution_secteurs_especes';
        fetch(path + '/comments_evolution_secteurs_' + espece + '__' + protocole + '.json').then(function (response) {
          return response.json();
        }).then(function (json) {
          var records = json.trends.filter(function (record) {
            return record.code.toLowerCase() === id.toLowerCase();
          });
          records.sort(function (a, b) {
            return a.count < b.count;
          });
          var sum_augmentation_diminution = records.reduce(function (acc, curr) {
            if (curr.trend !== 'stable') {
              acc = acc + curr.count;
            }
            return acc;
          }, 0);
          var sum_all = records.reduce(function (acc, curr) {
            acc = acc + curr.count;
            return acc;
          }, 0);
          var bassin;
          if (_this25.contextTitle === 'Bassin Seine Normandie') {
            bassin = 'bassin Seine Normandie';
          } else if (_this25.contextTitle.length > 0) {
            bassin = _this25.contextTitle.replace(/^[lL]e /, '');
          }
          var especeText = especes.find(function (esp) {
            return esp.code.toLowerCase() == espece;
          }).nom_commun;
          var isApostrophe = especes.find(function (esp) {
            return esp.code.toLowerCase() == espece;
          }).article == "L'" ? true : false;

          if (sum_augmentation_diminution < 10) {
            _this25.commentEvolutionEspeces = 'Les donn\xE9es sont insuffisantes pour d\xE9terminer une tendance sur le ' + bassin;
          } else {
            var countAugmentation = records.find(function (record) {
              return record.trend == 'augmentation';
            }).count;
            var countDiminution = records.find(function (record) {
              return record.trend == 'diminution';
            }).count;
            if (countAugmentation >= 2 / 3 * sum_augmentation_diminution) {
              _this25.commentEvolutionEspeces = 'Les densit\xE9s d' + (isApostrophe ? "'" : 'e ') + especeText + ' sont en augmentation sur les cours d\'eau \xE9chantillonn\xE9s du ' + bassin + '.';
            } else {
              if (countDiminution >= 2 / 3 * sum_augmentation_diminution) {
                _this25.commentEvolutionEspeces = 'Les densit\xE9s d' + (isApostrophe ? "'" : 'e ') + especeText + ' sont en diminution sur les cours d\'eau \xE9chantillonn\xE9s du ' + bassin + '.';
              } else {
                _this25.commentEvolutionEspeces = 'Aucune tendance ne se dégage à cette échelle.';
              }
            }
          }
        });
      }
    },
    updateCommentRichesseSpecifiqueEvolution: function updateCommentRichesseSpecifiqueEvolution(id) {
      var _this26 = this;

      if (this.checkboxes_left_menu.checked_richesse_specifique == true && this.checkboxes_left_menu.especes_temps.endsWith('__evolution')) {
        var path = 'static/comments/comments_evolution_richesse.json';
        fetch(path).then(function (response) {
          return response.json();
        }).then(function (json) {
          var records = json.trends.filter(function (record) {
            return record.code.toLowerCase() === id.toLowerCase();
          });
          records.sort(function (a, b) {
            return a.count < b.count;
          });
          var trend = records[0].trend;
          var textTrend = void 0;
          if (trend === 'augmentation') {
            textTrend = 'en augmentation';
          } else if (trend === 'stable') {
            textTrend = 'stable';
          } else if (trend === 'diminution') {
            textTrend = 'en régression';
          }
          var countAugmentation = records.find(function (r) {
            return r.trend == 'augmentation';
          }).count;
          var countDiminution = records.find(function (r) {
            return r.trend == 'diminution';
          }).count;
          var countStable = records.find(function (r) {
            return r.trend == 'stable';
          }).count;
          if (countAugmentation == countDiminution && countDiminution >= countStable) {
            textTrend = 'hétérogène';
          }
          // var annee = records[0].annee;
          var name = records[0].name;
          var bassin = name[0].toLowerCase() + name.slice(1);
          _this26.commentRichesseSpecifiqueEvolution = 'L\'\xE9volution de la richesse sp\xE9cifique est ' + textTrend + ' sur ' + bassin;
        });
      }
    },
    updateFromContext: function updateFromContext(withUpdate) {
      var _this27 = this;

      if (this.map) {
        var bassinsversants = this.map.getLayers().getArray().find(function (layer) {
          return layer.get('identifier') === 'bassinsversants';
        });
        var layerId = this.selected_especes[0] + '_' + this.checkboxes_left_menu.especes_temps.replace('temps_', '') + '_' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
        var layerNoProtocole = this.selected_especes[0] + '_' + this.checkboxes_left_menu.especes_temps.replace('temps_', '');
        // bassinsversants
        if (this.map.getView().getZoom() > 8) {
          var center3857 = this.map.getView().getCenter();
          var viewResolution = this.map.getView().getResolution();
          var url = bassinsversants.getSource().getGetFeatureInfoUrl(center3857, viewResolution, 'EPSG:3857', {
            // 'INFO_FORMAT': 'application/vnd.ogc.gml',
            'INFO_FORMAT': 'application/json',
            'FEATURE_COUNT': '1',
            'PROPERTYNAME': 'code_sect,libelle,the_geom'
          });
          if (url) {
            fetch(url).then(function (response) {
              return response.json();
            }).then(function (json) {
              if (json.features.length > 0) {
                var id = json.features[0].properties.code_sect;
                var libelle = json.features[0].properties.libelle;
                var geom = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.format.GeoJSON().readGeometry(json.features[0].geometry);
                _this27.highlight_layer_secteurs.getSource().clear();
                _this27.highlight_layer_secteurs.getSource().addFeature(new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.Feature({
                  geometry: geom
                }));
                _this27.contextTitle = libelle;
                _this27.updateChartsEchantillons(id, 'structure');
                _this27.updateContextes(id);
                _this27.updateCommentEvolutionEspeces(id);
                _this27.updateCommentRichesseSpecifiqueEvolution(id);
                _this27.updateChartsTravaux(id, 'type_op');
                _this27.updateChartsIPR(id);
                _this27.updateEspecesEtatComments(libelle, id.toLowerCase());
                if (withUpdate) {
                  var param = layerNoProtocole;
                  if (!layerNoProtocole.endsWith('__evolution')) {
                    param = layerNoProtocole.split('__')[0];
                  }
                  _this27.refreshText(param, id);
                }
              } else {
                console.log('No result');
                _this27.updateChartsEchantillons(undefined, 'structure');
                _this27.updateChartsTravaux(undefined, 'type_op');
                _this27.updateChartsIPR(undefined);
                _this27.updateEspecesEtatComments(undefined, '01');
              }
            });
          } else {
            console.log('outside');
          }
        } else {
          // circonscription_admin_bsn
          this.highlight_layer_secteurs.getSource().clear();
          this.updateChartsEchantillons(undefined, 'structure');
          this.updateContextes(undefined);
          this.updateCommentEvolutionEspeces('01');
          this.updateCommentRichesseSpecifiqueEvolution('01');
          this.updateChartsTravaux(undefined, 'type_op');
          this.updateChartsIPR(undefined);
          this.updateEspecesEtatComments(undefined, '01');
          if (withUpdate) {
            var param = layerNoProtocole;
            if (!layerNoProtocole.endsWith('__evolution')) {
              param = layerNoProtocole.split('__')[0];
            }
            this.refreshText(param, '-999999999');
          }
          this.contextTitle = 'Bassin Seine Normandie';
        }
      }
    },

    updateHtmlLegendPieChart: function updateHtmlLegendPieChart(selector, libelles, colors) {
      document.getElementById(selector).innerHTML = colors.map(function (color, idx) {
        return '<div class="legend-element">\n          <p class="libelle-name">\n            <span class="key-dot" style="background:' + color + ';font-size:14px;">\n            </span>\n            ' + libelles[idx] + '\n          </p>\n        </div>';
      }).join('');
    },
    onCopy: function onCopy(e) {
      console.log('You just copied: ' + e.text);
    },
    onError: function onError(e) {
      console.log('Failed to copy texts');
    },
    setLegendTitleForSpecificLayers: function setLegendTitleForSpecificLayers(checkboxes) {
      var _this28 = this;

      var specific_layer = this.correspondances.find(function (el) {
        var filtered = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(_this28.checkboxes_left_menu).filter(function (entry) {
          return [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(checkboxes)).includes(entry[0]) && entry[1];
        });
        if (filtered.length > 0) {
          return el.id == filtered[0][0];
        }
        return false;
      });
      if (specific_layer) {
        return specific_layer.layer.title_legend;
      }
      return '';
    },
    mapScale: function mapScale(dpi) {
      var unit = this.map.getView().getProjection().getUnits();
      var resolution = this.map.getView().getResolution();
      var inchesPerMetre = 39.37;
      return resolution * __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.METERS_PER_UNIT[unit] * inchesPerMetre * dpi;
    }
  },
  created: function created() {
    var _this29 = this;

    // Set checkbox default value for travaux filter
    this.travaux_filters.forEach(function (filter) {
      _this29.$set(filter, 'checked', false);
    });

    // Look for every tick box working without combination with other buttons
    var k1 = 'checked_stations_echantillonnage'; // Stations échanti
    var k2s = ['checked_localisation_typologie']; // Restauration eco
    var k3 = 'checked_qualite_localisation_obst'; // Obstacles
    var k4 = ['checked_qualite_eau_etat_pc', 'checked_qualite_eau_etat_ps', 'checked_qualite_eau_bio', 'checked_diversite_habitat', 'checked_presence_ripisylve', 'checked_erosion_sol', 'checked_taux_etag', 'checked_taux_frac', 'checked_assemblage_pisci_ref'];
    var excludeCategory1AndCategory3 = [k1].concat(k2s, [k3], k4);
    var ksWithEspeces = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(this.checkboxes_left_menu).filter(function (el) {
      return excludeCategory1AndCategory3.indexOf(el) === -1;
    });
    var ks = ksWithEspeces.filter(function (el) {
      return !el.startsWith('especes_');
    });

    var _loop3 = function _loop3(k) {
      _this29.$watch('checkboxes_left_menu.' + k, function (newVal, oldVal) {

        ks.filter(function (el) {
          return newVal && el !== k;
        }).filter(function (el) {
          return _this29.checkboxes_left_menu[el];
        }).forEach(function (el) {
          _this29.checkboxes_left_menu[el] = false;
        });
        if (newVal) {
          _this29.selected_especes = [];
          _this29.mapSetHash();
          _this29.foldAllExcept('show_toggletopdown_poissons');
        }
        var copy_k = k;
        if (k === 'checked_richesse_specifique') {
          var parts = _this29.checkboxes_left_menu.especes_temps.split('__');
          var suffix = 'evolution';
          if (parts.length > 0) {
            var _parts$slice11 = parts.slice(-1);

            var _parts$slice12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_parts$slice11, 1);

            suffix = _parts$slice12[0];
          }
          copy_k = 'richesse_specifique__full__' + suffix;
        }
        if (k === 'checked_etat_ipr') {
          if (_this29.checkboxes_left_menu.especes_temps.includes('evolution')) {
            _this29.checkboxes_left_menu.especes_temps = 'temps_etat__all';
          };
          var _parts3 = _this29.checkboxes_left_menu.especes_temps.split('__');

          var _parts3$slice = _parts3.slice(-1),
              _parts3$slice2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_parts3$slice, 1),
              _suffix3 = _parts3$slice2[0];

          copy_k = 'etat_ipr__' + _suffix3;
        }
        var matchingLayer = _this29.map.getLayers().getArray().find(function (layer) {
          return layer.get('identifier') == copy_k;
        });
        if (matchingLayer) {
          // LAYERS can contain more than one layer, comma separated
          // but the application has only one layer.
          var layerName = matchingLayer.getSource().getParams()['LAYERS'];
          if (newVal) {
            _this29.queryable_layers.push(layerName);
            if (['checked_richesse_specifique', 'checked_etat_ipr'].includes(k)) {
              _this29.checkboxes_left_menu[k1] = false;
              _this29.show_block_stat_echantillonnage = false;
            }
          } else {
            _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
              return item !== layerName;
            });
          }
          matchingLayer.setVisible(newVal);
        }
      });
      _this29.right_panel = false;
    };

    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
      for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ks), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
        var k = _step10.value;

        _loop3(k);
      }
    } catch (err) {
      _didIteratorError10 = true;
      _iteratorError10 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion10 && _iterator10.return) {
          _iterator10.return();
        }
      } finally {
        if (_didIteratorError10) {
          throw _iteratorError10;
        }
      }
    }

    var _loop4 = function _loop4(k) {
      _this29.$watch('checkboxes_left_menu.' + k, function (newVal, oldVal) {
        k4.filter(function (el) {
          return newVal && el !== k;
        }).filter(function (el) {
          return _this29.checkboxes_left_menu[el];
        }).forEach(function (el) {
          _this29.checkboxes_left_menu[el] = false;
        });
        if (newVal) {
          _this29.mapSetHash();
          _this29.foldAllExcept('show_toggletopdown_rivieres');
        }
        var matchingLayer = _this29.map.getLayers().getArray().find(function (layer) {
          return layer.get('identifier') == k;
        });
        if (matchingLayer) {
          // LAYERS can contain more than one layer, comma separated
          // but the application has only one layer.
          var layerName = matchingLayer.getSource().getParams()['LAYERS'];
          if (newVal) {
            _this29.queryable_layers.push(layerName);
          } else {
            _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
              return item !== layerName;
            });
          }
          matchingLayer.setVisible(newVal);
        }
      });
      _this29.right_panel = false;
    };

    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
      for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(k4), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
        var k = _step11.value;

        _loop4(k);
      }
    } catch (err) {
      _didIteratorError11 = true;
      _iteratorError11 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion11 && _iterator11.return) {
          _iterator11.return();
        }
      } finally {
        if (_didIteratorError11) {
          throw _iteratorError11;
        }
      }
    }

    this.$watch('checkboxes_left_menu.' + k1, function (newVal, oldVal) {
      var matchingLayer = _this29.map.getLayers().getArray().find(function (layer) {
        return layer.get('identifier') == k1;
      });
      if (matchingLayer) {
        // LAYERS can contain more than one layer, comma separated
        // but the application has only one layer.
        var layerName = matchingLayer.getSource().getParams()['LAYERS'];
        if (newVal) {
          _this29.queryable_layers.push(layerName);
          _this29.mapSetHash();
          _this29.updateFromContext(false);
          _this29.foldAllExcept('show_toggletopdown_poissons');
          _this29.selected_especes = [];
          _this29.checkboxes_left_menu.checked_richesse_specifique = false;
          _this29.checkboxes_left_menu.checked_etat_ipr = false;
        } else {
          _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
            return item !== layerName;
          });
        }
        matchingLayer.setVisible(newVal);
      }
      _this29.right_panel = false;
    });

    k2s.forEach(function (k2) {
      _this29.$watch('checkboxes_left_menu.' + k2, function (newVal, oldVal) {
        var matchingLayer = _this29.map.getLayers().getArray().find(function (layer) {
          return layer.get('identifier') == k2;
        });
        if (matchingLayer) {
          // LAYERS can contain more than one layer, comma separated
          // but the application has only one layer.
          var layerName = matchingLayer.getSource().getParams()['LAYERS'];
          if (newVal) {
            _this29.queryable_layers.push(layerName);
            _this29.mapSetHash();
            _this29.textPdfArea = '';
            _this29.idPdf = '';
          } else {
            _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
              return item !== layerName;
            });
          }
          matchingLayer.setVisible(newVal);
        }
        _this29.right_panel = false;
      });
    });

    this.$watch('checkboxes_left_menu.' + k3, function (newVal, oldVal) {
      var matchingLayer = _this29.map.getLayers().getArray().find(function (layer) {
        return layer.get('identifier') == k3;
      });
      if (matchingLayer) {
        // LAYERS can contain more than one layer, comma separated
        // but the application has only one layer.
        var layerName = matchingLayer.getSource().getParams()['LAYERS'];
        if (newVal) {
          _this29.queryable_layers.push(layerName);
          _this29.mapSetHash();
          // this.updateFromContext(false);
          _this29.foldAllExcept('show_toggletopdown_obstacles');
        } else {
          _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
            return item !== layerName;
          });
        }
        matchingLayer.setVisible(newVal);
      }
      _this29.right_panel = false;
    });

    var codesEspeces = especes.map(function (espece) {
      return espece.code.toLowerCase();
    });

    this.$watch('selected_especes', function (newVal, oldVal) {
      var toTick;
      if (newVal.length > 1) {
        toTick = newVal.filter(function (el) {
          return oldVal.indexOf(el) === -1;
        });
        _this29.selected_especes = toTick;
      } else {
        toTick = newVal;
      }
      if (newVal.length > 0) {
        _this29.foldAllExcept('show_toggletopdown_poissons');
        _this29.checkboxes_left_menu[k1] = false;
        _this29.show_block_stat_echantillonnage = false;
      }
      codesEspeces.forEach(function (codeEspece) {
        var visible = toTick.map(function (val) {
          return val.replace('temps_', '');
        }).indexOf(codeEspece) !== -1;
        var idLayer = _this29.getIdLayer(codeEspece);

        var matchingLayer = _this29.map.getLayers().getArray().find(function (layer) {
          return layer.get('identifier') == idLayer;
        });
        // console.log('matchingLayer', matchingLayer ? matchingLayer.get('identifier') : undefined);
        if (matchingLayer) {
          var layerName = matchingLayer.getSource().getParams()['LAYERS'];
          if (visible) {
            _this29.queryable_layers.push(layerName);
            _this29.mapSetHash();
          } else {
            _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
              return item !== layerName;
            });
          }
          matchingLayer.setVisible(visible);
        }
      });
      if (_this29.barChartEvolutionSpecies) {
        _this29.barChartEvolutionSpecies.data = [];
      }

      // Unchecked all except echantillonnage
      if (newVal.length > 0) {
        __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(_this29.checkboxes_left_menu).filter(function (el) {
          return !el.startsWith('especes_') && el !== 'checked_stations_echantillonnage' && el !== 'checked_localisation_typologie' && el !== 'checked_qualite_localisation_obst' && !k4.includes(el);
        }).filter(function (el) {
          return _this29.checkboxes_left_menu[el];
        }).forEach(function (el) {
          _this29.checkboxes_left_menu[el] = false;
        });
        _this29.updateFromContext(true);
      } else {
        _this29.idInfo = '';
        _this29.updateFromContext(false);
      }
      _this29.right_panel = false;
    });

    var regexTempsEtatFull = /^temps_[a-z]{3}_etat_full/gm;
    var ksEspecesOnly = ksWithEspeces.filter(function (el) {
      return el.startsWith('especes_');
    });
    ksEspecesOnly.forEach(function (kEspece) {
      _this29.$watch('checkboxes_left_menu.' + kEspece, function (newVal, oldVal) {
        // To manage disabling full when evolution
        // if (newVal == 'temps_evolution') {
        //   if (this.checkboxes_left_menu.especes_protocole == 'protocole_full') {
        //     this.checkboxes_left_menu.especes_protocole = 'protocole_complet';
        //   }
        //   this.disable_full = true;
        // } else if (newVal == 'temps_etat') {
        //   this.disable_full = false;
        // }

        if (_this29.selected_especes.length > 0) {
          var oldIdLayer = void 0;
          // console.log("DEBUG");
          var codeEspece = _this29.selected_especes[0].replace('temps_', '');
          if (kEspece.indexOf('_temps') > 0) {
            if (oldVal.endsWith('_evolution')) {
              oldIdLayer = 'points' + '_' + codeEspece + '_' + 'stations' + '_' + oldVal.replace(/temps[_]*/g, '') + '_' + _this29.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
            } else {
              oldIdLayer = 'points' + '_' + codeEspece + '__' + oldVal.replace(/temps[_]*/g, '').split('__')[0] + '__' + _this29.checkboxes_left_menu.especes_protocole.replace('protocole_', '') + '__' + oldVal.replace(/temps[_]*/g, '').split('__')[1];
            }
          }
          if (kEspece.indexOf('_protocole') > 0) {
            if (_this29.checkboxes_left_menu.especes_temps.endsWith('_evolution')) {
              oldIdLayer = 'points' + '_' + codeEspece + '_' + 'stations' + '_' + _this29.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '') + '_' + oldVal.replace('protocole_', '');
            } else {
              oldIdLayer = 'points' + '_' + codeEspece + '__' + _this29.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '').split('__')[0] + '__' + oldVal.replace('protocole_', '') + '__' + _this29.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '').split('__')[1];
            }
          }
          var idLayer = _this29.getIdLayer(codeEspece.replace('temps_', ''));
          var matchingLayer = _this29.map.getLayers().getArray().find(function (layer) {
            return layer.get('identifier') == idLayer;
          });
          if (matchingLayer) {
            var layerName = matchingLayer.getSource().getParams()['LAYERS'];
            matchingLayer.setVisible(true);
            if (!_this29.queryable_layers.includes(layerName)) {
              _this29.queryable_layers.push(layerName);
            }
            _this29.mapSetHash();
          }
          var matchingOldLayer = _this29.map.getLayers().getArray().find(function (layer) {
            return layer.get('identifier') == oldIdLayer;
          });
          if (matchingOldLayer) {
            var oldLayerName = matchingOldLayer.getSource().getParams()['LAYERS'];
            _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
              return item !== oldLayerName;
            });
            matchingOldLayer.setVisible(false);
          }

          if (newVal == 'temps_evolution' || newVal == 'temps__evolution') {
            var toClean = _this29.map.getLayers().getArray().find(function (layer) {
              return layer.getVisible() && layer.get('identifier') !== undefined && layer.get('identifier').match(regexTempsEtatFull);
            });
            if (toClean) {
              var oldLayerNameToClean = toClean.getSource().getParams()['LAYERS'];
              _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
                return item !== oldLayerNameToClean;
              });
              toClean.setVisible(false);
            }
          }
          _this29.updateFromContext(true);
        }
        if (_this29.checkboxes_left_menu.checked_richesse_specifique) {
          var getRichesseIdLayer = function getRichesseIdLayer(val) {
            var parts = val.split('__');
            var suffix = 'evolution';
            if (parts.length > 0) {
              var _parts$slice7 = parts.slice(-1);

              var _parts$slice8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_parts$slice7, 1);

              suffix = _parts$slice8[0];
            }
            return 'richesse_specifique__full__' + suffix;
          };

          if (kEspece.indexOf('_temps') > 0) {
            var toClean = _this29.map.getLayers().getArray().find(function (layer) {
              return layer.getVisible() && layer.get('identifier') !== undefined && layer.get('identifier') === getRichesseIdLayer(oldVal);
            });
            if (toClean) {
              var oldLayerNameToClean = toClean.getSource().getParams()['LAYERS'];
              _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
                return item !== oldLayerNameToClean;
              });
              toClean.setVisible(false);
            }
            var toShow = _this29.map.getLayers().getArray().find(function (layer) {
              return layer.get('identifier') !== undefined && layer.get('identifier') === getRichesseIdLayer(newVal);
            });
            if (toShow) {
              var _layerName = toShow.getSource().getParams()['LAYERS'];
              if (!_this29.queryable_layers.includes(_layerName)) {
                _this29.queryable_layers.push(_layerName);
              }
              toShow.setVisible(true);
            }
            _this29.mapSetHash();
          }
        }
        if (_this29.checkboxes_left_menu.checked_etat_ipr) {
          var getEtatIprIdLayer = function getEtatIprIdLayer(val) {
            var parts = val.split('__');

            var _parts$slice9 = parts.slice(-1),
                _parts$slice10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_parts$slice9, 1),
                suffix = _parts$slice10[0];

            return 'etat_ipr__' + suffix;
          };

          if (kEspece.indexOf('_temps') > 0) {
            var toClean = _this29.map.getLayers().getArray().find(function (layer) {
              return layer.getVisible() && layer.get('identifier') !== undefined && layer.get('identifier') === getEtatIprIdLayer(oldVal);
            });
            if (toClean) {
              var oldLayerNameToClean = toClean.getSource().getParams()['LAYERS'];
              _this29.queryable_layers = _this29.queryable_layers.filter(function (item) {
                return item !== oldLayerNameToClean;
              });
              toClean.setVisible(false);
            }
            var toShow = _this29.map.getLayers().getArray().find(function (layer) {
              return layer.get('identifier') !== undefined && layer.get('identifier') === getEtatIprIdLayer(newVal);
            });
            if (toShow) {
              var _layerName2 = toShow.getSource().getParams()['LAYERS'];
              if (!_this29.queryable_layers.includes(_layerName2)) {
                _this29.queryable_layers.push(_layerName2);
              }
              toShow.setVisible(true);
            }
            _this29.mapSetHash();
          }
        }
        _this29.right_panel = false;
      });
    });
  },

  mounted: function mounted() {
    var _this30 = this;

    var iconZoomToExtendSpan = document.createElement('span');
    var iElement = document.createElement('i');
    iElement.className = 'fa fa-home';
    iElement.setAttribute('aria-hidden', 'true');
    iconZoomToExtendSpan.appendChild(iElement);

    var self = this;
    var map = this.map = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.Map({
      target: 'map',
      logo: false,
      // view: view,
      controls: __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.defaults({
        attributionOptions: {
          collapsible: false,
          collapsed: false
        },
        attribution: true,
        zoomOptions: {
          zoomInTipLabel: 'Zoom avant',
          zoomOutTipLabel: 'Zoom arrière'
        }
      }).extend([
      // scaleLineControl,
      new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.ZoomToExtent({
        label: iconZoomToExtendSpan,
        extent: extentZoom,
        tipLabel: 'Vue initiale'
      })])
    });

    // Format result in the search input autocomplete
    var formatResult = function formatResult(feature, el) {
      var title = document.createElement('strong');
      el.appendChild(title);
      var detailsContainer = document.createElement('small');
      el.appendChild(detailsContainer);
      var details = [];
      title.innerHTML = feature.properties.label || feature.properties.name;
      var types = {
        housenumber: 'numéro',
        street: 'Rue',
        locality: 'Lieu-dit',
        hamlet: 'Hameau',
        village: 'Village',
        city: 'Ville',
        municipality: 'Commune',
        river: 'Cours d\'eau'
      };
      if (types[feature.properties.type]) {
        var spanType = document.createElement('span');
        spanType.className = 'type';
        title.appendChild(spanType);
        spanType.innerHTML = types[feature.properties.type];
      }
      if (feature.properties.city && feature.properties.city !== feature.properties.name) {
        details.push(feature.properties.city);
      }
      if (feature.properties.context) {
        details.push(feature.properties.context);
      }
      detailsContainer.innerHTML = details.join(', ');
    };

    // We reused the default function to center and zoom on selected feature.
    // You can make your own. For instance, you could center, zoom
    // and add a point on the map
    function onSelected(feature) {
      var featureBounds = feature.properties.bounds;
      featureBounds = featureBounds.split(',').map(function (s) {
        return +s;
      });
      // var coordinates = ol.proj.transform(
      //   [feature.geometry.coordinates[0], feature.geometry.coordinates[1]],
      //   'EPSG:4326',
      //   map.getView().getProjection()
      // );
      var fromLonLatToMercator = __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.getTransform('EPSG:4326', map.getView().getProjection());
      // very approximate calculation of projection extent
      var extent3857 = __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.extent.applyTransform(featureBounds, fromLonLatToMercator);
      map.getView().fit(extent3857);
      // map.getView().setCenter(coordinates);
      // map.getView().setZoom(16);
    }

    // URL for API
    var API_URL = this.baseUrlCarto + '/mysearch';

    // Create search by adresses component
    var container = new __WEBPACK_IMPORTED_MODULE_21_ol3_photon__["a" /* default */].Search(map, {
      resultsHandler: function resultsHandler() {},
      onSelected: onSelected,
      width: 230,
      placeholder: 'Commune ou cours d\'eau',
      formatResult: formatResult,
      url: API_URL + '/search/?',
      position: 'topright',
      feedbackEmail: null
    });

    var searchBox = document.getElementById('search-box');
    searchBox.appendChild(container);

    var canvasTitleControl = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasTitle();
    map.addControl(canvasTitleControl);

    var scaleLineControl = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasScaleLine();
    map.addControl(scaleLineControl);
    scaleLineControl.element.style.visibility = '';
    map.renderSync();

    var canvasAttributionControl = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.control.CanvasAttribution();
    map.addControl(canvasAttributionControl);

    var handleClickControlPrint = self.handleClickControlPrint = function () {
      canvasAttributionControl.setCanvas(true);
      scaleLineControl.element.style.visibility = 'hidden';
      var title;
      if (self.legends.length > 0) {
        title = self.legends[0].layerLabel;
      } else {
        title = 'Bassin Seine Normandie';
      }
      canvasTitleControl.setTitle(title);
      map.once('postcompose', function (event) {
        var canvas = event.context.canvas;
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(canvas.msToBlob(), 'map.png');
        } else {
          canvas.toBlob(function (blob) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_file_saver_FileSaver__["saveAs"])(blob, 'map.png');
          });
        }
      });
      map.renderSync();
      scaleLineControl.element.style.visibility = '';
      canvasAttributionControl.setCanvas(false);
      canvasTitleControl.setTitle('');
      map.renderSync();
    };

    var tileGrid = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.tilegrid.WMTS({
      origin: [-20037508, 20037508],
      resolutions: resolutions,
      matrixIds: matrixIds
    });

    this.layers_background_list.forEach(function (el) {

      if (el.type === 'WMTS-IGN') {
        var ign_source = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.source.WMTS({
          url: 'https://data.geopf.fr/wmts',
          layer: el.identifier,
          matrixSet: 'PM',
          format: el.format,
          projection: 'EPSG:3857',
          tileGrid: tileGrid,
          style: el.styles[0],
          attributions: [new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.Attribution({
            html: '<a href="http://www.geoportail.fr/" target="_blank">' + 'IGN-Fr/Géoportail</a>'
          })],
          crossOrigin: 'anonymous'
        });

        var ign = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.layer.Tile({
          identifier: el.identifier,
          title: el.title,
          basemap: el.basemap,
          source: ign_source,
          visible: el.visible,
          opacity: el.opacity || 1
        });

        map.addLayer(ign);
      } else if (el.type === 'XYZ') {
        // Detect if retina
        var retina = window.devicePixelRatio > 1;
        var url_xyz = el.url.replace('{r}', '@' + (retina ? '2' : '1') + 'x');
        var ign_source = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.source.XYZ({
          url: url_xyz,
          attributions: [new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.Attribution({
            html: '&copy; Les contributeurs <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
          })],
          tilePixelRatio: retina ? 2 : 1,
          maxZoom: 19,
          crossOrigin: 'anonymous'
        });

        var ign = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.layer.Tile({
          identifier: el.identifier,
          title: el.title,
          basemap: el.basemap,
          source: ign_source,
          visible: el.visible,
          opacity: el.opacity || 1
        });

        map.addLayer(ign);
      } else if (el.type === 'WMS-UNTILED') {
        // WMS at the moment
        var sourceWMS = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.source.ImageWMS({
          url: el.url,
          params: el.params,
          serverType: 'geoserver',
          crossOrigin: 'anonymous'
        });
        var wms = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.layer.Image({
          identifier: el.identifier,
          title: el.title,
          basemap: el.basemap,
          source: sourceWMS,
          visible: el.visible
        });
        map.addLayer(wms);
      } else {
        el.params['TILED'] = true;
        var sourceWMS = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.source.TileWMS({
          url: el.url,
          params: el.params,
          serverType: 'geoserver',
          crossOrigin: 'anonymous'
        });
        var _wms = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.layer.Tile({
          identifier: el.identifier,
          title: el.title,
          basemap: el.basemap,
          source: sourceWMS,
          visible: el.visible
        });
        map.addLayer(_wms);
      }
    });

    var element = document.getElementById('map');

    map.on('moveend', function (evt) {
      // Set hash
      _this30.mapSetHash();

      if (_this30.selected_especes.length > 0) {
        _this30.updateFromContext(true);
      } else {
        _this30.updateFromContext(false);
      }
    });

    fetch('static/correspondances.json').then(function (response) {
      return response.json();
    }).then(function (json) {
      _this30.correspondances = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(json)).reverse();
      [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(_this30.correspondances)).sort(function (obj1, obj2) {
        return obj2.layer.geometry - obj1.layer.geometry;
      }).forEach(function (el) {
        // WMS at the moment
        el.layer.params['TILED'] = true;
        var sourceWMS = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.source.TileWMS({
          url: el.layer.url,
          params: el.layer.params,
          ratio: 1,
          serverType: 'geoserver',
          crossOrigin: 'anonymous'
        });
        var wms = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.layer.Tile({
          identifier: el.id,
          source: sourceWMS,
          visible: el.layer.visible
        });
        map.addLayer(wms);
      });

      _this30.mapGetHash();
      var view = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.View({
        center: __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.proj.fromLonLat(_this30.current_center),
        zoom: _this30.current_zoom,
        maxZoom: 18
      });

      map.setView(view);

      // view.setCenter(ol.proj.fromLonLat(this.current_center));
      // view.setZoom(this.current_zoom);

      var sourceWmsCirconscription = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.source.TileWMS({
        url: _this30.baseUrlCarto + '/geoserver/general/wms',
        params: {
          "FORMAT": "image/png",
          "VERSION": "1.1.1",
          "STYLES": "",
          "LAYERS": "general:circonscription_admin_bsn"
        },
        serverType: 'geoserver',
        crossOrigin: 'anonymous',
        attributions: 'Observatoire Poissons Seine Normandie'
      });
      var wmsCirconscription = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.layer.Tile({
        identifier: 'circonscription_admin_bsn',
        source: sourceWmsCirconscription
      });
      map.addLayer(wmsCirconscription);

      var iconStyleNoPdf = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
        image: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Icon( /** @type {olx.style.IconOptions} */{
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-action.svg'
        })
      });

      var iconStyleNoPdfHighZoom = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
        image: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Icon( /** @type {olx.style.IconOptions} */{
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-action-high-zoom.svg'
        })
      });

      var iconStyleWithPdf = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
        image: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Icon( /** @type {olx.style.IconOptions} */{
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-action-url-plus.svg'
        })
      });

      var iconStyleWithPdfHighZoom = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
        image: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Icon( /** @type {olx.style.IconOptions} */{
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-action-url-plus-high-zoom.svg'
        })
      });

      var filterTypeOpColors = [['continuite', '#fc8d62'], ['zones_humides', '#8da0cb'], ['hydromorphologie', '#66c2a5']];

      var typeResolutions = [['high', 9], ['low', 12]];

      var iconStyleStationsLow = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
        image: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Icon( /** @type {olx.style.IconOptions} */{
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-station-institution-medium-@2x.svg'
        })
      });

      var iconStyleStationsMedium = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
        image: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Icon( /** @type {olx.style.IconOptions} */{
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-station-institution-small-@2x.svg'
        })
      });

      var combinations = {};
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filterTypeOpColors), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var typeOp = _step12.value;

          combinations[typeOp[0]] = {};
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(typeResolutions), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var _typeResolution = _step14.value;

              combinations[typeOp[0]][_typeResolution[0]] = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
                image: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Circle({
                  radius: _typeResolution[1],
                  snapToPixel: false,
                  fill: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Fill({
                    color: typeOp[1]
                  }),
                  stroke: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Stroke({
                    color: 'black', width: 1
                  })
                })
              });
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      var combinationsTravauxHighlight = {};
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(typeResolutions), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var typeResolution = _step13.value;

          combinationsTravauxHighlight[typeResolution[0]] = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
            image: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Circle({
              radius: typeResolution[1],
              snapToPixel: false,
              fill: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Fill({
                color: [0, 0, 0, 0]
              }),
              stroke: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Stroke({
                color: '#ffff00', width: 2
              })
            })
          });
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      var empty_style = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({});
      var travaux_layer_style = function travaux_layer_style(filter_feature) {
        return function (feature, resolution) {
          var typeResolution = resolution > 310;
          var typeResolutionName = typeResolution ? 'high' : 'low';
          if (filter_feature(feature)) {
            var pdf = void 0;
            var myStyle = [];
            var type_op = feature.get('type_op');

            myStyle.push(combinations[type_op][typeResolutionName]);

            if (feature.get('fichier').length > 0 || feature.get('url').length > 0) {
              if (typeResolution) {
                myStyle.push(iconStyleWithPdfHighZoom);
              } else {
                myStyle.push(iconStyleWithPdf);
              }
            } else {
              if (typeResolution) {
                myStyle.push(iconStyleNoPdfHighZoom);
              } else {
                myStyle.push(iconStyleNoPdf);
              }
            }
            return myStyle;
          } else {
            return empty_style;
          }
        };
      };
      var travaux_layer_source = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.source.Vector();
      var travaux_layer = _this30.travaux_layer = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.layer.Vector({
        source: travaux_layer_source,
        visible: false,
        style: travaux_layer_style(self.filter_travaux_layer_style)
      });
      travaux_layer.set('identifier', 'travaux');
      map.addLayer(travaux_layer);

      var csvUrl = _this30.baseURL + '/feed/actions/';
      fetch(csvUrl).then(function (response) {
        return response.text();
      }).then(function (text) {
        __WEBPACK_IMPORTED_MODULE_19_csv2geojson___default.a.csv2geojson(text, {
          latfield: 'y_l93',
          lonfield: 'x_l93',
          delimiter: ';'
        }, function (err, data) {
          // After data reception, add features to the empty vector layer
          var geoJsonFormat = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.format.GeoJSON();
          var features = geoJsonFormat.readFeatures(data, {
            dataProjection: proj2154,
            featureProjection: 'EPSG:3857'
          });
          travaux_layer_source.addFeatures(features);
          self.mapSetHash();
        });
      });

      // Part to highlight features from GetFeatureInfo
      var fill_highlight_layer = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Fill({
        color: 'rgba(255,255,0,0.0)'
      });
      var stroke_highlight_layer = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Stroke({
        color: '#ffff00',
        width: 1.5
      });
      var style_highlight_layer = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
        image: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Circle({
          fill: fill_highlight_layer,
          stroke: stroke_highlight_layer,
          radius: 5
        }),
        fill: fill_highlight_layer,
        stroke: stroke_highlight_layer
      });

      var travaux_layer_style_highlight = function travaux_layer_style_highlight(feature, resolution) {
        var typeResolution = resolution > 310;
        var typeResolutionName = typeResolution ? 'high' : 'low';
        return combinationsTravauxHighlight[typeResolutionName];
      };
      var stations_layer_style_highlight = function stations_layer_style_highlight(feature, resolution) {
        var typeResolution = resolution > 310;
        var simpleImage = void 0;
        if (typeResolution) {
          simpleImage = iconStyleStationsMedium;
        } else {
          simpleImage = iconStyleStationsLow;
        }
        return simpleImage;
      };
      var highlight_layer_source = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.source.Vector();

      var highlight_layer = _this30.highlight_layer = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.layer.Vector({
        source: highlight_layer_source,
        visible: true,
        style: function style(feature, resolution) {
          if (feature.get('identifier') == 'travaux') {
            return travaux_layer_style_highlight(feature, resolution);
          } else if (feature.get('identifier') == 'checked_stations_echantillonnage') {
            return stations_layer_style_highlight(feature, resolution);
          } else {
            return style_highlight_layer;
          }
        }
      });
      map.addLayer(highlight_layer);

      // Part for highlightning secteurs
      var style_highlight_layer_secteurs = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Style({
        fill: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Fill({
          color: 'rgba(255, 255, 255, 0)'
        }),
        stroke: new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.style.Stroke({
          color: '#319FD3',
          width: 3
        })
      });

      var highlight_layer_secteurs_source = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.source.Vector();

      var highlight_layer_secteurs = _this30.highlight_layer_secteurs = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.layer.Vector({
        source: highlight_layer_secteurs_source,
        visible: true,
        style: style_highlight_layer_secteurs
      });
      map.addLayer(highlight_layer_secteurs);

      var regexLayers = /LAYERS=([\da-zA-Z_:,%]*)/;
      var regexQueryLayers = /QUERY_LAYERS=([\da-zA-Z_:,%]*)/;

      map.on('click', function (evt) {
        if (!_this30.draw_travaux) {
          if (evt.dragging) {
            return;
          }
          var viewResolution = map.getView().getResolution();
          var url = sourceWmsCirconscription.getGetFeatureInfoUrl(evt.coordinate, viewResolution, 'EPSG:3857', {
            'INFO_FORMAT': 'application/vnd.ogc.gml',
            'FEATURE_COUNT': '20'
          });
          var featureTravaux;
          if (_this30.checked_travaux_vector_layer) {
            var featureTravaux = map.forEachFeatureAtPixel(evt.pixel, function (feat, l) {
              if (l.get('identifier') == 'travaux') {
                return feat;
              }
            });
            if (featureTravaux) {
              var nAction = featureTravaux.get('id').replace('checked_localisation_typologie__n_action__', '');
              self.refreshPdf('checked_localisation_typologie', nAction);
              var template_travaux = "<b>{{type_op}}</b><br>{{m_ouvrage}}, {{annee_rec}}<br><i>{{n_travaux}}</i>";
              self.popup_travaux = __WEBPACK_IMPORTED_MODULE_20__distribution_micromustache__["a" /* default */].render(template_travaux, {
                type_op: self.travaux_filters.find(function (travaux) {
                  return travaux.value == featureTravaux.get('type_op');
                }).lib,
                annee_rec: featureTravaux.get('annee_rec'),
                m_ouvrage: featureTravaux.get('m_ouvrage'),
                n_travaux: featureTravaux.get('n_travaux')
              });
              self.external_url = featureTravaux.get('url');
            } else {
              self.textPdfArea = '';
              self.idPdf = '';
              self.popup_travaux = '';
              self.external_url = '';
            }
          } else {
            self.textPdfArea = '';
            self.popup_travaux = '';
            self.external_url = '';
          }
          // Si on peut faire l'appel
          if (url) {
            var myFeatures = [];
            if (self.layers_background_list.find(function (layer) {
              return layer.identifier === 'courseau_fxx';
            }).visible) {
              self.queryable_layers = ['general:courseau_fxx'].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(self.queryable_layers));
            } else {
              self.queryable_layers = self.queryable_layers.filter(function (layer) {
                return layer !== 'general:courseau_fxx';
              });
            }

            if (featureTravaux) {
              var featureTravauxCopy = featureTravaux.clone();
              featureTravauxCopy.set('identifier', 'travaux');
              myFeatures.push(featureTravauxCopy);
              _this30.highlight_layer.getSource().clear();
              _this30.highlight_layer.getSource().addFeatures(myFeatures);
              self.right_panel = true;
            } else {
              _this30.highlight_layer.getSource().clear();
            }

            if (self.queryable_layers.length > 0) {
              self.queryable_layers = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(self.queryable_layers));
              var stringReplacement = self.queryable_layers.map(function (el) {
                return window.encodeURIComponent(el);
              }).join(',');
              var layersWms = regexLayers.exec(url);
              var queryLayersWms = regexQueryLayers.exec(url);
              url = url.replace(layersWms[1], stringReplacement).replace(queryLayersWms[1], stringReplacement);
              var features = {};

              // Faire l'appel au WMS GetFeatureInfo
              fetch(url).then(function (response) {
                return response.text();
              }).then(function (text) {
                self.queryable_layers.forEach(function (layer) {
                  features[layer] = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.format.WMSGetFeatureInfo({
                    layers: [layer]
                  }).readFeatures(text);
                });

                // Pour les espèces en évolution
                var evolutionSpeciesLayer = self.queryable_layers.find(function (el) {
                  return (el.startsWith('general:points_') || el.startsWith('general:pointsnext_')) && el.endsWith('_evolution_complet') | el.endsWith('_evolution_ponctuel') | el.endsWith('_evolution_full');
                });

                if (evolutionSpeciesLayer) {
                  var featureSpecies = new __WEBPACK_IMPORTED_MODULE_17_openlayers___default.a.format.WMSGetFeatureInfo({
                    layers: [evolutionSpeciesLayer]
                  }).readFeatures(text);
                  featureSpecies = featureSpecies.filter(function (feature) {
                    return feature.getId().split('.')[0] == evolutionSpeciesLayer.split(':')[1];
                  });

                  if (featureSpecies.length > 0) {
                    var cluster_id = featureSpecies[0].get('cluster_id');
                    var protocole = self.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
                    self.barChartEvolutionSpecies.fetchBarChart('static/barchart/evolution_density/evolution_density_species_' + protocole + '_' + cluster_id.toLowerCase() + '.json', 'agg_den_' + self.selected_especes[0].replace('temps_', ''));
                    self.idInfoEvolution = cluster_id;
                  } else {
                    self.idInfoEvolution = '';
                  }
                } else {
                  self.idInfoEvolution = '';
                }
                var layerWithContent = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(features).filter(function (el) {
                  return features[el].length > 0;
                });
                if ([].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(features))).length > 0 && layerWithContent.length > 0) {
                  // Add the content to the popup
                  var layerOrdered = self.correspondances.slice().reverse().map(function (el) {
                    return {
                      title: el.layer.title,
                      cols: el.layer.cols || [],
                      layer: el.layer.params.LAYERS,
                      template: el.layer.template || '',
                      identifier: el.id
                    };
                  }).filter(function (el) {
                    return layerWithContent.indexOf(el.layer) !== -1;
                  });
                  layerOrdered = removeDuplicates(layerOrdered, 'layer');

                  if (self.queryable_layers.indexOf('general:courseau_fxx') !== -1) {
                    layerOrdered = [{
                      "identifier": "courseau_fxx",
                      "title": "Cours d'eau",
                      "cols": ["topooh"],
                      "layer": "general:courseau_fxx",
                      "template": "{{topooh}}"
                    }].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(layerOrdered));
                  }
                  var layerOrderedFixFeatures = layerOrdered.map(function (el) {
                    features[el.layer] = features[el.layer].filter(function (feature) {
                      return feature.getId().split('.')[0] == el.layer.split(':')[1];
                    });
                    return el;
                  }).filter(function (el) {
                    if (features[el.layer].length > 0) {
                      features[el.layer] = features[el.layer].slice(0, 1);
                      return features[el.layer].map(function (el1) {
                        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(el.cols.map(function (el2) {
                          return el1.get(el2);
                        })));
                      }).filter(function (el) {
                        return el[0] !== undefined;
                      }).length > 0;
                    } else {
                      return false;
                    }
                    // return features[el.layer].length > 0;
                  });

                  var myWmsFeatures = layerOrderedFixFeatures.reduce(function (acc, curr) {
                    var flatened = features[curr.layer].map(function (feat) {
                      feat.set('identifier', curr.identifier);
                      return feat;
                    });
                    acc = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(acc), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(flatened));
                    return acc;
                  }, []);

                  if (myFeatures.length == 0) {
                    _this30.highlight_layer.getSource().clear();
                  }
                  _this30.highlight_layer.getSource().addFeatures(myWmsFeatures);

                  var html = layerOrderedFixFeatures.map(function (el) {
                    return '<span style="font-weight: bold;">' + el.title + '</span>' + '<br>' + features[el.layer].filter(function (el1) {
                      // filter to remove empty results
                      var tmp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(el.cols.map(function (el2) {
                        return el1.get(el2);
                      })));
                      if (tmp[0] !== undefined) {
                        return true;
                      } else {
                        return false;
                      }
                    }).filter(function (el1, index) {
                      // Take only first result
                      return index == 0;
                    }).map(function (feat) {
                      var textPopupContent = el.cols.reduce(function (acc, col, index) {
                        // debugger;
                        acc[col] = feat.get(col);
                        if (index === 0 && (el.layer.startsWith('general:points_') || el.layer.startsWith('general:pointsnext_')) && !el.layer.includes('evolution') && acc[col] !== undefined) {
                          acc[col] = acc[col] !== 0 ? Number(Number(acc[col]).toFixed(1)) : 0;
                        }
                        if (index === 0 && (el.layer.startsWith('general:points_') || el.layer.startsWith('general:pointsnext_')) && el.layer.includes('evolution') && acc[col] !== undefined) {
                          if (col !== 'html') {
                            acc[col] = acc[col] !== 0 ? acc[col] > 0 ? '+' + String(Number(Number(acc[col]).toFixed(4))) : Number(Number(acc[col]).toFixed(4)) : '';
                          }
                          if (el.cols.length == 1) {
                            acc['espece'] = especes_by_key[col.replace('tx_evol_den_', '')];
                          }
                        }
                        if (index === 0 && el.layer.includes('taux_etagement_bsn') && acc[col] !== undefined) {
                          acc[col] = acc[col] < 0 || acc[col] > 1 ? 'Non renseigné' : Number(Number(acc[col]) * 100).toFixed(1) + '%';
                        }

                        // if (index === 0 && el.layer.includes('stations_echantillonnage_latest') && acc[col] !== undefined) {
                        //   if (col == 'station') {
                        //     acc['station1'] = acc[col].replace(/#/g, 'D');
                        //     // console.log(acc['station1']);
                        //   }
                        // }
                        // For Habitats aquatiques or ripisylve data columns
                        if (col === 'taux_vege1' || col === 'taux_recti' && acc[col] !== undefined) {
                          acc[col] = Number(acc[col]).toFixed(1);
                        }
                        if (col === 'note_ipr' && acc[col] !== undefined) {
                          acc[col] = Number(acc[col]).toFixed(2);
                        }
                        return acc;
                      }, {});
                      return __WEBPACK_IMPORTED_MODULE_20__distribution_micromustache__["a" /* default */].render(el.template, textPopupContent);
                    }).map(function (el) {
                      if (el.length == 0) {
                        return 'Absence de données';
                      } else {
                        return el;
                      }
                    }).join('<br>');
                  });
                  self.popup_element = html.join('<br>');
                  if (self.popup_element.length > 0 || featureTravaux) {
                    self.right_panel = true;
                  } else {
                    if (featureTravaux) {
                      self.right_panel = true;
                    } else {
                      self.right_panel = false;
                    }
                  }
                } else {
                  if (featureTravaux) {
                    self.right_panel = true;
                  } else {
                    self.right_panel = false;
                  }
                }
              });
            } else {
              if (featureTravaux) {
                self.right_panel = true;
              } else {
                self.right_panel = false;
              }
            }
          }
        }
      });
    });

    var libellesTravaux = ['Restauration de la continuit\xE9 \xE9cologique', "Restauration de zones humides", "Restauration hydromorphologique"];
    var colorsTravaux = ['#fc8d62', '#8da0cb', '#66c2a5'];

    var libellesEchantillonnages = ['Institutions', 'Structures de p\xEAche de loisir', 'Collectivités'];
    var colorsEchantillonnages = ['#984ea3', '#d95f02', '#7a6c5d'];

    var margin = { top: 10, right: 20, bottom: 80, left: 20 },
        width = 220 - margin.left - margin.right,
        height = 140 - margin.top - margin.bottom;

    var barChartEchantillonnage = new BarChart('#barchart', height, width, margin, colorsEchantillonnages, libellesEchantillonnages);
    this.barChartEchantillonnage = barChartEchantillonnage;

    var barChartTravaux = new BarChart('#barchart-travaux', height, width, margin, colorsTravaux, libellesTravaux);
    this.barChartTravaux = barChartTravaux;

    var barChartIPR = new BarChartIPR('#barchart-ipr', 240, width, { top: 10, right: 20, bottom: 80, left: 30 });
    this.barChartIPR = barChartIPR;

    var widthPie = 220,
        heightPie = 220,
        radiusPie = 80;

    var pieChartEchantillonnage = new PieChart('#piechart', widthPie, heightPie, radiusPie, colorsEchantillonnages, libellesEchantillonnages);
    this.pieChartEchantillonnage = pieChartEchantillonnage;

    this.updateHtmlLegendPieChart('echantillonnages-legend', libellesEchantillonnages, colorsEchantillonnages);

    var pieChartTravaux = new PieChart('#piechart-travaux', widthPie, heightPie, radiusPie, colorsTravaux, libellesTravaux);
    this.pieChartTravaux = pieChartTravaux;

    this.updateHtmlLegendPieChart('travaux-legend', libellesTravaux, colorsTravaux);

    this.barChartEvolutionSpecies = new BarChartEvolutionSpecies('#barchart-evolution-species', 140, width, { top: 10, right: 20, bottom: 40, left: 40 });

    var libellesEvolutionTendances = ['abl', 'asp', 'baf', 'bbg', 'bln', 'bou', 'brb', 'bre', 'bro', 'cad', 'cag', 'car', 'cas', 'cco', 'ccu', 'cha', 'che', 'cmi', 'cti', 'epi', 'ept', 'gar', 'gob', 'gou', 'gre', 'hot', 'ide', 'loe', 'lof', 'lor', 'lot', 'lpp', 'obr', 'pch', 'per', 'pes', 'psr', 'rot', 'san', 'sdf', 'sil', 'spi', 'tac', 'tan', 'trf', 'ump', 'vai', 'van', 'var', 'Autres'];
    //var codeEvolutionTendances = ['Institutions', 'Structures de p\u00eache de loisir'];
    var colorsEvolutionTendances = ['#f9ebea', '#fdedec', '#f5eef8', '#f4ecf7', '#eaf2f8', '#ebf5fb', '#e8f8f5', '#e8f6f3', '#e9f7ef', '#eafaf1', '#e6b0aa', '#f5b7b1', '#d7bde2', '#d2b4de', '#a9cce3', '#aed6f1', '#a3e4d7', '#a2d9ce', '#a9dfbf', '#abebc6', '#cd6155', '#ec7063', '#af7ac5', '#a569bd', '#5499c7', '#5dade2', '#48c9b0', '#45b39d', '#52be80', '#58d68d', '#a93226', '#cb4335', '#884ea0', '#7d3c98', '#2471a3', '#2e86c1', '#17a589', '#138d75', '#229954', '#28b463', '#7b241c', '#943126', '#633974', '#5b2c6f', '#1a5276', '#21618c', '#117864', '#0e6655', '#196f3d', '#1d8348'];
    var pieContextePiscicoleSalmonicole = new PieChart('#piechart-contexte-piscicole-salmonicole', widthPie, heightPie, radiusPie, colorsEvolutionTendances, libellesEvolutionTendances);
    this.pieContextePiscicoleSalmonicole = pieContextePiscicoleSalmonicole;

    var pieContextePiscicoleIntermediaire = new PieChart('#piechart-contexte-piscicole-intermediaire', widthPie, heightPie, radiusPie, colorsEvolutionTendances, libellesEvolutionTendances);
    this.pieContextePiscicoleIntermediaire = pieContextePiscicoleIntermediaire;

    var pieContextePiscicoleCyprinicole = new PieChart('#piechart-contexte-piscicole-cyprinicole', widthPie, heightPie, radiusPie, colorsEvolutionTendances, libellesEvolutionTendances);
    this.pieContextePiscicoleCyprinicole = pieContextePiscicoleCyprinicole;

    var slider = this.slider = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__distribution_d3RangeSlider_d3RangeSlider__["a" /* default */])(this.minDate, this.maxDate, "#slider-container");

    // slider.range(this.minSelectedDate, this.maxSelectedDate);
    slider.onChange(function (newRange) {
      self.minSelectedDate = newRange.begin;
      self.maxSelectedDate = newRange.end;
      __WEBPACK_IMPORTED_MODULE_23_d3__["select"]("#range-label").text(newRange.begin + " - " + newRange.end);
    });

    // To get the right width for the slider,
    // we need to watch show_restauration_ecologique
    // and stop watching after it runs once
    // Borrowed from https://medium.com/@bmacher/vue-watch-only-once-63597466dc74
    this.unwatch_show_restauration_ecologique = this.$watch('show_restauration_ecologique', function (newVal) {
      if (newVal) {
        slider.range(_this30.minSelectedDate, _this30.maxSelectedDate);
        _this30.unwatch_show_restauration_ecologique();
      }
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_js__ = __webpack_require__("gZpW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3130000d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("0UW5");
function injectStyle (ssrContext) {
  __webpack_require__("/0Ya")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3130000d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oiZJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pDlW":
/***/ (function(module, exports) {

module.exports = {"Abkhazian":{"name":"Abkhazian","names":["Abkhazian"],"iso639-2":"abk","iso639-1":"ab"},"Achinese":{"name":"Achinese","names":["Achinese"],"iso639-2":"ace","iso639-1":null},"Acoli":{"name":"Acoli","names":["Acoli"],"iso639-2":"ach","iso639-1":null},"Adangme":{"name":"Adangme","names":["Adangme"],"iso639-2":"ada","iso639-1":null},"Adygei":{"name":"Adygei","names":["Adyghe","Adygei"],"iso639-2":"ady","iso639-1":null},"Adyghe":{"name":"Adyghe","names":["Adyghe","Adygei"],"iso639-2":"ady","iso639-1":null},"Afar":{"name":"Afar","names":["Afar"],"iso639-2":"aar","iso639-1":"aa"},"Afrihili":{"name":"Afrihili","names":["Afrihili"],"iso639-2":"afh","iso639-1":null},"Afrikaans":{"name":"Afrikaans","names":["Afrikaans"],"iso639-2":"afr","iso639-1":"af"},"Afro-Asiatic languages":{"name":"Afro-Asiatic languages","names":["Afro-Asiatic languages"],"iso639-2":"afa","iso639-1":null},"Ainu":{"name":"Ainu","names":["Ainu"],"iso639-2":"ain","iso639-1":null},"Akan":{"name":"Akan","names":["Akan"],"iso639-2":"aka","iso639-1":"ak"},"Akkadian":{"name":"Akkadian","names":["Akkadian"],"iso639-2":"akk","iso639-1":null},"Albanian":{"name":"Albanian","names":["Albanian"],"iso639-2":"alb/sqi","iso639-1":"sq"},"Alemannic":{"name":"Alemannic","names":["Swiss German","Alemannic","Alsatian"],"iso639-2":"gsw","iso639-1":null},"Aleut":{"name":"Aleut","names":["Aleut"],"iso639-2":"ale","iso639-1":null},"Algonquian languages":{"name":"Algonquian languages","names":["Algonquian languages"],"iso639-2":"alg","iso639-1":null},"Alsatian":{"name":"Alsatian","names":["Swiss German","Alemannic","Alsatian"],"iso639-2":"gsw","iso639-1":null},"Altaic languages":{"name":"Altaic languages","names":["Altaic languages"],"iso639-2":"tut","iso639-1":null},"Amharic":{"name":"Amharic","names":["Amharic"],"iso639-2":"amh","iso639-1":"am"},"Angika":{"name":"Angika","names":["Angika"],"iso639-2":"anp","iso639-1":null},"Apache languages":{"name":"Apache languages","names":["Apache languages"],"iso639-2":"apa","iso639-1":null},"Arabic":{"name":"Arabic","names":["Arabic"],"iso639-2":"ara","iso639-1":"ar"},"Aragonese":{"name":"Aragonese","names":["Aragonese"],"iso639-2":"arg","iso639-1":"an"},"Arapaho":{"name":"Arapaho","names":["Arapaho"],"iso639-2":"arp","iso639-1":null},"Arawak":{"name":"Arawak","names":["Arawak"],"iso639-2":"arw","iso639-1":null},"Armenian":{"name":"Armenian","names":["Armenian"],"iso639-2":"arm/hye","iso639-1":"hy"},"Aromanian":{"name":"Aromanian","names":["Aromanian","Arumanian","Macedo-Romanian"],"iso639-2":"rup","iso639-1":null},"Artificial languages":{"name":"Artificial languages","names":["Artificial languages"],"iso639-2":"art","iso639-1":null},"Arumanian":{"name":"Arumanian","names":["Aromanian","Arumanian","Macedo-Romanian"],"iso639-2":"rup","iso639-1":null},"Assamese":{"name":"Assamese","names":["Assamese"],"iso639-2":"asm","iso639-1":"as"},"Asturian":{"name":"Asturian","names":["Asturian","Bable","Leonese","Asturleonese"],"iso639-2":"ast","iso639-1":null},"Asturleonese":{"name":"Asturleonese","names":["Asturian","Bable","Leonese","Asturleonese"],"iso639-2":"ast","iso639-1":null},"Athapascan languages":{"name":"Athapascan languages","names":["Athapascan languages"],"iso639-2":"ath","iso639-1":null},"Australian languages":{"name":"Australian languages","names":["Australian languages"],"iso639-2":"aus","iso639-1":null},"Austronesian languages":{"name":"Austronesian languages","names":["Austronesian languages"],"iso639-2":"map","iso639-1":null},"Avaric":{"name":"Avaric","names":["Avaric"],"iso639-2":"ava","iso639-1":"av"},"Avestan":{"name":"Avestan","names":["Avestan"],"iso639-2":"ave","iso639-1":"ae"},"Awadhi":{"name":"Awadhi","names":["Awadhi"],"iso639-2":"awa","iso639-1":null},"Aymara":{"name":"Aymara","names":["Aymara"],"iso639-2":"aym","iso639-1":"ay"},"Azerbaijani":{"name":"Azerbaijani","names":["Azerbaijani"],"iso639-2":"aze","iso639-1":"az"},"Bable":{"name":"Bable","names":["Asturian","Bable","Leonese","Asturleonese"],"iso639-2":"ast","iso639-1":null},"Balinese":{"name":"Balinese","names":["Balinese"],"iso639-2":"ban","iso639-1":null},"Baltic languages":{"name":"Baltic languages","names":["Baltic languages"],"iso639-2":"bat","iso639-1":null},"Baluchi":{"name":"Baluchi","names":["Baluchi"],"iso639-2":"bal","iso639-1":null},"Bambara":{"name":"Bambara","names":["Bambara"],"iso639-2":"bam","iso639-1":"bm"},"Bamileke languages":{"name":"Bamileke languages","names":["Bamileke languages"],"iso639-2":"bai","iso639-1":null},"Banda languages":{"name":"Banda languages","names":["Banda languages"],"iso639-2":"bad","iso639-1":null},"Bantu languages":{"name":"Bantu languages","names":["Bantu languages"],"iso639-2":"bnt","iso639-1":null},"Basa":{"name":"Basa","names":["Basa"],"iso639-2":"bas","iso639-1":null},"Bashkir":{"name":"Bashkir","names":["Bashkir"],"iso639-2":"bak","iso639-1":"ba"},"Basque":{"name":"Basque","names":["Basque"],"iso639-2":"baq/eus","iso639-1":"eu"},"Batak languages":{"name":"Batak languages","names":["Batak languages"],"iso639-2":"btk","iso639-1":null},"Bedawiyet":{"name":"Bedawiyet","names":["Beja","Bedawiyet"],"iso639-2":"bej","iso639-1":null},"Beja":{"name":"Beja","names":["Beja","Bedawiyet"],"iso639-2":"bej","iso639-1":null},"Belarusian":{"name":"Belarusian","names":["Belarusian"],"iso639-2":"bel","iso639-1":"be"},"Bemba":{"name":"Bemba","names":["Bemba"],"iso639-2":"bem","iso639-1":null},"Bengali":{"name":"Bengali","names":["Bengali"],"iso639-2":"ben","iso639-1":"bn"},"Berber languages":{"name":"Berber languages","names":["Berber languages"],"iso639-2":"ber","iso639-1":null},"Bhojpuri":{"name":"Bhojpuri","names":["Bhojpuri"],"iso639-2":"bho","iso639-1":null},"Bihari languages":{"name":"Bihari languages","names":["Bihari languages"],"iso639-2":"bih","iso639-1":"bh"},"Bikol":{"name":"Bikol","names":["Bikol"],"iso639-2":"bik","iso639-1":null},"Bilin":{"name":"Bilin","names":["Blin","Bilin"],"iso639-2":"byn","iso639-1":null},"Bini":{"name":"Bini","names":["Bini","Edo"],"iso639-2":"bin","iso639-1":null},"Bislama":{"name":"Bislama","names":["Bislama"],"iso639-2":"bis","iso639-1":"bi"},"Blin":{"name":"Blin","names":["Blin","Bilin"],"iso639-2":"byn","iso639-1":null},"Bliss":{"name":"Bliss","names":["Blissymbols","Blissymbolics","Bliss"],"iso639-2":"zbl","iso639-1":null},"Blissymbolics":{"name":"Blissymbolics","names":["Blissymbols","Blissymbolics","Bliss"],"iso639-2":"zbl","iso639-1":null},"Blissymbols":{"name":"Blissymbols","names":["Blissymbols","Blissymbolics","Bliss"],"iso639-2":"zbl","iso639-1":null},"Bokmål, Norwegian":{"name":"Bokmål, Norwegian","names":["Bokmål, Norwegian","Norwegian Bokmål"],"iso639-2":"nob","iso639-1":"nb"},"Bosnian":{"name":"Bosnian","names":["Bosnian"],"iso639-2":"bos","iso639-1":"bs"},"Braj":{"name":"Braj","names":["Braj"],"iso639-2":"bra","iso639-1":null},"Breton":{"name":"Breton","names":["Breton"],"iso639-2":"bre","iso639-1":"br"},"Buginese":{"name":"Buginese","names":["Buginese"],"iso639-2":"bug","iso639-1":null},"Bulgarian":{"name":"Bulgarian","names":["Bulgarian"],"iso639-2":"bul","iso639-1":"bg"},"Buriat":{"name":"Buriat","names":["Buriat"],"iso639-2":"bua","iso639-1":null},"Burmese":{"name":"Burmese","names":["Burmese"],"iso639-2":"bur/mya","iso639-1":"my"},"Caddo":{"name":"Caddo","names":["Caddo"],"iso639-2":"cad","iso639-1":null},"Castilian":{"name":"Castilian","names":["Spanish","Castilian"],"iso639-2":"spa","iso639-1":"es"},"Catalan":{"name":"Catalan","names":["Catalan","Valencian"],"iso639-2":"cat","iso639-1":"ca"},"Caucasian languages":{"name":"Caucasian languages","names":["Caucasian languages"],"iso639-2":"cau","iso639-1":null},"Cebuano":{"name":"Cebuano","names":["Cebuano"],"iso639-2":"ceb","iso639-1":null},"Celtic languages":{"name":"Celtic languages","names":["Celtic languages"],"iso639-2":"cel","iso639-1":null},"Central American Indian languages":{"name":"Central American Indian languages","names":["Central American Indian languages"],"iso639-2":"cai","iso639-1":null},"Central Khmer":{"name":"Central Khmer","names":["Central Khmer"],"iso639-2":"khm","iso639-1":"km"},"Chagatai":{"name":"Chagatai","names":["Chagatai"],"iso639-2":"chg","iso639-1":null},"Chamic languages":{"name":"Chamic languages","names":["Chamic languages"],"iso639-2":"cmc","iso639-1":null},"Chamorro":{"name":"Chamorro","names":["Chamorro"],"iso639-2":"cha","iso639-1":"ch"},"Chechen":{"name":"Chechen","names":["Chechen"],"iso639-2":"che","iso639-1":"ce"},"Cherokee":{"name":"Cherokee","names":["Cherokee"],"iso639-2":"chr","iso639-1":null},"Chewa":{"name":"Chewa","names":["Chichewa","Chewa","Nyanja"],"iso639-2":"nya","iso639-1":"ny"},"Cheyenne":{"name":"Cheyenne","names":["Cheyenne"],"iso639-2":"chy","iso639-1":null},"Chibcha":{"name":"Chibcha","names":["Chibcha"],"iso639-2":"chb","iso639-1":null},"Chichewa":{"name":"Chichewa","names":["Chichewa","Chewa","Nyanja"],"iso639-2":"nya","iso639-1":"ny"},"Chinese":{"name":"Chinese","names":["Chinese"],"iso639-2":"chi/zho","iso639-1":"zh"},"Chinook jargon":{"name":"Chinook jargon","names":["Chinook jargon"],"iso639-2":"chn","iso639-1":null},"Chipewyan":{"name":"Chipewyan","names":["Chipewyan","Dene Suline"],"iso639-2":"chp","iso639-1":null},"Choctaw":{"name":"Choctaw","names":["Choctaw"],"iso639-2":"cho","iso639-1":null},"Chuang":{"name":"Chuang","names":["Zhuang","Chuang"],"iso639-2":"zha","iso639-1":"za"},"Church Slavic":{"name":"Church Slavic","names":["Church Slavic","Old Slavonic","Church Slavonic","Old Bulgarian","Old Church Slavonic"],"iso639-2":"chu","iso639-1":"cu"},"Church Slavonic":{"name":"Church Slavonic","names":["Church Slavic","Old Slavonic","Church Slavonic","Old Bulgarian","Old Church Slavonic"],"iso639-2":"chu","iso639-1":"cu"},"Chuukese":{"name":"Chuukese","names":["Chuukese"],"iso639-2":"chk","iso639-1":null},"Chuvash":{"name":"Chuvash","names":["Chuvash"],"iso639-2":"chv","iso639-1":"cv"},"Classical Nepal Bhasa":{"name":"Classical Nepal Bhasa","names":["Classical Newari","Old Newari","Classical Nepal Bhasa"],"iso639-2":"nwc","iso639-1":null},"Classical Newari":{"name":"Classical Newari","names":["Classical Newari","Old Newari","Classical Nepal Bhasa"],"iso639-2":"nwc","iso639-1":null},"Classical Syriac":{"name":"Classical Syriac","names":["Classical Syriac"],"iso639-2":"syc","iso639-1":null},"Cook Islands Maori":{"name":"Cook Islands Maori","names":["Rarotongan","Cook Islands Maori"],"iso639-2":"rar","iso639-1":null},"Coptic":{"name":"Coptic","names":["Coptic"],"iso639-2":"cop","iso639-1":null},"Cornish":{"name":"Cornish","names":["Cornish"],"iso639-2":"cor","iso639-1":"kw"},"Corsican":{"name":"Corsican","names":["Corsican"],"iso639-2":"cos","iso639-1":"co"},"Cree":{"name":"Cree","names":["Cree"],"iso639-2":"cre","iso639-1":"cr"},"Creek":{"name":"Creek","names":["Creek"],"iso639-2":"mus","iso639-1":null},"Creoles and pidgins":{"name":"Creoles and pidgins","names":["Creoles and pidgins"],"iso639-2":"crp","iso639-1":null},"Creoles and pidgins, English based":{"name":"Creoles and pidgins, English based","names":["Creoles and pidgins, English based"],"iso639-2":"cpe","iso639-1":null},"Creoles and pidgins, French-based":{"name":"Creoles and pidgins, French-based","names":["Creoles and pidgins, French-based"],"iso639-2":"cpf","iso639-1":null},"Creoles and pidgins, Portuguese-based":{"name":"Creoles and pidgins, Portuguese-based","names":["Creoles and pidgins, Portuguese-based"],"iso639-2":"cpp","iso639-1":null},"Crimean Tatar":{"name":"Crimean Tatar","names":["Crimean Tatar","Crimean Turkish"],"iso639-2":"crh","iso639-1":null},"Crimean Turkish":{"name":"Crimean Turkish","names":["Crimean Tatar","Crimean Turkish"],"iso639-2":"crh","iso639-1":null},"Croatian":{"name":"Croatian","names":["Croatian"],"iso639-2":"hrv","iso639-1":"hr"},"Cushitic languages":{"name":"Cushitic languages","names":["Cushitic languages"],"iso639-2":"cus","iso639-1":null},"Czech":{"name":"Czech","names":["Czech"],"iso639-2":"cze/ces","iso639-1":"cs"},"Dakota":{"name":"Dakota","names":["Dakota"],"iso639-2":"dak","iso639-1":null},"Danish":{"name":"Danish","names":["Danish"],"iso639-2":"dan","iso639-1":"da"},"Dargwa":{"name":"Dargwa","names":["Dargwa"],"iso639-2":"dar","iso639-1":null},"Delaware":{"name":"Delaware","names":["Delaware"],"iso639-2":"del","iso639-1":null},"Dene Suline":{"name":"Dene Suline","names":["Chipewyan","Dene Suline"],"iso639-2":"chp","iso639-1":null},"Dhivehi":{"name":"Dhivehi","names":["Divehi","Dhivehi","Maldivian"],"iso639-2":"div","iso639-1":"dv"},"Dimili":{"name":"Dimili","names":["Zaza","Dimili","Dimli","Kirdki","Kirmanjki","Zazaki"],"iso639-2":"zza","iso639-1":null},"Dimli":{"name":"Dimli","names":["Zaza","Dimili","Dimli","Kirdki","Kirmanjki","Zazaki"],"iso639-2":"zza","iso639-1":null},"Dinka":{"name":"Dinka","names":["Dinka"],"iso639-2":"din","iso639-1":null},"Divehi":{"name":"Divehi","names":["Divehi","Dhivehi","Maldivian"],"iso639-2":"div","iso639-1":"dv"},"Dogri":{"name":"Dogri","names":["Dogri"],"iso639-2":"doi","iso639-1":null},"Dogrib":{"name":"Dogrib","names":["Dogrib"],"iso639-2":"dgr","iso639-1":null},"Dravidian languages":{"name":"Dravidian languages","names":["Dravidian languages"],"iso639-2":"dra","iso639-1":null},"Duala":{"name":"Duala","names":["Duala"],"iso639-2":"dua","iso639-1":null},"Dutch":{"name":"Dutch","names":["Dutch","Flemish"],"iso639-2":"dut/nld","iso639-1":"nl"},"Dutch, Middle (ca.1050-1350)":{"name":"Dutch, Middle (ca.1050-1350)","names":["Dutch, Middle (ca.1050-1350)"],"iso639-2":"dum","iso639-1":null},"Dyula":{"name":"Dyula","names":["Dyula"],"iso639-2":"dyu","iso639-1":null},"Dzongkha":{"name":"Dzongkha","names":["Dzongkha"],"iso639-2":"dzo","iso639-1":"dz"},"Eastern Frisian":{"name":"Eastern Frisian","names":["Eastern Frisian"],"iso639-2":"frs","iso639-1":null},"Edo":{"name":"Edo","names":["Bini","Edo"],"iso639-2":"bin","iso639-1":null},"Efik":{"name":"Efik","names":["Efik"],"iso639-2":"efi","iso639-1":null},"Egyptian (Ancient)":{"name":"Egyptian (Ancient)","names":["Egyptian (Ancient)"],"iso639-2":"egy","iso639-1":null},"Ekajuk":{"name":"Ekajuk","names":["Ekajuk"],"iso639-2":"eka","iso639-1":null},"Elamite":{"name":"Elamite","names":["Elamite"],"iso639-2":"elx","iso639-1":null},"English":{"name":"English","names":["English"],"iso639-2":"eng","iso639-1":"en"},"English, Middle (1100-1500)":{"name":"English, Middle (1100-1500)","names":["English, Middle (1100-1500)"],"iso639-2":"enm","iso639-1":null},"English, Old (ca.450-1100)":{"name":"English, Old (ca.450-1100)","names":["English, Old (ca.450-1100)"],"iso639-2":"ang","iso639-1":null},"Erzya":{"name":"Erzya","names":["Erzya"],"iso639-2":"myv","iso639-1":null},"Esperanto":{"name":"Esperanto","names":["Esperanto"],"iso639-2":"epo","iso639-1":"eo"},"Estonian":{"name":"Estonian","names":["Estonian"],"iso639-2":"est","iso639-1":"et"},"Ewe":{"name":"Ewe","names":["Ewe"],"iso639-2":"ewe","iso639-1":"ee"},"Ewondo":{"name":"Ewondo","names":["Ewondo"],"iso639-2":"ewo","iso639-1":null},"Fang":{"name":"Fang","names":["Fang"],"iso639-2":"fan","iso639-1":null},"Fanti":{"name":"Fanti","names":["Fanti"],"iso639-2":"fat","iso639-1":null},"Faroese":{"name":"Faroese","names":["Faroese"],"iso639-2":"fao","iso639-1":"fo"},"Fijian":{"name":"Fijian","names":["Fijian"],"iso639-2":"fij","iso639-1":"fj"},"Filipino":{"name":"Filipino","names":["Filipino","Pilipino"],"iso639-2":"fil","iso639-1":null},"Finnish":{"name":"Finnish","names":["Finnish"],"iso639-2":"fin","iso639-1":"fi"},"Finno-Ugrian languages":{"name":"Finno-Ugrian languages","names":["Finno-Ugrian languages"],"iso639-2":"fiu","iso639-1":null},"Flemish":{"name":"Flemish","names":["Dutch","Flemish"],"iso639-2":"dut/nld","iso639-1":"nl"},"Fon":{"name":"Fon","names":["Fon"],"iso639-2":"fon","iso639-1":null},"French":{"name":"French","names":["French"],"iso639-2":"fre/fra","iso639-1":"fr"},"French, Middle (ca.1400-1600)":{"name":"French, Middle (ca.1400-1600)","names":["French, Middle (ca.1400-1600)"],"iso639-2":"frm","iso639-1":null},"French, Old (842-ca.1400)":{"name":"French, Old (842-ca.1400)","names":["French, Old (842-ca.1400)"],"iso639-2":"fro","iso639-1":null},"Friulian":{"name":"Friulian","names":["Friulian"],"iso639-2":"fur","iso639-1":null},"Fulah":{"name":"Fulah","names":["Fulah"],"iso639-2":"ful","iso639-1":"ff"},"Ga":{"name":"Ga","names":["Ga"],"iso639-2":"gaa","iso639-1":null},"Gaelic":{"name":"Gaelic","names":["Gaelic","Scottish Gaelic"],"iso639-2":"gla","iso639-1":"gd"},"Galibi Carib":{"name":"Galibi Carib","names":["Galibi Carib"],"iso639-2":"car","iso639-1":null},"Galician":{"name":"Galician","names":["Galician"],"iso639-2":"glg","iso639-1":"gl"},"Ganda":{"name":"Ganda","names":["Ganda"],"iso639-2":"lug","iso639-1":"lg"},"Gayo":{"name":"Gayo","names":["Gayo"],"iso639-2":"gay","iso639-1":null},"Gbaya":{"name":"Gbaya","names":["Gbaya"],"iso639-2":"gba","iso639-1":null},"Geez":{"name":"Geez","names":["Geez"],"iso639-2":"gez","iso639-1":null},"Georgian":{"name":"Georgian","names":["Georgian"],"iso639-2":"geo/kat","iso639-1":"ka"},"German":{"name":"German","names":["German"],"iso639-2":"ger/deu","iso639-1":"de"},"German, Low":{"name":"German, Low","names":["Low German","Low Saxon","German, Low","Saxon, Low"],"iso639-2":"nds","iso639-1":null},"German, Middle High (ca.1050-1500)":{"name":"German, Middle High (ca.1050-1500)","names":["German, Middle High (ca.1050-1500)"],"iso639-2":"gmh","iso639-1":null},"German, Old High (ca.750-1050)":{"name":"German, Old High (ca.750-1050)","names":["German, Old High (ca.750-1050)"],"iso639-2":"goh","iso639-1":null},"Germanic languages":{"name":"Germanic languages","names":["Germanic languages"],"iso639-2":"gem","iso639-1":null},"Gikuyu":{"name":"Gikuyu","names":["Kikuyu","Gikuyu"],"iso639-2":"kik","iso639-1":"ki"},"Gilbertese":{"name":"Gilbertese","names":["Gilbertese"],"iso639-2":"gil","iso639-1":null},"Gondi":{"name":"Gondi","names":["Gondi"],"iso639-2":"gon","iso639-1":null},"Gorontalo":{"name":"Gorontalo","names":["Gorontalo"],"iso639-2":"gor","iso639-1":null},"Gothic":{"name":"Gothic","names":["Gothic"],"iso639-2":"got","iso639-1":null},"Grebo":{"name":"Grebo","names":["Grebo"],"iso639-2":"grb","iso639-1":null},"Greek, Ancient (to 1453)":{"name":"Greek, Ancient (to 1453)","names":["Greek, Ancient (to 1453)"],"iso639-2":"grc","iso639-1":null},"Greek, Modern (1453-)":{"name":"Greek, Modern (1453-)","names":["Greek, Modern (1453-)"],"iso639-2":"gre/ell","iso639-1":"el"},"Greenlandic":{"name":"Greenlandic","names":["Kalaallisut","Greenlandic"],"iso639-2":"kal","iso639-1":"kl"},"Guarani":{"name":"Guarani","names":["Guarani"],"iso639-2":"grn","iso639-1":"gn"},"Gujarati":{"name":"Gujarati","names":["Gujarati"],"iso639-2":"guj","iso639-1":"gu"},"Gwich'in":{"name":"Gwich'in","names":["Gwich'in"],"iso639-2":"gwi","iso639-1":null},"Haida":{"name":"Haida","names":["Haida"],"iso639-2":"hai","iso639-1":null},"Haitian":{"name":"Haitian","names":["Haitian","Haitian Creole"],"iso639-2":"hat","iso639-1":"ht"},"Haitian Creole":{"name":"Haitian Creole","names":["Haitian","Haitian Creole"],"iso639-2":"hat","iso639-1":"ht"},"Hausa":{"name":"Hausa","names":["Hausa"],"iso639-2":"hau","iso639-1":"ha"},"Hawaiian":{"name":"Hawaiian","names":["Hawaiian"],"iso639-2":"haw","iso639-1":null},"Hebrew":{"name":"Hebrew","names":["Hebrew"],"iso639-2":"heb","iso639-1":"he"},"Herero":{"name":"Herero","names":["Herero"],"iso639-2":"her","iso639-1":"hz"},"Hiligaynon":{"name":"Hiligaynon","names":["Hiligaynon"],"iso639-2":"hil","iso639-1":null},"Himachali languages":{"name":"Himachali languages","names":["Himachali languages","Western Pahari languages"],"iso639-2":"him","iso639-1":null},"Hindi":{"name":"Hindi","names":["Hindi"],"iso639-2":"hin","iso639-1":"hi"},"Hiri Motu":{"name":"Hiri Motu","names":["Hiri Motu"],"iso639-2":"hmo","iso639-1":"ho"},"Hittite":{"name":"Hittite","names":["Hittite"],"iso639-2":"hit","iso639-1":null},"Hmong":{"name":"Hmong","names":["Hmong","Mong"],"iso639-2":"hmn","iso639-1":null},"Hungarian":{"name":"Hungarian","names":["Hungarian"],"iso639-2":"hun","iso639-1":"hu"},"Hupa":{"name":"Hupa","names":["Hupa"],"iso639-2":"hup","iso639-1":null},"Iban":{"name":"Iban","names":["Iban"],"iso639-2":"iba","iso639-1":null},"Icelandic":{"name":"Icelandic","names":["Icelandic"],"iso639-2":"ice/isl","iso639-1":"is"},"Ido":{"name":"Ido","names":["Ido"],"iso639-2":"ido","iso639-1":"io"},"Igbo":{"name":"Igbo","names":["Igbo"],"iso639-2":"ibo","iso639-1":"ig"},"Ijo languages":{"name":"Ijo languages","names":["Ijo languages"],"iso639-2":"ijo","iso639-1":null},"Iloko":{"name":"Iloko","names":["Iloko"],"iso639-2":"ilo","iso639-1":null},"Imperial Aramaic (700-300 BCE)":{"name":"Imperial Aramaic (700-300 BCE)","names":["Official Aramaic (700-300 BCE)","Imperial Aramaic (700-300 BCE)"],"iso639-2":"arc","iso639-1":null},"Inari Sami":{"name":"Inari Sami","names":["Inari Sami"],"iso639-2":"smn","iso639-1":null},"Indic languages":{"name":"Indic languages","names":["Indic languages"],"iso639-2":"inc","iso639-1":null},"Indo-European languages":{"name":"Indo-European languages","names":["Indo-European languages"],"iso639-2":"ine","iso639-1":null},"Indonesian":{"name":"Indonesian","names":["Indonesian"],"iso639-2":"ind","iso639-1":"id"},"Ingush":{"name":"Ingush","names":["Ingush"],"iso639-2":"inh","iso639-1":null},"Interlingua (International Auxiliary Language Association)":{"name":"Interlingua (International Auxiliary Language Association)","names":["Interlingua (International Auxiliary Language Association)"],"iso639-2":"ina","iso639-1":"ia"},"Interlingue":{"name":"Interlingue","names":["Interlingue","Occidental"],"iso639-2":"ile","iso639-1":"ie"},"Inuktitut":{"name":"Inuktitut","names":["Inuktitut"],"iso639-2":"iku","iso639-1":"iu"},"Inupiaq":{"name":"Inupiaq","names":["Inupiaq"],"iso639-2":"ipk","iso639-1":"ik"},"Iranian languages":{"name":"Iranian languages","names":["Iranian languages"],"iso639-2":"ira","iso639-1":null},"Irish":{"name":"Irish","names":["Irish"],"iso639-2":"gle","iso639-1":"ga"},"Irish, Middle (900-1200)":{"name":"Irish, Middle (900-1200)","names":["Irish, Middle (900-1200)"],"iso639-2":"mga","iso639-1":null},"Irish, Old (to 900)":{"name":"Irish, Old (to 900)","names":["Irish, Old (to 900)"],"iso639-2":"sga","iso639-1":null},"Iroquoian languages":{"name":"Iroquoian languages","names":["Iroquoian languages"],"iso639-2":"iro","iso639-1":null},"Italian":{"name":"Italian","names":["Italian"],"iso639-2":"ita","iso639-1":"it"},"Japanese":{"name":"Japanese","names":["Japanese"],"iso639-2":"jpn","iso639-1":"ja"},"Javanese":{"name":"Javanese","names":["Javanese"],"iso639-2":"jav","iso639-1":"jv"},"Jingpho":{"name":"Jingpho","names":["Kachin","Jingpho"],"iso639-2":"kac","iso639-1":null},"Judeo-Arabic":{"name":"Judeo-Arabic","names":["Judeo-Arabic"],"iso639-2":"jrb","iso639-1":null},"Judeo-Persian":{"name":"Judeo-Persian","names":["Judeo-Persian"],"iso639-2":"jpr","iso639-1":null},"Kabardian":{"name":"Kabardian","names":["Kabardian"],"iso639-2":"kbd","iso639-1":null},"Kabyle":{"name":"Kabyle","names":["Kabyle"],"iso639-2":"kab","iso639-1":null},"Kachin":{"name":"Kachin","names":["Kachin","Jingpho"],"iso639-2":"kac","iso639-1":null},"Kalaallisut":{"name":"Kalaallisut","names":["Kalaallisut","Greenlandic"],"iso639-2":"kal","iso639-1":"kl"},"Kalmyk":{"name":"Kalmyk","names":["Kalmyk","Oirat"],"iso639-2":"xal","iso639-1":null},"Kamba":{"name":"Kamba","names":["Kamba"],"iso639-2":"kam","iso639-1":null},"Kannada":{"name":"Kannada","names":["Kannada"],"iso639-2":"kan","iso639-1":"kn"},"Kanuri":{"name":"Kanuri","names":["Kanuri"],"iso639-2":"kau","iso639-1":"kr"},"Kapampangan":{"name":"Kapampangan","names":["Pampanga","Kapampangan"],"iso639-2":"pam","iso639-1":null},"Kara-Kalpak":{"name":"Kara-Kalpak","names":["Kara-Kalpak"],"iso639-2":"kaa","iso639-1":null},"Karachay-Balkar":{"name":"Karachay-Balkar","names":["Karachay-Balkar"],"iso639-2":"krc","iso639-1":null},"Karelian":{"name":"Karelian","names":["Karelian"],"iso639-2":"krl","iso639-1":null},"Karen languages":{"name":"Karen languages","names":["Karen languages"],"iso639-2":"kar","iso639-1":null},"Kashmiri":{"name":"Kashmiri","names":["Kashmiri"],"iso639-2":"kas","iso639-1":"ks"},"Kashubian":{"name":"Kashubian","names":["Kashubian"],"iso639-2":"csb","iso639-1":null},"Kawi":{"name":"Kawi","names":["Kawi"],"iso639-2":"kaw","iso639-1":null},"Kazakh":{"name":"Kazakh","names":["Kazakh"],"iso639-2":"kaz","iso639-1":"kk"},"Khasi":{"name":"Khasi","names":["Khasi"],"iso639-2":"kha","iso639-1":null},"Khoisan languages":{"name":"Khoisan languages","names":["Khoisan languages"],"iso639-2":"khi","iso639-1":null},"Khotanese":{"name":"Khotanese","names":["Khotanese","Sakan"],"iso639-2":"kho","iso639-1":null},"Kikuyu":{"name":"Kikuyu","names":["Kikuyu","Gikuyu"],"iso639-2":"kik","iso639-1":"ki"},"Kimbundu":{"name":"Kimbundu","names":["Kimbundu"],"iso639-2":"kmb","iso639-1":null},"Kinyarwanda":{"name":"Kinyarwanda","names":["Kinyarwanda"],"iso639-2":"kin","iso639-1":"rw"},"Kirdki":{"name":"Kirdki","names":["Zaza","Dimili","Dimli","Kirdki","Kirmanjki","Zazaki"],"iso639-2":"zza","iso639-1":null},"Kirghiz":{"name":"Kirghiz","names":["Kirghiz","Kyrgyz"],"iso639-2":"kir","iso639-1":"ky"},"Kirmanjki":{"name":"Kirmanjki","names":["Zaza","Dimili","Dimli","Kirdki","Kirmanjki","Zazaki"],"iso639-2":"zza","iso639-1":null},"Klingon":{"name":"Klingon","names":["Klingon","tlhIngan-Hol"],"iso639-2":"tlh","iso639-1":null},"Komi":{"name":"Komi","names":["Komi"],"iso639-2":"kom","iso639-1":"kv"},"Kongo":{"name":"Kongo","names":["Kongo"],"iso639-2":"kon","iso639-1":"kg"},"Konkani":{"name":"Konkani","names":["Konkani"],"iso639-2":"kok","iso639-1":null},"Korean":{"name":"Korean","names":["Korean"],"iso639-2":"kor","iso639-1":"ko"},"Kosraean":{"name":"Kosraean","names":["Kosraean"],"iso639-2":"kos","iso639-1":null},"Kpelle":{"name":"Kpelle","names":["Kpelle"],"iso639-2":"kpe","iso639-1":null},"Kru languages":{"name":"Kru languages","names":["Kru languages"],"iso639-2":"kro","iso639-1":null},"Kuanyama":{"name":"Kuanyama","names":["Kuanyama","Kwanyama"],"iso639-2":"kua","iso639-1":"kj"},"Kumyk":{"name":"Kumyk","names":["Kumyk"],"iso639-2":"kum","iso639-1":null},"Kurdish":{"name":"Kurdish","names":["Kurdish"],"iso639-2":"kur","iso639-1":"ku"},"Kurukh":{"name":"Kurukh","names":["Kurukh"],"iso639-2":"kru","iso639-1":null},"Kutenai":{"name":"Kutenai","names":["Kutenai"],"iso639-2":"kut","iso639-1":null},"Kwanyama":{"name":"Kwanyama","names":["Kuanyama","Kwanyama"],"iso639-2":"kua","iso639-1":"kj"},"Kyrgyz":{"name":"Kyrgyz","names":["Kirghiz","Kyrgyz"],"iso639-2":"kir","iso639-1":"ky"},"Ladino":{"name":"Ladino","names":["Ladino"],"iso639-2":"lad","iso639-1":null},"Lahnda":{"name":"Lahnda","names":["Lahnda"],"iso639-2":"lah","iso639-1":null},"Lamba":{"name":"Lamba","names":["Lamba"],"iso639-2":"lam","iso639-1":null},"Land Dayak languages":{"name":"Land Dayak languages","names":["Land Dayak languages"],"iso639-2":"day","iso639-1":null},"Lao":{"name":"Lao","names":["Lao"],"iso639-2":"lao","iso639-1":"lo"},"Latin":{"name":"Latin","names":["Latin"],"iso639-2":"lat","iso639-1":"la"},"Latvian":{"name":"Latvian","names":["Latvian"],"iso639-2":"lav","iso639-1":"lv"},"Leonese":{"name":"Leonese","names":["Asturian","Bable","Leonese","Asturleonese"],"iso639-2":"ast","iso639-1":null},"Letzeburgesch":{"name":"Letzeburgesch","names":["Luxembourgish","Letzeburgesch"],"iso639-2":"ltz","iso639-1":"lb"},"Lezghian":{"name":"Lezghian","names":["Lezghian"],"iso639-2":"lez","iso639-1":null},"Limburgan":{"name":"Limburgan","names":["Limburgan","Limburger","Limburgish"],"iso639-2":"lim","iso639-1":"li"},"Limburger":{"name":"Limburger","names":["Limburgan","Limburger","Limburgish"],"iso639-2":"lim","iso639-1":"li"},"Limburgish":{"name":"Limburgish","names":["Limburgan","Limburger","Limburgish"],"iso639-2":"lim","iso639-1":"li"},"Lingala":{"name":"Lingala","names":["Lingala"],"iso639-2":"lin","iso639-1":"ln"},"Lithuanian":{"name":"Lithuanian","names":["Lithuanian"],"iso639-2":"lit","iso639-1":"lt"},"Lojban":{"name":"Lojban","names":["Lojban"],"iso639-2":"jbo","iso639-1":null},"Low German":{"name":"Low German","names":["Low German","Low Saxon","German, Low","Saxon, Low"],"iso639-2":"nds","iso639-1":null},"Low Saxon":{"name":"Low Saxon","names":["Low German","Low Saxon","German, Low","Saxon, Low"],"iso639-2":"nds","iso639-1":null},"Lower Sorbian":{"name":"Lower Sorbian","names":["Lower Sorbian"],"iso639-2":"dsb","iso639-1":null},"Lozi":{"name":"Lozi","names":["Lozi"],"iso639-2":"loz","iso639-1":null},"Luba-Katanga":{"name":"Luba-Katanga","names":["Luba-Katanga"],"iso639-2":"lub","iso639-1":"lu"},"Luba-Lulua":{"name":"Luba-Lulua","names":["Luba-Lulua"],"iso639-2":"lua","iso639-1":null},"Luiseno":{"name":"Luiseno","names":["Luiseno"],"iso639-2":"lui","iso639-1":null},"Lule Sami":{"name":"Lule Sami","names":["Lule Sami"],"iso639-2":"smj","iso639-1":null},"Lunda":{"name":"Lunda","names":["Lunda"],"iso639-2":"lun","iso639-1":null},"Luo (Kenya and Tanzania)":{"name":"Luo (Kenya and Tanzania)","names":["Luo (Kenya and Tanzania)"],"iso639-2":"luo","iso639-1":null},"Lushai":{"name":"Lushai","names":["Lushai"],"iso639-2":"lus","iso639-1":null},"Luxembourgish":{"name":"Luxembourgish","names":["Luxembourgish","Letzeburgesch"],"iso639-2":"ltz","iso639-1":"lb"},"Macedo-Romanian":{"name":"Macedo-Romanian","names":["Aromanian","Arumanian","Macedo-Romanian"],"iso639-2":"rup","iso639-1":null},"Macedonian":{"name":"Macedonian","names":["Macedonian"],"iso639-2":"mac/mkd","iso639-1":"mk"},"Madurese":{"name":"Madurese","names":["Madurese"],"iso639-2":"mad","iso639-1":null},"Magahi":{"name":"Magahi","names":["Magahi"],"iso639-2":"mag","iso639-1":null},"Maithili":{"name":"Maithili","names":["Maithili"],"iso639-2":"mai","iso639-1":null},"Makasar":{"name":"Makasar","names":["Makasar"],"iso639-2":"mak","iso639-1":null},"Malagasy":{"name":"Malagasy","names":["Malagasy"],"iso639-2":"mlg","iso639-1":"mg"},"Malay":{"name":"Malay","names":["Malay"],"iso639-2":"may/msa","iso639-1":"ms"},"Malayalam":{"name":"Malayalam","names":["Malayalam"],"iso639-2":"mal","iso639-1":"ml"},"Maldivian":{"name":"Maldivian","names":["Divehi","Dhivehi","Maldivian"],"iso639-2":"div","iso639-1":"dv"},"Maltese":{"name":"Maltese","names":["Maltese"],"iso639-2":"mlt","iso639-1":"mt"},"Manchu":{"name":"Manchu","names":["Manchu"],"iso639-2":"mnc","iso639-1":null},"Mandar":{"name":"Mandar","names":["Mandar"],"iso639-2":"mdr","iso639-1":null},"Mandingo":{"name":"Mandingo","names":["Mandingo"],"iso639-2":"man","iso639-1":null},"Manipuri":{"name":"Manipuri","names":["Manipuri"],"iso639-2":"mni","iso639-1":null},"Manobo languages":{"name":"Manobo languages","names":["Manobo languages"],"iso639-2":"mno","iso639-1":null},"Manx":{"name":"Manx","names":["Manx"],"iso639-2":"glv","iso639-1":"gv"},"Maori":{"name":"Maori","names":["Maori"],"iso639-2":"mao/mri","iso639-1":"mi"},"Mapuche":{"name":"Mapuche","names":["Mapudungun","Mapuche"],"iso639-2":"arn","iso639-1":null},"Mapudungun":{"name":"Mapudungun","names":["Mapudungun","Mapuche"],"iso639-2":"arn","iso639-1":null},"Marathi":{"name":"Marathi","names":["Marathi"],"iso639-2":"mar","iso639-1":"mr"},"Mari":{"name":"Mari","names":["Mari"],"iso639-2":"chm","iso639-1":null},"Marshallese":{"name":"Marshallese","names":["Marshallese"],"iso639-2":"mah","iso639-1":"mh"},"Marwari":{"name":"Marwari","names":["Marwari"],"iso639-2":"mwr","iso639-1":null},"Masai":{"name":"Masai","names":["Masai"],"iso639-2":"mas","iso639-1":null},"Mayan languages":{"name":"Mayan languages","names":["Mayan languages"],"iso639-2":"myn","iso639-1":null},"Mende":{"name":"Mende","names":["Mende"],"iso639-2":"men","iso639-1":null},"Mi'kmaq":{"name":"Mi'kmaq","names":["Mi'kmaq","Micmac"],"iso639-2":"mic","iso639-1":null},"Micmac":{"name":"Micmac","names":["Mi'kmaq","Micmac"],"iso639-2":"mic","iso639-1":null},"Minangkabau":{"name":"Minangkabau","names":["Minangkabau"],"iso639-2":"min","iso639-1":null},"Mirandese":{"name":"Mirandese","names":["Mirandese"],"iso639-2":"mwl","iso639-1":null},"Mohawk":{"name":"Mohawk","names":["Mohawk"],"iso639-2":"moh","iso639-1":null},"Moksha":{"name":"Moksha","names":["Moksha"],"iso639-2":"mdf","iso639-1":null},"Moldavian":{"name":"Moldavian","names":["Romanian","Moldavian","Moldovan"],"iso639-2":"rum/ron","iso639-1":"ro"},"Moldovan":{"name":"Moldovan","names":["Romanian","Moldavian","Moldovan"],"iso639-2":"rum/ron","iso639-1":"ro"},"Mon-Khmer languages":{"name":"Mon-Khmer languages","names":["Mon-Khmer languages"],"iso639-2":"mkh","iso639-1":null},"Mong":{"name":"Mong","names":["Hmong","Mong"],"iso639-2":"hmn","iso639-1":null},"Mongo":{"name":"Mongo","names":["Mongo"],"iso639-2":"lol","iso639-1":null},"Mongolian":{"name":"Mongolian","names":["Mongolian"],"iso639-2":"mon","iso639-1":"mn"},"Montenegrin":{"name":"Montenegrin","names":["Montenegrin"],"iso639-2":"cnr","iso639-1":null},"Mossi":{"name":"Mossi","names":["Mossi"],"iso639-2":"mos","iso639-1":null},"Multiple languages":{"name":"Multiple languages","names":["Multiple languages"],"iso639-2":"mul","iso639-1":null},"Munda languages":{"name":"Munda languages","names":["Munda languages"],"iso639-2":"mun","iso639-1":null},"N'Ko":{"name":"N'Ko","names":["N'Ko"],"iso639-2":"nqo","iso639-1":null},"Nahuatl languages":{"name":"Nahuatl languages","names":["Nahuatl languages"],"iso639-2":"nah","iso639-1":null},"Nauru":{"name":"Nauru","names":["Nauru"],"iso639-2":"nau","iso639-1":"na"},"Navaho":{"name":"Navaho","names":["Navajo","Navaho"],"iso639-2":"nav","iso639-1":"nv"},"Navajo":{"name":"Navajo","names":["Navajo","Navaho"],"iso639-2":"nav","iso639-1":"nv"},"Ndebele, North":{"name":"Ndebele, North","names":["Ndebele, North","North Ndebele"],"iso639-2":"nde","iso639-1":"nd"},"Ndebele, South":{"name":"Ndebele, South","names":["Ndebele, South","South Ndebele"],"iso639-2":"nbl","iso639-1":"nr"},"Ndonga":{"name":"Ndonga","names":["Ndonga"],"iso639-2":"ndo","iso639-1":"ng"},"Neapolitan":{"name":"Neapolitan","names":["Neapolitan"],"iso639-2":"nap","iso639-1":null},"Nepal Bhasa":{"name":"Nepal Bhasa","names":["Nepal Bhasa","Newari"],"iso639-2":"new","iso639-1":null},"Nepali":{"name":"Nepali","names":["Nepali"],"iso639-2":"nep","iso639-1":"ne"},"Newari":{"name":"Newari","names":["Nepal Bhasa","Newari"],"iso639-2":"new","iso639-1":null},"Nias":{"name":"Nias","names":["Nias"],"iso639-2":"nia","iso639-1":null},"Niger-Kordofanian languages":{"name":"Niger-Kordofanian languages","names":["Niger-Kordofanian languages"],"iso639-2":"nic","iso639-1":null},"Nilo-Saharan languages":{"name":"Nilo-Saharan languages","names":["Nilo-Saharan languages"],"iso639-2":"ssa","iso639-1":null},"Niuean":{"name":"Niuean","names":["Niuean"],"iso639-2":"niu","iso639-1":null},"No linguistic content":{"name":"No linguistic content","names":["No linguistic content","Not applicable"],"iso639-2":"zxx","iso639-1":null},"Nogai":{"name":"Nogai","names":["Nogai"],"iso639-2":"nog","iso639-1":null},"Norse, Old":{"name":"Norse, Old","names":["Norse, Old"],"iso639-2":"non","iso639-1":null},"North American Indian languages":{"name":"North American Indian languages","names":["North American Indian languages"],"iso639-2":"nai","iso639-1":null},"North Ndebele":{"name":"North Ndebele","names":["Ndebele, North","North Ndebele"],"iso639-2":"nde","iso639-1":"nd"},"Northern Frisian":{"name":"Northern Frisian","names":["Northern Frisian"],"iso639-2":"frr","iso639-1":null},"Northern Sami":{"name":"Northern Sami","names":["Northern Sami"],"iso639-2":"sme","iso639-1":"se"},"Northern Sotho":{"name":"Northern Sotho","names":["Pedi","Sepedi","Northern Sotho"],"iso639-2":"nso","iso639-1":null},"Norwegian":{"name":"Norwegian","names":["Norwegian"],"iso639-2":"nor","iso639-1":"no"},"Norwegian Bokmål":{"name":"Norwegian Bokmål","names":["Bokmål, Norwegian","Norwegian Bokmål"],"iso639-2":"nob","iso639-1":"nb"},"Norwegian Nynorsk":{"name":"Norwegian Nynorsk","names":["Norwegian Nynorsk","Nynorsk, Norwegian"],"iso639-2":"nno","iso639-1":"nn"},"Not applicable":{"name":"Not applicable","names":["No linguistic content","Not applicable"],"iso639-2":"zxx","iso639-1":null},"Nubian languages":{"name":"Nubian languages","names":["Nubian languages"],"iso639-2":"nub","iso639-1":null},"Nuosu":{"name":"Nuosu","names":["Sichuan Yi","Nuosu"],"iso639-2":"iii","iso639-1":"ii"},"Nyamwezi":{"name":"Nyamwezi","names":["Nyamwezi"],"iso639-2":"nym","iso639-1":null},"Nyanja":{"name":"Nyanja","names":["Chichewa","Chewa","Nyanja"],"iso639-2":"nya","iso639-1":"ny"},"Nyankole":{"name":"Nyankole","names":["Nyankole"],"iso639-2":"nyn","iso639-1":null},"Nynorsk, Norwegian":{"name":"Nynorsk, Norwegian","names":["Norwegian Nynorsk","Nynorsk, Norwegian"],"iso639-2":"nno","iso639-1":"nn"},"Nyoro":{"name":"Nyoro","names":["Nyoro"],"iso639-2":"nyo","iso639-1":null},"Nzima":{"name":"Nzima","names":["Nzima"],"iso639-2":"nzi","iso639-1":null},"Occidental":{"name":"Occidental","names":["Interlingue","Occidental"],"iso639-2":"ile","iso639-1":"ie"},"Occitan (post 1500)":{"name":"Occitan (post 1500)","names":["Occitan (post 1500)"],"iso639-2":"oci","iso639-1":"oc"},"Occitan, Old (to 1500)":{"name":"Occitan, Old (to 1500)","names":["Provençal, Old (to 1500)","Occitan, Old (to 1500)"],"iso639-2":"pro","iso639-1":null},"Official Aramaic (700-300 BCE)":{"name":"Official Aramaic (700-300 BCE)","names":["Official Aramaic (700-300 BCE)","Imperial Aramaic (700-300 BCE)"],"iso639-2":"arc","iso639-1":null},"Oirat":{"name":"Oirat","names":["Kalmyk","Oirat"],"iso639-2":"xal","iso639-1":null},"Ojibwa":{"name":"Ojibwa","names":["Ojibwa"],"iso639-2":"oji","iso639-1":"oj"},"Old Bulgarian":{"name":"Old Bulgarian","names":["Church Slavic","Old Slavonic","Church Slavonic","Old Bulgarian","Old Church Slavonic"],"iso639-2":"chu","iso639-1":"cu"},"Old Church Slavonic":{"name":"Old Church Slavonic","names":["Church Slavic","Old Slavonic","Church Slavonic","Old Bulgarian","Old Church Slavonic"],"iso639-2":"chu","iso639-1":"cu"},"Old Newari":{"name":"Old Newari","names":["Classical Newari","Old Newari","Classical Nepal Bhasa"],"iso639-2":"nwc","iso639-1":null},"Old Slavonic":{"name":"Old Slavonic","names":["Church Slavic","Old Slavonic","Church Slavonic","Old Bulgarian","Old Church Slavonic"],"iso639-2":"chu","iso639-1":"cu"},"Oriya":{"name":"Oriya","names":["Oriya"],"iso639-2":"ori","iso639-1":"or"},"Oromo":{"name":"Oromo","names":["Oromo"],"iso639-2":"orm","iso639-1":"om"},"Osage":{"name":"Osage","names":["Osage"],"iso639-2":"osa","iso639-1":null},"Ossetian":{"name":"Ossetian","names":["Ossetian","Ossetic"],"iso639-2":"oss","iso639-1":"os"},"Ossetic":{"name":"Ossetic","names":["Ossetian","Ossetic"],"iso639-2":"oss","iso639-1":"os"},"Otomian languages":{"name":"Otomian languages","names":["Otomian languages"],"iso639-2":"oto","iso639-1":null},"Pahlavi":{"name":"Pahlavi","names":["Pahlavi"],"iso639-2":"pal","iso639-1":null},"Palauan":{"name":"Palauan","names":["Palauan"],"iso639-2":"pau","iso639-1":null},"Pali":{"name":"Pali","names":["Pali"],"iso639-2":"pli","iso639-1":"pi"},"Pampanga":{"name":"Pampanga","names":["Pampanga","Kapampangan"],"iso639-2":"pam","iso639-1":null},"Pangasinan":{"name":"Pangasinan","names":["Pangasinan"],"iso639-2":"pag","iso639-1":null},"Panjabi":{"name":"Panjabi","names":["Panjabi","Punjabi"],"iso639-2":"pan","iso639-1":"pa"},"Papiamento":{"name":"Papiamento","names":["Papiamento"],"iso639-2":"pap","iso639-1":null},"Papuan languages":{"name":"Papuan languages","names":["Papuan languages"],"iso639-2":"paa","iso639-1":null},"Pashto":{"name":"Pashto","names":["Pushto","Pashto"],"iso639-2":"pus","iso639-1":"ps"},"Pedi":{"name":"Pedi","names":["Pedi","Sepedi","Northern Sotho"],"iso639-2":"nso","iso639-1":null},"Persian":{"name":"Persian","names":["Persian"],"iso639-2":"per/fas","iso639-1":"fa"},"Persian, Old (ca.600-400 B.C.)":{"name":"Persian, Old (ca.600-400 B.C.)","names":["Persian, Old (ca.600-400 B.C.)"],"iso639-2":"peo","iso639-1":null},"Philippine languages":{"name":"Philippine languages","names":["Philippine languages"],"iso639-2":"phi","iso639-1":null},"Phoenician":{"name":"Phoenician","names":["Phoenician"],"iso639-2":"phn","iso639-1":null},"Pilipino":{"name":"Pilipino","names":["Filipino","Pilipino"],"iso639-2":"fil","iso639-1":null},"Pohnpeian":{"name":"Pohnpeian","names":["Pohnpeian"],"iso639-2":"pon","iso639-1":null},"Polish":{"name":"Polish","names":["Polish"],"iso639-2":"pol","iso639-1":"pl"},"Portuguese":{"name":"Portuguese","names":["Portuguese"],"iso639-2":"por","iso639-1":"pt"},"Prakrit languages":{"name":"Prakrit languages","names":["Prakrit languages"],"iso639-2":"pra","iso639-1":null},"Provençal, Old (to 1500)":{"name":"Provençal, Old (to 1500)","names":["Provençal, Old (to 1500)","Occitan, Old (to 1500)"],"iso639-2":"pro","iso639-1":null},"Punjabi":{"name":"Punjabi","names":["Panjabi","Punjabi"],"iso639-2":"pan","iso639-1":"pa"},"Pushto":{"name":"Pushto","names":["Pushto","Pashto"],"iso639-2":"pus","iso639-1":"ps"},"Quechua":{"name":"Quechua","names":["Quechua"],"iso639-2":"que","iso639-1":"qu"},"Rajasthani":{"name":"Rajasthani","names":["Rajasthani"],"iso639-2":"raj","iso639-1":null},"Rapanui":{"name":"Rapanui","names":["Rapanui"],"iso639-2":"rap","iso639-1":null},"Rarotongan":{"name":"Rarotongan","names":["Rarotongan","Cook Islands Maori"],"iso639-2":"rar","iso639-1":null},"Reserved for local use":{"name":"Reserved for local use","names":["Reserved for local use"],"iso639-2":"qaa-qtz","iso639-1":null},"Romance languages":{"name":"Romance languages","names":["Romance languages"],"iso639-2":"roa","iso639-1":null},"Romanian":{"name":"Romanian","names":["Romanian","Moldavian","Moldovan"],"iso639-2":"rum/ron","iso639-1":"ro"},"Romansh":{"name":"Romansh","names":["Romansh"],"iso639-2":"roh","iso639-1":"rm"},"Romany":{"name":"Romany","names":["Romany"],"iso639-2":"rom","iso639-1":null},"Rundi":{"name":"Rundi","names":["Rundi"],"iso639-2":"run","iso639-1":"rn"},"Russian":{"name":"Russian","names":["Russian"],"iso639-2":"rus","iso639-1":"ru"},"Sakan":{"name":"Sakan","names":["Khotanese","Sakan"],"iso639-2":"kho","iso639-1":null},"Salishan languages":{"name":"Salishan languages","names":["Salishan languages"],"iso639-2":"sal","iso639-1":null},"Samaritan Aramaic":{"name":"Samaritan Aramaic","names":["Samaritan Aramaic"],"iso639-2":"sam","iso639-1":null},"Sami languages":{"name":"Sami languages","names":["Sami languages"],"iso639-2":"smi","iso639-1":null},"Samoan":{"name":"Samoan","names":["Samoan"],"iso639-2":"smo","iso639-1":"sm"},"Sandawe":{"name":"Sandawe","names":["Sandawe"],"iso639-2":"sad","iso639-1":null},"Sango":{"name":"Sango","names":["Sango"],"iso639-2":"sag","iso639-1":"sg"},"Sanskrit":{"name":"Sanskrit","names":["Sanskrit"],"iso639-2":"san","iso639-1":"sa"},"Santali":{"name":"Santali","names":["Santali"],"iso639-2":"sat","iso639-1":null},"Sardinian":{"name":"Sardinian","names":["Sardinian"],"iso639-2":"srd","iso639-1":"sc"},"Sasak":{"name":"Sasak","names":["Sasak"],"iso639-2":"sas","iso639-1":null},"Saxon, Low":{"name":"Saxon, Low","names":["Low German","Low Saxon","German, Low","Saxon, Low"],"iso639-2":"nds","iso639-1":null},"Scots":{"name":"Scots","names":["Scots"],"iso639-2":"sco","iso639-1":null},"Scottish Gaelic":{"name":"Scottish Gaelic","names":["Gaelic","Scottish Gaelic"],"iso639-2":"gla","iso639-1":"gd"},"Selkup":{"name":"Selkup","names":["Selkup"],"iso639-2":"sel","iso639-1":null},"Semitic languages":{"name":"Semitic languages","names":["Semitic languages"],"iso639-2":"sem","iso639-1":null},"Sepedi":{"name":"Sepedi","names":["Pedi","Sepedi","Northern Sotho"],"iso639-2":"nso","iso639-1":null},"Serbian":{"name":"Serbian","names":["Serbian"],"iso639-2":"srp","iso639-1":"sr"},"Serer":{"name":"Serer","names":["Serer"],"iso639-2":"srr","iso639-1":null},"Shan":{"name":"Shan","names":["Shan"],"iso639-2":"shn","iso639-1":null},"Shona":{"name":"Shona","names":["Shona"],"iso639-2":"sna","iso639-1":"sn"},"Sichuan Yi":{"name":"Sichuan Yi","names":["Sichuan Yi","Nuosu"],"iso639-2":"iii","iso639-1":"ii"},"Sicilian":{"name":"Sicilian","names":["Sicilian"],"iso639-2":"scn","iso639-1":null},"Sidamo":{"name":"Sidamo","names":["Sidamo"],"iso639-2":"sid","iso639-1":null},"Sign Languages":{"name":"Sign Languages","names":["Sign Languages"],"iso639-2":"sgn","iso639-1":null},"Siksika":{"name":"Siksika","names":["Siksika"],"iso639-2":"bla","iso639-1":null},"Sindhi":{"name":"Sindhi","names":["Sindhi"],"iso639-2":"snd","iso639-1":"sd"},"Sinhala":{"name":"Sinhala","names":["Sinhala","Sinhalese"],"iso639-2":"sin","iso639-1":"si"},"Sinhalese":{"name":"Sinhalese","names":["Sinhala","Sinhalese"],"iso639-2":"sin","iso639-1":"si"},"Sino-Tibetan languages":{"name":"Sino-Tibetan languages","names":["Sino-Tibetan languages"],"iso639-2":"sit","iso639-1":null},"Siouan languages":{"name":"Siouan languages","names":["Siouan languages"],"iso639-2":"sio","iso639-1":null},"Skolt Sami":{"name":"Skolt Sami","names":["Skolt Sami"],"iso639-2":"sms","iso639-1":null},"Slave (Athapascan)":{"name":"Slave (Athapascan)","names":["Slave (Athapascan)"],"iso639-2":"den","iso639-1":null},"Slavic languages":{"name":"Slavic languages","names":["Slavic languages"],"iso639-2":"sla","iso639-1":null},"Slovak":{"name":"Slovak","names":["Slovak"],"iso639-2":"slo/slk","iso639-1":"sk"},"Slovenian":{"name":"Slovenian","names":["Slovenian"],"iso639-2":"slv","iso639-1":"sl"},"Sogdian":{"name":"Sogdian","names":["Sogdian"],"iso639-2":"sog","iso639-1":null},"Somali":{"name":"Somali","names":["Somali"],"iso639-2":"som","iso639-1":"so"},"Songhai languages":{"name":"Songhai languages","names":["Songhai languages"],"iso639-2":"son","iso639-1":null},"Soninke":{"name":"Soninke","names":["Soninke"],"iso639-2":"snk","iso639-1":null},"Sorbian languages":{"name":"Sorbian languages","names":["Sorbian languages"],"iso639-2":"wen","iso639-1":null},"Sotho, Northern":{"name":"Sotho, Northern","names":["Pedi","Sepedi","Northern Sotho"],"iso639-2":"nso","iso639-1":null},"Sotho, Southern":{"name":"Sotho, Southern","names":["Sotho, Southern"],"iso639-2":"sot","iso639-1":"st"},"South American Indian languages":{"name":"South American Indian languages","names":["South American Indian languages"],"iso639-2":"sai","iso639-1":null},"South Ndebele":{"name":"South Ndebele","names":["Ndebele, South","South Ndebele"],"iso639-2":"nbl","iso639-1":"nr"},"Southern Altai":{"name":"Southern Altai","names":["Southern Altai"],"iso639-2":"alt","iso639-1":null},"Southern Sami":{"name":"Southern Sami","names":["Southern Sami"],"iso639-2":"sma","iso639-1":null},"Spanish":{"name":"Spanish","names":["Spanish","Castilian"],"iso639-2":"spa","iso639-1":"es"},"Sranan Tongo":{"name":"Sranan Tongo","names":["Sranan Tongo"],"iso639-2":"srn","iso639-1":null},"Standard Moroccan Tamazight":{"name":"Standard Moroccan Tamazight","names":["Standard Moroccan Tamazight"],"iso639-2":"zgh","iso639-1":null},"Sukuma":{"name":"Sukuma","names":["Sukuma"],"iso639-2":"suk","iso639-1":null},"Sumerian":{"name":"Sumerian","names":["Sumerian"],"iso639-2":"sux","iso639-1":null},"Sundanese":{"name":"Sundanese","names":["Sundanese"],"iso639-2":"sun","iso639-1":"su"},"Susu":{"name":"Susu","names":["Susu"],"iso639-2":"sus","iso639-1":null},"Swahili":{"name":"Swahili","names":["Swahili"],"iso639-2":"swa","iso639-1":"sw"},"Swati":{"name":"Swati","names":["Swati"],"iso639-2":"ssw","iso639-1":"ss"},"Swedish":{"name":"Swedish","names":["Swedish"],"iso639-2":"swe","iso639-1":"sv"},"Swiss German":{"name":"Swiss German","names":["Swiss German","Alemannic","Alsatian"],"iso639-2":"gsw","iso639-1":null},"Syriac":{"name":"Syriac","names":["Syriac"],"iso639-2":"syr","iso639-1":null},"Tagalog":{"name":"Tagalog","names":["Tagalog"],"iso639-2":"tgl","iso639-1":"tl"},"Tahitian":{"name":"Tahitian","names":["Tahitian"],"iso639-2":"tah","iso639-1":"ty"},"Tai languages":{"name":"Tai languages","names":["Tai languages"],"iso639-2":"tai","iso639-1":null},"Tajik":{"name":"Tajik","names":["Tajik"],"iso639-2":"tgk","iso639-1":"tg"},"Tamashek":{"name":"Tamashek","names":["Tamashek"],"iso639-2":"tmh","iso639-1":null},"Tamil":{"name":"Tamil","names":["Tamil"],"iso639-2":"tam","iso639-1":"ta"},"Tatar":{"name":"Tatar","names":["Tatar"],"iso639-2":"tat","iso639-1":"tt"},"Telugu":{"name":"Telugu","names":["Telugu"],"iso639-2":"tel","iso639-1":"te"},"Tereno":{"name":"Tereno","names":["Tereno"],"iso639-2":"ter","iso639-1":null},"Tetum":{"name":"Tetum","names":["Tetum"],"iso639-2":"tet","iso639-1":null},"Thai":{"name":"Thai","names":["Thai"],"iso639-2":"tha","iso639-1":"th"},"Tibetan":{"name":"Tibetan","names":["Tibetan"],"iso639-2":"tib/bod","iso639-1":"bo"},"Tigre":{"name":"Tigre","names":["Tigre"],"iso639-2":"tig","iso639-1":null},"Tigrinya":{"name":"Tigrinya","names":["Tigrinya"],"iso639-2":"tir","iso639-1":"ti"},"Timne":{"name":"Timne","names":["Timne"],"iso639-2":"tem","iso639-1":null},"Tiv":{"name":"Tiv","names":["Tiv"],"iso639-2":"tiv","iso639-1":null},"tlhIngan-Hol":{"name":"tlhIngan-Hol","names":["Klingon","tlhIngan-Hol"],"iso639-2":"tlh","iso639-1":null},"Tlingit":{"name":"Tlingit","names":["Tlingit"],"iso639-2":"tli","iso639-1":null},"Tok Pisin":{"name":"Tok Pisin","names":["Tok Pisin"],"iso639-2":"tpi","iso639-1":null},"Tokelau":{"name":"Tokelau","names":["Tokelau"],"iso639-2":"tkl","iso639-1":null},"Tonga (Nyasa)":{"name":"Tonga (Nyasa)","names":["Tonga (Nyasa)"],"iso639-2":"tog","iso639-1":null},"Tonga (Tonga Islands)":{"name":"Tonga (Tonga Islands)","names":["Tonga (Tonga Islands)"],"iso639-2":"ton","iso639-1":"to"},"Tsimshian":{"name":"Tsimshian","names":["Tsimshian"],"iso639-2":"tsi","iso639-1":null},"Tsonga":{"name":"Tsonga","names":["Tsonga"],"iso639-2":"tso","iso639-1":"ts"},"Tswana":{"name":"Tswana","names":["Tswana"],"iso639-2":"tsn","iso639-1":"tn"},"Tumbuka":{"name":"Tumbuka","names":["Tumbuka"],"iso639-2":"tum","iso639-1":null},"Tupi languages":{"name":"Tupi languages","names":["Tupi languages"],"iso639-2":"tup","iso639-1":null},"Turkish":{"name":"Turkish","names":["Turkish"],"iso639-2":"tur","iso639-1":"tr"},"Turkish, Ottoman (1500-1928)":{"name":"Turkish, Ottoman (1500-1928)","names":["Turkish, Ottoman (1500-1928)"],"iso639-2":"ota","iso639-1":null},"Turkmen":{"name":"Turkmen","names":["Turkmen"],"iso639-2":"tuk","iso639-1":"tk"},"Tuvalu":{"name":"Tuvalu","names":["Tuvalu"],"iso639-2":"tvl","iso639-1":null},"Tuvinian":{"name":"Tuvinian","names":["Tuvinian"],"iso639-2":"tyv","iso639-1":null},"Twi":{"name":"Twi","names":["Twi"],"iso639-2":"twi","iso639-1":"tw"},"Udmurt":{"name":"Udmurt","names":["Udmurt"],"iso639-2":"udm","iso639-1":null},"Ugaritic":{"name":"Ugaritic","names":["Ugaritic"],"iso639-2":"uga","iso639-1":null},"Uighur":{"name":"Uighur","names":["Uighur","Uyghur"],"iso639-2":"uig","iso639-1":"ug"},"Ukrainian":{"name":"Ukrainian","names":["Ukrainian"],"iso639-2":"ukr","iso639-1":"uk"},"Umbundu":{"name":"Umbundu","names":["Umbundu"],"iso639-2":"umb","iso639-1":null},"Uncoded languages":{"name":"Uncoded languages","names":["Uncoded languages"],"iso639-2":"mis","iso639-1":null},"Undetermined":{"name":"Undetermined","names":["Undetermined"],"iso639-2":"und","iso639-1":null},"Upper Sorbian":{"name":"Upper Sorbian","names":["Upper Sorbian"],"iso639-2":"hsb","iso639-1":null},"Urdu":{"name":"Urdu","names":["Urdu"],"iso639-2":"urd","iso639-1":"ur"},"Uyghur":{"name":"Uyghur","names":["Uighur","Uyghur"],"iso639-2":"uig","iso639-1":"ug"},"Uzbek":{"name":"Uzbek","names":["Uzbek"],"iso639-2":"uzb","iso639-1":"uz"},"Vai":{"name":"Vai","names":["Vai"],"iso639-2":"vai","iso639-1":null},"Valencian":{"name":"Valencian","names":["Catalan","Valencian"],"iso639-2":"cat","iso639-1":"ca"},"Venda":{"name":"Venda","names":["Venda"],"iso639-2":"ven","iso639-1":"ve"},"Vietnamese":{"name":"Vietnamese","names":["Vietnamese"],"iso639-2":"vie","iso639-1":"vi"},"Volapük":{"name":"Volapük","names":["Volapük"],"iso639-2":"vol","iso639-1":"vo"},"Votic":{"name":"Votic","names":["Votic"],"iso639-2":"vot","iso639-1":null},"Wakashan languages":{"name":"Wakashan languages","names":["Wakashan languages"],"iso639-2":"wak","iso639-1":null},"Walloon":{"name":"Walloon","names":["Walloon"],"iso639-2":"wln","iso639-1":"wa"},"Waray":{"name":"Waray","names":["Waray"],"iso639-2":"war","iso639-1":null},"Washo":{"name":"Washo","names":["Washo"],"iso639-2":"was","iso639-1":null},"Welsh":{"name":"Welsh","names":["Welsh"],"iso639-2":"wel/cym","iso639-1":"cy"},"Western Frisian":{"name":"Western Frisian","names":["Western Frisian"],"iso639-2":"fry","iso639-1":"fy"},"Western Pahari languages":{"name":"Western Pahari languages","names":["Himachali languages","Western Pahari languages"],"iso639-2":"him","iso639-1":null},"Wolaitta":{"name":"Wolaitta","names":["Wolaitta","Wolaytta"],"iso639-2":"wal","iso639-1":null},"Wolaytta":{"name":"Wolaytta","names":["Wolaitta","Wolaytta"],"iso639-2":"wal","iso639-1":null},"Wolof":{"name":"Wolof","names":["Wolof"],"iso639-2":"wol","iso639-1":"wo"},"Xhosa":{"name":"Xhosa","names":["Xhosa"],"iso639-2":"xho","iso639-1":"xh"},"Yakut":{"name":"Yakut","names":["Yakut"],"iso639-2":"sah","iso639-1":null},"Yao":{"name":"Yao","names":["Yao"],"iso639-2":"yao","iso639-1":null},"Yapese":{"name":"Yapese","names":["Yapese"],"iso639-2":"yap","iso639-1":null},"Yiddish":{"name":"Yiddish","names":["Yiddish"],"iso639-2":"yid","iso639-1":"yi"},"Yoruba":{"name":"Yoruba","names":["Yoruba"],"iso639-2":"yor","iso639-1":"yo"},"Yupik languages":{"name":"Yupik languages","names":["Yupik languages"],"iso639-2":"ypk","iso639-1":null},"Zande languages":{"name":"Zande languages","names":["Zande languages"],"iso639-2":"znd","iso639-1":null},"Zapotec":{"name":"Zapotec","names":["Zapotec"],"iso639-2":"zap","iso639-1":null},"Zaza":{"name":"Zaza","names":["Zaza","Dimili","Dimli","Kirdki","Kirmanjki","Zazaki"],"iso639-2":"zza","iso639-1":null},"Zazaki":{"name":"Zazaki","names":["Zaza","Dimili","Dimli","Kirdki","Kirmanjki","Zazaki"],"iso639-2":"zza","iso639-1":null},"Zenaga":{"name":"Zenaga","names":["Zenaga"],"iso639-2":"zen","iso639-1":null},"Zhuang":{"name":"Zhuang","names":["Zhuang","Chuang"],"iso639-2":"zha","iso639-1":"za"},"Zulu":{"name":"Zulu","names":["Zulu"],"iso639-2":"zul","iso639-1":"zu"},"Zuni":{"name":"Zuni","names":["Zuni"],"iso639-2":"zun","iso639-1":null}}

/***/ }),

/***/ "q1+f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "ye6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_render__ = __webpack_require__("CAXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_compile__ = __webpack_require__("yk5s");
/* unused harmony reexport compile */



/* harmony default export */ __webpack_exports__["a"] = ({ render: __WEBPACK_IMPORTED_MODULE_0__lib_render__["a" /* default */] });



/***/ }),

/***/ "yk5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__render__ = __webpack_require__("CAXL");


/**
 * @callback Compiler
 *
 * @param {Object} [view={}] - An optional object containing values for
 *        every variable names that is used in the template. If it's omitted,
 *        it'll be assumed an empty object.
 * @returns {string} - Template where its variable names replaced with
 *        corresponding values. If a value is not found or is invalid, it will
 *        be assumed empty string ''. If the value is an object itself, it'll
 *        be stringified by JSON.
 *        In case of a JSON stringify error the result will look like "{...}".
 */

/**
 * This function makes repeated calls shorter by returning a compiler function
 * for a particular template that accepts view and returnes the rendered string.
 *
 * It doesn't make the code faster since the compiler still uses render
 * internally.
 *
 * @param {string} template - same as the template parameter to .render()
 * @param {GeneralValueFn} [resolver] - same as the parameter to .render()
 * @returns {Compiler} - a function that accepts a view object and returns a
 *        rendered template string template
 */
function compile(template, resolver) {
  // Create and return a function that will always apply this template
  // and resolver under the hood
  return function compiler(view) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__render__["a" /* default */])(template, view, resolver);
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (compile);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ece3c4eedb3a42f667d5.js